/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any; }
  /** An ISO 8601-encoded duration */
  ISO8601Duration: { input: any; output: any; }
  /** Represents untyped JSON */
  JSON: { input: any; output: any; }
  /** An integer range represented as a two-element array [min, max]. A one-element array [min] is open-ended. */
  Range: { input: any; output: any; }
  join__DirectiveArguments: { input: any; output: any; }
  join__FieldSet: { input: any; output: any; }
  join__FieldValue: { input: any; output: any; }
  link__Import: { input: any; output: any; }
  requiresScopes__Scope: { input: any; output: any; }
};

/** Autogenerated input type of AcceptCompanyInvitation */
export type AcceptCompanyInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The code from createCompanyInvitation. An unknown, spent, revoked or expired one fails identically. */
  code: Scalars['String']['input'];
};

/** Whether a token subject may act for a company, as Hermes sees it right now. */
export type ActingCheck =
  /**
   * The company and the subject both exist, but the person is not a member of it,
   * or the application belongs to another company.
   */
  | 'NOT_A_MEMBER'
  /** The subject may act for the company: a member of it, or an application it owns. */
  | 'OK'
  /** No company with this id. */
  | 'UNKNOWN_COMPANY'
  /** Hermes knows no person or application behind this subject. */
  | 'UNKNOWN_SUBJECT';

/** A national administrative code attached to a division, such as a French INSEE region or département code. */
export type AdministrativeCode = Node & {
  __typename?: 'AdministrativeCode';
  id: Scalars['ID']['output'];
  /**
   * Global id of the division that carries this code natively. Equals the queried
   * location's own id for its own codes, or an ancestor's id for an inherited one
   * — e.g. Lyon reports Rhône's département code with Rhône's id here.
   */
  locationId: Scalars['ID']['output'];
  /** Coding scheme the value belongs to. */
  scheme: AdministrativeCodeScheme;
  /** The code itself, as the scheme's authority writes it — e.g. "11", "2A", "971". Not zero-stripped. */
  value: Scalars['String']['output'];
};

/** National coding scheme an administrative code belongs to. */
export type AdministrativeCodeScheme =
  /**
   * French INSEE département code, e.g. "69" for Rhône, "2A" for Corse-du-Sud,
   * "971" for Guadeloupe. Carried by COUNTY divisions.
   */
  | 'INSEE_DEPARTMENT'
  /** French INSEE region code, e.g. "11" for Île-de-France. Carried by REGION divisions. */
  | 'INSEE_REGION';

/** Federation reference to a Application owned by another subgraph. */
export type Application = Node & {
  __typename?: 'Application';
  /**
   * The owning company. Every member of it can manage this application, and
   * `Query.applications` spans them all, so this is what attributes a row to one.
   */
  company: Company;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Who registered it. Confers no ownership: any member of the owning company can manage it. */
  createdBy: User;
  /**
   * Several may be active — chiefly to rotate without downtime. Throwaway CLI
   * session credentials are excluded unless asked for.
   */
  credentials: ApplicationCredentialConnection;
  description?: Maybe<Scalars['String']['output']>;
  /** GlobalID-encoded Application id. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**
   * Scopes every token minted from this application's credentials carries. The
   * same for every application and not a setting: reading Atlas contacts and
   * organizations, metered on the application's company.
   */
  scopes: Array<Scalars['String']['output']>;
};


/** Federation reference to a Application owned by another subgraph. */
export type ApplicationCredentialsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeSessions?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Application. */
export type ApplicationConnection = {
  __typename?: 'ApplicationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ApplicationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Application>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/** A client_id/client_secret pair. The secret is shown exactly once, at creation. */
export type ApplicationCredential = Node & {
  __typename?: 'ApplicationCredential';
  clientId: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Who registered it. Recorded, but absent from minted tokens: the subject is the application. */
  createdBy: User;
  /** Null for a credential that lives until revoked. */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** When this credential last obtained a token. Null if never used. */
  lastUsedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Human label, e.g. `rotation-2026-08`. Required: an unnamed credential among three is unmanageable. */
  name: Scalars['String']['output'];
  revokedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** True for a throwaway credential minted for one CLI session and revoked immediately. */
  session: Scalars['Boolean']['output'];
};

/** The connection type for ApplicationCredential. */
export type ApplicationCredentialConnection = {
  __typename?: 'ApplicationCredentialConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ApplicationCredentialEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ApplicationCredential>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ApplicationCredentialEdge = {
  __typename?: 'ApplicationCredentialEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ApplicationCredential>;
};

/** An edge in a connection. */
export type ApplicationEdge = {
  __typename?: 'ApplicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Application>;
};

/** Autogenerated input type of AuthenticateChannelAccount */
export type AuthenticateChannelAccountInput = {
  /**
   * Hostname the provider's sign-in page is served from instead of the provider's
   * own, e.g. `ln-auth.consumer.example`. Must be verified with the provider
   * beforehand; refused as `authentication_domain.invalid` when it is not a bare
   * hostname. Hosted-link providers only.
   */
  authenticationDomain?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The owner's credentials, for a provider that authenticates with them. Verified
   * at the channel before this returns; refused as `credentials.rejected` when the
   * channel does not accept them and as `credentials.unsupported` on a hosted-link provider.
   */
  credentials?: InputMaybe<ChannelAccountCredentialsInput>;
  /** Global id of the channel account to authenticate. */
  id: Scalars['ID']['input'];
  /**
   * Provider to authenticate on. Defaults to the account's running connection's
   * provider. Naming another one opens a new connection beside it; once that
   * connection is confirmed the account works through it and the previous one is
   * released — same id, same conversations. Refused as `provider.unknown` when it
   * does not serve the channel.
   */
  provider?: InputMaybe<Provider>;
  /**
   * HTTPS address the owner's browser is sent back to after the provider's page.
   * Required by hosted-link providers (`return_url.blank` otherwise).
   * Display-only: its query string must never be trusted as the result.
   */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AuthenticateChannelAccount. */
export type AuthenticateChannelAccountPayload = Node & {
  __typename?: 'AuthenticateChannelAccountPayload';
  /** The step the account owner has to complete, or its acceptance. */
  authentication: ChannelAccountAuthentication;
  /** The account the attempt was started on, unchanged. */
  channelAccount: ChannelAccount;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** A Stripe Checkout session opened for a company, in embedded mode. */
export type BillingCheckoutSession = {
  __typename?: 'BillingCheckoutSession';
  /**
   * Hand to Stripe.js' `<EmbeddedCheckoutProvider>` to mount the payment form in
   * place. Single-use and short-lived; request a new session rather than storing it.
   */
  clientSecret: Scalars['String']['output'];
};

/** A grant of credits to a customer — recurring (plan / extras) or one-off (trial). */
export type BillingCredit = Node & {
  __typename?: 'BillingCredit';
  /** Granted credits. Always greater than 0. */
  amount: Scalars['Float']['output'];
  /** When this credit was granted. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Free-form label describing the grant origin. */
  description?: Maybe<Scalars['String']['output']>;
  /** When the unconsumed portion of this grant expires. */
  expiresAt: Scalars['ISO8601DateTime']['output'];
  /** Credit UUID. */
  id: Scalars['ID']['output'];
  /** One of: granted, trial. */
  kind: Scalars['String']['output'];
  /** Credits still available on this grant: amount minus any debits drawn from it. */
  remaining: Scalars['Float']['output'];
  /** Per-credit price (EUR) when this grant was created, used for revenue recognition on debits. */
  unitPriceEur: Scalars['Float']['output'];
};

/** The connection type for BillingCredit. */
export type BillingCreditConnection = {
  __typename?: 'BillingCreditConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BillingCreditEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BillingCredit>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /**
   * Sum of granted `amount` over every credit in the filtered set — the total
   * credits originally granted. Use as the denominator of a usage gauge when
   * filtered by `expired: false`.
   */
  totalAmount: Scalars['Float']['output'];
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
  /**
   * Sum of `remaining` (amount − debits drawn) over every credit in the filtered
   * set — credits still available to consume. `total_amount − total_remaining` is
   * the consumption so far.
   */
  totalRemaining: Scalars['Float']['output'];
};

/** An edge in a connection. */
export type BillingCreditEdge = {
  __typename?: 'BillingCreditEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BillingCredit>;
};

/** Federation reference to a BillingCustomer owned by another subgraph. */
export type BillingCustomer = Node & {
  __typename?: 'BillingCustomer';
  /**
   * The customer's active subscription (one of trialing, active, past_due, unpaid,
   * paused, incomplete), or null. A customer holds at most one at a time; the
   * newest is returned if several exist.
   */
  activeSubscription?: Maybe<BillingSubscription>;
  /** ISO 3166-1 alpha-2 country code, captured from Stripe Checkout / Customer Portal. */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Derived credit balance: SUM(credits.amount) - SUM(debits.amount). Always 0 for a newly-created customer. */
  creditBalance: Scalars['Float']['output'];
  /** Paginated credits granted to this customer, newest first. Optionally filter by expiry status via the `expired` argument. */
  credits: BillingCreditConnection;
  /**
   * The customer's settlement currency, lowercase ISO — the single source of truth
   * for price display and checkout pinning. Locked at the first successful invoice
   * payment; null before that (the product or Stripe Adaptive Pricing pick per
   * request). Manually overridable for specific customers.
   */
  currency?: Maybe<Scalars['String']['output']>;
  /** Snapshot of the customer's default Stripe payment method (brand + last4 + expiry). Null until the customer adds a card. */
  defaultPaymentMethod?: Maybe<BillingPaymentMethod>;
  /** Customer's billing email, mirrored from Stripe. May lag the user's email until the next customer.updated webhook. */
  email?: Maybe<Scalars['String']['output']>;
  /** GlobalID-encoded BillingCustomer id. */
  id: Scalars['ID']['output'];
  /** Paginated invoices and credit notes for this customer, newest first. */
  invoices: BillingInvoiceConnection;
  /**
   * Net revenue the customer has paid, ex-VAT, in EUR cents: all invoice payments
   * minus all refunded credit notes, each stripped of its VAT share and converted
   * at its document's frozen FX rate. Credits applied to the customer balance or
   * booked out of band are not deductions (no money moved). Recomputed live, so
   * later corrections are reflected.
   */
  lifetimePaidCents: Scalars['Int']['output'];
  /**
   * Product this customer belongs to. Decides the Stripe account and plan catalog;
   * credits and subscriptions never cross products.
   */
  product: BillingProduct;
  /** Customer's VAT number for EU customers, captured by Stripe at Checkout. */
  vatId?: Maybe<Scalars['String']['output']>;
  /** Stripe VAT verification status. One of: pending, verified, unverified, unavailable. */
  vatIdStatus?: Maybe<Scalars['String']['output']>;
};


/** Federation reference to a BillingCustomer owned by another subgraph. */
export type BillingCustomerCreditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  expired?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Federation reference to a BillingCustomer owned by another subgraph. */
export type BillingCustomerInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A positive draw against a customer's credits — consumption, expiration, or withdrawal. */
export type BillingDebit = Node & {
  __typename?: 'BillingDebit';
  /** Credits drawn by this debit. Always greater than 0. */
  amount: Scalars['Float']['output'];
  /** UUID of the consumed record. Set only when source is consumption. */
  consumableId?: Maybe<Scalars['ID']['output']>;
  /** AR class name of the consumed record (e.g. "Lead", "Message"). Set only when source is consumption. */
  consumableType?: Maybe<Scalars['String']['output']>;
  /** When this debit row was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Free-form note — the consumer's label, or the refund charge id on withdrawals. */
  description?: Maybe<Scalars['String']['output']>;
  /** Debit UUID. */
  id: Scalars['ID']['output'];
  /** When this entry was recorded for revenue. */
  revenueRecognizedAt: Scalars['ISO8601DateTime']['output'];
  /** One of: consumption, expiration, withdrawal. */
  source: Scalars['String']['output'];
};

/** A mirrored Stripe invoice (or credit note). One row per Stripe object. */
export type BillingInvoice = Node & {
  __typename?: 'BillingInvoice';
  /** Amount paid in the transaction currency. */
  amountPaid: Scalars['Float']['output'];
  /** Outstanding balance in the transaction currency. Zero on a fully-paid invoice. */
  amountRemaining: Scalars['Float']['output'];
  /** True for credit-note rows (refund); false for regular invoices. */
  creditNote: Scalars['Boolean']['output'];
  /** Transaction currency — ISO 4217 lowercase ("eur", "usd", ...). */
  currency: Scalars['String']['output'];
  /** Stripe-hosted invoice page. May be null on credit-note rows. */
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** When the invoice was finalized in Stripe. */
  issuedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Human-readable Stripe invoice number ("INV-001"). Null until finalized. */
  number?: Maybe<Scalars['String']['output']>;
  /** When payment was captured. Null on unpaid or credit-note rows. */
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** On credit-note rows, the parent invoice being refunded. Null on regular invoices. */
  parentInvoice?: Maybe<BillingInvoice>;
  /**
   * URL to the billing service's PDF passthrough endpoint. The endpoint fetches a
   * fresh signed URL from Stripe and 302s to it. Null until the invoice is finalized.
   */
  pdfUrl?: Maybe<Scalars['String']['output']>;
  /** End of the billing period this invoice covers (subscriptions). */
  periodEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Start of the billing period this invoice covers (subscriptions). */
  periodStart?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Stripe's verbatim invoice status. One of: draft, open, paid, void, uncollectible — or for credit notes: issued, void. */
  status: Scalars['String']['output'];
  /** Pre-tax subtotal in the transaction currency. */
  subtotal: Scalars['Float']['output'];
  /** Tax applied in the transaction currency. */
  tax: Scalars['Float']['output'];
  /** Final total in the transaction currency. */
  total: Scalars['Float']['output'];
};

/** The connection type for BillingInvoice. */
export type BillingInvoiceConnection = {
  __typename?: 'BillingInvoiceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BillingInvoiceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BillingInvoice>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BillingInvoiceEdge = {
  __typename?: 'BillingInvoiceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BillingInvoice>;
};

/** Denormalized snapshot of a customer's default payment method, mirrored from Stripe. */
export type BillingPaymentMethod = {
  __typename?: 'BillingPaymentMethod';
  /** Card brand: visa, mastercard, amex, etc. */
  brand?: Maybe<Scalars['String']['output']>;
  /** Card expiration month (1-12), as reported by Stripe. */
  expMonth?: Maybe<Scalars['Int']['output']>;
  /** Card expiration year (4-digit), as reported by Stripe. */
  expYear?: Maybe<Scalars['Int']['output']>;
  /** Last 4 digits of the card number, as reported by Stripe. */
  last4?: Maybe<Scalars['String']['output']>;
};

/** Subscription billing periodicity. */
export type BillingPeriodicity =
  /** Billed annually (12% off vs monthly). */
  | 'ANNUAL'
  /** Billed monthly. */
  | 'MONTHLY';

/** A single (plan, periodicity) row from a product's static plan catalog. */
export type BillingPlanCatalogEntry = Node & {
  __typename?: 'BillingPlanCatalogEntry';
  /** Exact total fee per period in EUR (the annual entries carry the full yearly amount). */
  feeEur: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** Credits granted on each paid invoice for this plan. Annual entries grant the full yearly pool at once. */
  includedCredits: Scalars['Int']['output'];
  /** Plan tier. */
  name: BillingPlanName;
  /** Whether the plan offers a self-serve trial. */
  offersTrial: Scalars['Boolean']['output'];
  /** Billing periodicity. */
  periodicity: BillingPeriodicity;
  /** Credits granted at trial start, expiring at trial end. Zero when the plan offers no trial. */
  trialCredits: Scalars['Int']['output'];
  /** Trial length in days. Zero when the plan offers no trial. */
  trialDays: Scalars['Int']['output'];
};

/**
 * Subscription plan tier of the Max catalog. Tiers differ by monthly credit
 * allowance and price; annual periodicity grants the yearly pool at once.
 */
export type BillingPlanName =
  /** Grow — developer catalog. */
  | 'GROW'
  /** Pro 500 — 500 credits/month. */
  | 'PRO_500'
  /** Pro 1,500 — 1,500 credits/month. */
  | 'PRO_1500'
  /** Pro 3,000 — 3,000 credits/month. */
  | 'PRO_3000'
  /** Pro 6,000 — 6,000 credits/month. */
  | 'PRO_6000'
  /** Pro 10,000 — 10,000 credits/month. */
  | 'PRO_10000'
  /** Scale — developer catalog. */
  | 'SCALE'
  /** Start — developer catalog. */
  | 'START'
  /** Starter — 100 credits/month. */
  | 'STARTER';

/** A Stripe customer portal session opened for a company. */
export type BillingPortalSession = {
  __typename?: 'BillingPortalSession';
  /**
   * Hosted Stripe page for replacing the card and reading invoice history.
   * Single-use and short-lived; redirect to it immediately.
   */
  url: Scalars['String']['output'];
};

/**
 * Sortlist product a billing customer belongs to. Each product runs on its own
 * Stripe account with its own plan catalog; credits, subscriptions, and invoices
 * never cross products.
 */
export type BillingProduct =
  /** The developer portal's API access, on its own dedicated Stripe account. */
  | 'DEVELOPER'
  /** The original shared Stripe account — the old Max app's billing and the marketplace's Recurly payment-gateway traffic. */
  | 'LEGACY'
  /** The new Max product (rebuilt app replacing the old Max, keeping the name), on its own dedicated Stripe account. */
  | 'MAX';

/**
 * A mirrored Stripe subscription. Plan tier is identified by the subscription's
 * plan-item Price (`PlanCatalog.find_by_stripe_price_id`).
 */
export type BillingSubscription = Node & {
  __typename?: 'BillingSubscription';
  /** Whether the subscription will end at `currentPeriodEnd` (Stripe-side cancel). */
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  /** When the subscription was canceled, or null if still active. */
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Credits the customer is entitled to per period (from `PlanCatalog#included_credits`). */
  creditsPerPeriod: Scalars['Float']['output'];
  /** End of the current billing period. */
  currentPeriodEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Start of the current billing period. */
  currentPeriodStart?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Stripe billing interval string: day / week / month / year. */
  interval: Scalars['String']['output'];
  /** Interval multiplier (1 = every interval). */
  intervalCount: Scalars['Int']['output'];
  /**
   * Realized monthly rate in EUR cents, net of coupon discounts and inclusive VAT
   * — derived from the latest posted renewal invoice, spread over the months its
   * period covers and converted from the invoice's charge currency at its frozen
   * FX rate, so values are safe to aggregate across currencies. Falls back to the
   * catalog's gross monthly fee for trials and never-invoiced subscriptions.
   * Parity source for legacy product MRR columns.
   */
  netMonthlyFeeCents: Scalars['Int']['output'];
  /**
   * Scheduled plan change applying at the next bill date (a deferred downgrade or
   * lateral move, backed by a Stripe Subscription Schedule). Null when none is
   * pending. Cancel for free via cancelBillingSubscriptionChange.
   */
  pendingChange?: Maybe<BillingSubscriptionPendingChange>;
  /** Derived from the Stripe interval. Null on intervals we don't model. */
  periodicity?: Maybe<BillingPeriodicity>;
  /** Plan tier looked up from the stored stripe_price_id. Null when the Price doesn't match a known plan. */
  plan?: Maybe<BillingPlanName>;
  /** When the subscription was first created in Stripe. */
  startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Stripe verbatim status (active, trialing, past_due, canceled, ...). */
  status: Scalars['String']['output'];
};

/**
 * A scheduled plan change waiting to apply at the subscription's next bill date,
 * backed by a Stripe Subscription Schedule. The current plan — credits and limits
 * — stays fully in force until then.
 */
export type BillingSubscriptionPendingChange = Node & {
  __typename?: 'BillingSubscriptionPendingChange';
  /** When the change applies: the end of the current billing period. */
  effectiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Periodicity the subscription switches to. */
  periodicity: BillingPeriodicity;
  /** Plan tier the subscription switches to. */
  plan: BillingPlanName;
};

/** Autogenerated input type of CancelBillingCustomerSubscriptions */
export type CancelBillingCustomerSubscriptionsInput = {
  /** Billing customer UUID whose active subscriptions are canceled. The owning service stores this on its company record. */
  billingCustomerId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CancelBillingCustomerSubscriptions. */
export type CancelBillingCustomerSubscriptionsPayload = Node & {
  __typename?: 'CancelBillingCustomerSubscriptionsPayload';
  /** Number of subscriptions canceled by this call. Zero when the customer had no active subscription. */
  canceledCount: Scalars['Int']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of CancelBillingSubscriptionChange */
export type CancelBillingSubscriptionChangeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Target subscription global id. */
  subscriptionId: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelBillingSubscriptionChange. */
export type CancelBillingSubscriptionChangePayload = Node & {
  __typename?: 'CancelBillingSubscriptionChangePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The subscription, with pendingChange cleared. */
  subscription: BillingSubscription;
};

/** Autogenerated input type of CancelCompanySubscription */
export type CancelCompanySubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The company whose subscription is ending. Every member may end it — there are no roles. */
  companyId: Scalars['ID']['input'];
};

/** A single entry in a contact's career history: a work-experience role, degree, certification, award, or publication. */
export type CareerEntry = Node & {
  __typename?: 'CareerEntry';
  /** Free-text description of the entry as provided by the source. */
  description?: Maybe<Scalars['String']['output']>;
  /** End date of the entry (upper bound of its period), or null when the entry is ongoing or the source gave no end date. */
  endedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  /** Which kind of career entry this is. */
  kind: CareerEntryKind;
  /**
   * The organization this entry links to (e.g. the employer or school), or null
   * when it could not be resolved to a known record.
   */
  organization?: Maybe<Organization>;
  /** Start date of the entry (lower bound of its period), or null when the source gave no start date. */
  startedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The entry's headline — role title, degree, certification name, award title, or publication title depending on kind. */
  title?: Maybe<Scalars['String']['output']>;
  /** Source URL for the entry (e.g. the credential link), or null. */
  url?: Maybe<Scalars['String']['output']>;
};

/** The connection type for CareerEntry. */
export type CareerEntryConnection = {
  __typename?: 'CareerEntryConnection';
  /**
   * Estimated total number of items across all pages. It comes from the query
   * planner rather than a count, so it costs planning time instead of a scan and
   * cannot exceed the statement timeout. It is approximate at every magnitude,
   * including small ones, and it moves when the table's statistics are refreshed.
   * Accuracy depends on the filter: within a few percent on plain column and
   * array-overlap filters, and as much as 30% out on a range filter such as
   * `companySize`. It is not meaningful for the embedding filters `jobTitle` and
   * `industry` — no statistics exist for a vector-distance predicate, so the
   * estimate ignores the distance threshold entirely and approximates only what
   * the other filters admit; it has been measured reporting 241371 for a filter
   * whose true result was empty. Never render it as an exact figure, and use
   * `totalCount` when the figure has to be exact.
   */
  approximateTotalCount: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CareerEntryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CareerEntry>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages, exact unless `upTo` is given. */
  totalCount: Scalars['Int']['output'];
};


/** The connection type for CareerEntry. */
export type CareerEntryConnectionTotalCountArgs = {
  upTo?: InputMaybe<Scalars['Int']['input']>;
};

/** An edge in a connection. */
export type CareerEntryEdge = Node & {
  __typename?: 'CareerEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CareerEntry>;
};

/** The kind of entry in a contact's career history. */
export type CareerEntryKind =
  /** An award or honor received. */
  | 'AWARD'
  /** A professional certification. */
  | 'CERTIFICATION'
  /** A degree or course of study. */
  | 'EDUCATION'
  /** A past or current work-experience role. */
  | 'EXPERIENCE'
  /** An authored publication. */
  | 'PUBLICATION';

/** Filter on career-entry kind with schema-validated enum values. */
export type CareerEntryKindFilterInput = {
  /** Exact match. */
  eq?: InputMaybe<CareerEntryKind>;
  /** Match any of these values. */
  in?: InputMaybe<Array<CareerEntryKind>>;
  /** Exclude exact match. */
  notEq?: InputMaybe<CareerEntryKind>;
  /** Exclude any of these values. */
  notIn?: InputMaybe<Array<CareerEntryKind>>;
};

/** Autogenerated input type of ChangeBillingSubscription */
export type ChangeBillingSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Target periodicity. Omit to keep the current one. */
  periodicity?: InputMaybe<BillingPeriodicity>;
  /** Target plan tier. Omit to keep the current one. */
  plan?: InputMaybe<BillingPlanName>;
  /** Target subscription global id. */
  subscriptionId: Scalars['ID']['input'];
};

/** Autogenerated return type of ChangeBillingSubscription. */
export type ChangeBillingSubscriptionPayload = Node & {
  __typename?: 'ChangeBillingSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The subscription with its refreshed plan mirror. */
  subscription: BillingSubscription;
};

/** Autogenerated input type of ChangeCompanySubscription */
export type ChangeCompanySubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The company whose subscription is changing. Every member may change it — there are no roles. */
  companyId: Scalars['ID']['input'];
  /** MONTHLY or ANNUAL. Unset keeps the current one. */
  periodicity?: InputMaybe<Scalars['String']['input']>;
  /** Tier name from `billingPlanCatalog(product:)`. Unset keeps the current one, so periodicity can change alone. */
  plan?: InputMaybe<Scalars['String']['input']>;
};

/** Channel a channel account operates on. One of: linkedin. */
export type Channel =
  /** The linkedin channel. */
  | 'LINKEDIN';

/**
 * An account the gateway operates on a channel, for one consumer: who the account
 * is, and the connections through which it has been reached.
 */
export type ChannelAccount = Node & {
  __typename?: 'ChannelAccount';
  /** Channel the account operates on. */
  channel: Channel;
  /** How the account has been reached over time, newest first: at most one `RUNNING`, the rest drafts, disconnected or retired. */
  connections: ProviderConnectionConnection;
  /** When the account was registered. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /**
   * Who the account is, typed by channel. Populated once a connection has
   * confirmed the identity; null while it is a draft, or when the consumer only
   * claimed an identity that no connection has confirmed yet.
   */
  identity?: Maybe<ChannelAccountIdentity>;
  /**
   * Subject of the token that registered the account and owns it: a person's
   * `auth0|…` or an application's `application:<uuid>`, the same value Hermes
   * knows the caller by.
   */
  ownerSub: Scalars['String']['output'];
  /**
   * Until when the provider asked the gateway to hold the account's actions, after
   * a `429`; the pending ones are rebooked after it. Null when the account is not paused.
   */
  pausedUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Provider of the running connection, or of the latest one while none runs; the
   * channel's default before any connection exists.
   */
  provider: Provider;
  /** Lifecycle state of the account. */
  status: ChannelAccountStatus;
  /** Address the account's events are delivered to. */
  webhookUrl: Scalars['String']['output'];
};


/**
 * An account the gateway operates on a channel, for one consumer: who the account
 * is, and the connections through which it has been reached.
 */
export type ChannelAccountConnectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** How the account owner authenticates at the provider. One of: HostedAuthenticationLink, CredentialsAccepted. */
export type ChannelAccountAuthentication = CredentialsAccepted | HostedAuthenticationLink;

/** The connection type for ChannelAccount. */
export type ChannelAccountConnection = {
  __typename?: 'ChannelAccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ChannelAccountEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ChannelAccount>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/**
 * The credentials the account owner authenticates with: exactly one of the
 * variants, typed by channel and accepted only by a provider that authenticates this way.
 */
export type ChannelAccountCredentialsInput = {
  /** A LinkedIn session cookie. */
  linkedinCookie?: InputMaybe<LinkedinCookieCredentialsInput>;
};

/** An edge in a connection. */
export type ChannelAccountEdge = {
  __typename?: 'ChannelAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ChannelAccount>;
};

/** Narrows `channelAccounts`. */
export type ChannelAccountFilterInput = {
  /** Keep only the accounts of these channels. */
  channel?: InputMaybe<ChannelFilterInput>;
  /**
   * Keep only the accounts owned by these subjects. Of use to a token carrying
   * `outreach/*:read`, which sees every consumer's accounts.
   */
  ownerSub?: InputMaybe<StringFilterInput>;
  /** Keep only the accounts whose `provider` is one of these: the running connection's, or the latest one's while none runs. */
  provider?: InputMaybe<ProviderFilterInput>;
  /** Keep only the accounts in these states. */
  status?: InputMaybe<ChannelAccountStatusFilterInput>;
};

/** Who a channel account is connected as, typed by channel. One of: LinkedinIdentity. */
export type ChannelAccountIdentity = LinkedinIdentity;

/** Lifecycle state of a channel account. One of: draft, running, disconnected, removed. */
export type ChannelAccountStatus =
  /** The provider session expired or was revoked; a new authentication is needed. */
  | 'DISCONNECTED'
  /** Registered, never authenticated at the provider yet. */
  | 'DRAFT'
  /** Removed for good, by the consumer or at the provider; it no longer resolves by id. */
  | 'REMOVED'
  /** Authenticated and able to perform actions. */
  | 'RUNNING';

/** Filter on an account's lifecycle state (eq/in/notEq/notIn). */
export type ChannelAccountStatusFilterInput = {
  /** Exact match. */
  eq?: InputMaybe<ChannelAccountStatus>;
  /** Match any of these values. */
  in?: InputMaybe<Array<ChannelAccountStatus>>;
  /** Exclude exact match. */
  notEq?: InputMaybe<ChannelAccountStatus>;
  /** Exclude any of these values. */
  notIn?: InputMaybe<Array<ChannelAccountStatus>>;
};

/** One piece of work a consumer asked the gateway to perform on a channel account. */
export type ChannelAction = Node & {
  __typename?: 'ChannelAction';
  /** What the action does. */
  actionType: ChannelActionType;
  /** The account the action runs on. */
  channelAccount: ChannelAccount;
  /** When the action settled, completed or failed. */
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the action was accepted. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Why the action failed: `{ code, status, message }`, the same object `channel_action.failed` carries. Null unless `FAILED`. */
  error?: Maybe<Scalars['JSON']['output']>;
  /**
   * The caller's own id for this action on its account, or the one the gateway
   * derived from the input when none was given. Unique per account, dedupes a
   * repeated call, and is what `channelActionResult` subscribes on; the same word
   * as Atlas's async mutations.
   */
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The action's input, as accepted; attachment contents are replaced by their `size` in bytes. */
  input: Scalars['JSON']['output'];
  /**
   * What the provider answered, typed by action — for `LINKEDIN_SEND_MESSAGE`, `{
   * chat_id, message_id }`, LinkedIn's own ids. Null unless `COMPLETED`.
   */
  result?: Maybe<Scalars['JSON']['output']>;
  /**
   * When the action is due to run, the slot the gateway booked for it within the
   * account's pace; moves later when the provider pauses the account. Null once it
   * has run. A caller decides on it whether to wait on `channelActionResult` or to
   * rely on the webhook.
   */
  scheduledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Where the action stands. */
  state: ChannelActionState;
};

/** The connection type for ChannelAction. */
export type ChannelActionConnection = {
  __typename?: 'ChannelActionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ChannelActionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ChannelAction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ChannelActionEdge = {
  __typename?: 'ChannelActionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ChannelAction>;
};

/** Narrows `channelActions`. */
export type ChannelActionFilterInput = {
  /** Keep only the actions of these types. */
  actionType?: InputMaybe<ChannelActionTypeFilterInput>;
  /** Keep only the actions in these states. */
  state?: InputMaybe<ChannelActionStateFilterInput>;
};

/** The action to perform: exactly one of the variants, typed by channel. */
export type ChannelActionInput = {
  /** Withdraw a LinkedIn connection request. */
  linkedinCancelInvitation?: InputMaybe<LinkedinCancelInvitationInput>;
  /** Send a LinkedIn connection request. */
  linkedinInvite?: InputMaybe<LinkedinInviteInput>;
  /** Read a LinkedIn member's profile. */
  linkedinLookupProfile?: InputMaybe<LinkedinLookupProfileInput>;
  /** Send a LinkedIn message. */
  linkedinSendMessage?: InputMaybe<LinkedinSendMessageInput>;
  /** Visit a LinkedIn profile. */
  linkedinVisit?: InputMaybe<LinkedinVisitInput>;
};

/** Autogenerated return type of ChannelActionResult. */
export type ChannelActionResultPayload = {
  __typename?: 'ChannelActionResultPayload';
  /** The settled action, with its `result` or `error`. */
  channelAction: ChannelAction;
};

/** Where an action stands. One of: pending, executing, completed, failed. */
export type ChannelActionState =
  /** Performed; the result is in `channel_action.completed`. */
  | 'COMPLETED'
  /** Being performed. */
  | 'EXECUTING'
  /** Refused or failed; the error is in `channel_action.failed`. */
  | 'FAILED'
  /** Accepted, not performed yet. */
  | 'PENDING';

/** Filter on where an action stands (eq/in/notEq/notIn). */
export type ChannelActionStateFilterInput = {
  /** Exact match. */
  eq?: InputMaybe<ChannelActionState>;
  /** Match any of these values. */
  in?: InputMaybe<Array<ChannelActionState>>;
  /** Exclude exact match. */
  notEq?: InputMaybe<ChannelActionState>;
  /** Exclude any of these values. */
  notIn?: InputMaybe<Array<ChannelActionState>>;
};

/** What an action does, typed by channel. */
export type ChannelActionType =
  /** Withdraws a LinkedIn connection request. */
  | 'LINKEDIN_CANCEL_INVITATION'
  /** Sends a LinkedIn connection request to a member. */
  | 'LINKEDIN_INVITE'
  /** Reads a LinkedIn member's profile as the account. */
  | 'LINKEDIN_LOOKUP_PROFILE'
  /** Sends a LinkedIn message to a member. */
  | 'LINKEDIN_SEND_MESSAGE'
  /** Visits a LinkedIn profile, notifying the member when they allow it. */
  | 'LINKEDIN_VISIT';

/** Filter on what an action does (eq/in/notEq/notIn). */
export type ChannelActionTypeFilterInput = {
  /** Exact match. */
  eq?: InputMaybe<ChannelActionType>;
  /** Match any of these values. */
  in?: InputMaybe<Array<ChannelActionType>>;
  /** Exclude exact match. */
  notEq?: InputMaybe<ChannelActionType>;
  /** Exclude any of these values. */
  notIn?: InputMaybe<Array<ChannelActionType>>;
};

/** Filter on channel (eq/in/notEq/notIn). */
export type ChannelFilterInput = {
  /** Exact match. */
  eq?: InputMaybe<Channel>;
  /** Match any of these values. */
  in?: InputMaybe<Array<Channel>>;
  /** Exclude exact match. */
  notEq?: InputMaybe<Channel>;
  /** Exclude any of these values. */
  notIn?: InputMaybe<Array<Channel>>;
};

/** Who the account is for, typed by channel: exactly one variant, which must match the account's channel. */
export type ChannelIdentityInput = {
  /** A LinkedIn member. */
  linkedin?: InputMaybe<LinkedinIdentityInput>;
};

/** Federation reference to a Company owned by another subgraph. */
export type Company = Node & {
  __typename?: 'Company';
  /** Applications owned by this company. */
  applications: ApplicationConnection;
  /**
   * The company's customer in the billing subgraph, or null until it first touches
   * billing. The id itself is deliberately not exposed: reaching the customer only
   * through a company the caller belongs to is what scopes billing reads to their own tenant.
   */
  billingCustomer?: Maybe<BillingCustomer>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** GlobalID-encoded Company id. */
  id: Scalars['ID']['output'];
  /** Offers to join, in every state. */
  invitations: CompanyInvitationConnection;
  /** Every member can manage every application and credential this company owns. */
  members: CompanyMemberConnection;
  /** Display name. Not unique. */
  name: Scalars['String']['output'];
  /**
   * True when this is the calling user's private company. A relationship to the
   * caller rather than a property of the company, so it is resolved against them.
   */
  personal: Scalars['Boolean']['output'];
  /**
   * Readable, unique handle, derived from the name when the company is created and
   * never rewritten afterwards — a URL built from one does not break when the
   * company is renamed. Prefer it to `id` for addressing a company in a path.
   */
  slug: Scalars['String']['output'];
};


/** Federation reference to a Company owned by another subgraph. */
export type CompanyApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Federation reference to a Company owned by another subgraph. */
export type CompanyInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pendingOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Federation reference to a Company owned by another subgraph. */
export type CompanyMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Company. */
export type CompanyConnection = {
  __typename?: 'CompanyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CompanyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Company>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Company>;
};

/** An offer to join a company, redeemed by the invitee. */
export type CompanyInvitation = Node & {
  __typename?: 'CompanyInvitation';
  acceptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Who actually redeemed it. May not be who `email` names, since this service
   * cannot verify an email it only caches — the mismatch is recorded, not refused.
   */
  acceptedBy?: Maybe<User>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Who the inviter meant it for. A label: membership is granted to whoever
   * authenticates while accepting, never to this address.
   */
  email: Scalars['String']['output'];
  expiresAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  invitedBy: User;
  revokedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for CompanyInvitation. */
export type CompanyInvitationConnection = {
  __typename?: 'CompanyInvitationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CompanyInvitationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CompanyInvitation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CompanyInvitationEdge = {
  __typename?: 'CompanyInvitationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CompanyInvitation>;
};

/** An invitation as its holder sees it, before accepting. */
export type CompanyInvitationPreview = {
  __typename?: 'CompanyInvitationPreview';
  /** Names are not unique, so read it alongside `invitedBy` rather than alone. */
  companyName: Scalars['String']['output'];
  /** Who the inviter meant it for. Unverified — a mismatch with your own address is a signal to ask them, not a refusal. */
  email: Scalars['String']['output'];
  expiresAt: Scalars['ISO8601DateTime']['output'];
  invitedBy: User;
};

/** A user's membership of a company. Every member is an administrator. */
export type CompanyMember = Node & {
  __typename?: 'CompanyMember';
  id: Scalars['ID']['output'];
  /** Null for the founding member. */
  invitedBy?: Maybe<User>;
  joinedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

/** The connection type for CompanyMember. */
export type CompanyMemberConnection = {
  __typename?: 'CompanyMemberConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CompanyMemberEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CompanyMember>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CompanyMemberEdge = {
  __typename?: 'CompanyMemberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CompanyMember>;
};

/** A business contact associated with an organization. */
export type Contact = Node & {
  __typename?: 'Contact';
  /**
   * Profile picture URL, re-hosted on our own storage so it doesn't depend on the
   * source's (potentially expiring) URL. Null until the background fetch runs or
   * the contact has no public photo.
   */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Paginated career entries — experience, education, certifications, awards, and publications — most recent first. */
  careerEntries: CareerEntryConnection;
  /** City where the contact is located. */
  city?: Maybe<Scalars['String']['output']>;
  /** Confidence score (0.0-1.0) from source quality, freshness, and diversity. */
  confidenceScore?: Maybe<Scalars['Float']['output']>;
  /** ISO 3166-1 alpha-2 country code. */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** When the contact record was first created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Primary email address. */
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** Extracted email pattern (e.g. {first}.{last}). */
  emailPattern?: Maybe<Scalars['String']['output']>;
  /** Verification status of the primary email address. */
  emailStatus?: Maybe<EmailStatus>;
  /** First name. */
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Functional department (e.g. marketing, sales, engineering). */
  jobFunction?: Maybe<Scalars['String']['output']>;
  /** Seniority level (e.g. c_level, vp, director, manager). */
  jobLevel?: Maybe<Scalars['String']['output']>;
  /** Current job title. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** Last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** LinkedIn profile URL. */
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  /** Mercator location divisions assigned to this contact's location. Empty until the background enrichment job runs. */
  locations: LocationConnection;
  /** The organization this contact belongs to. */
  organization: Organization;
  /** Phone number from an enrichment source. Null until a source provides one. */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   * Profile completeness score (0.0-1.0) from the presence of identity fields,
   * experience, and the merged confidence score. Consumers gate low-quality
   * records on this instead of counting raw history entries.
   */
  profileCompleteness: Scalars['Float']['output'];
  /** When the contact record was last modified. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** A business contact associated with an organization. */
export type ContactCareerEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<CareerEntryKindFilterInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A business contact associated with an organization. */
export type ContactLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Contact. */
export type ContactConnection = {
  __typename?: 'ContactConnection';
  /**
   * Estimated total number of items across all pages. It comes from the query
   * planner rather than a count, so it costs planning time instead of a scan and
   * cannot exceed the statement timeout. It is approximate at every magnitude,
   * including small ones, and it moves when the table's statistics are refreshed.
   * Accuracy depends on the filter: within a few percent on plain column and
   * array-overlap filters, and as much as 30% out on a range filter such as
   * `companySize`. It is not meaningful for the embedding filters `jobTitle` and
   * `industry` — no statistics exist for a vector-distance predicate, so the
   * estimate ignores the distance threshold entirely and approximates only what
   * the other filters admit; it has been measured reporting 241371 for a filter
   * whose true result was empty. Never render it as an exact figure, and use
   * `totalCount` when the figure has to be exact.
   */
  approximateTotalCount: Scalars['Int']['output'];
  /**
   * What this page cost in reveal credits — the ceiling held and the units used —
   * so a caller can see the bill of a request in the request. Zero when the query
   * revealed nothing.
   */
  credits: RevealCredits;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ContactEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Contact>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages, exact unless `upTo` is given. */
  totalCount: Scalars['Int']['output'];
};


/** The connection type for Contact. */
export type ContactConnectionTotalCountArgs = {
  upTo?: InputMaybe<Scalars['Int']['input']>;
};

/** An edge in a connection. */
export type ContactEdge = {
  __typename?: 'ContactEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /**
   * One entry per filter constrained on this query, reporting whether this contact
   * matched on the attribute's value or on its absence. `organizationFilter` axes
   * are reported under "organization." paths. Empty when the connection was
   * resolved without a filter.
   */
  filterMatches: Array<FilterMatch>;
  /**
   * Hamming distance between the binary quantizations of the contact's job
   * embedding and the sort query, an integer from 0 to 512 where 0 is identical.
   * Not a cosine distance, and not comparable to the thresholds the jobTitle
   * filter takes. Only present when sorting by JOB_TITLE_DISTANCE with a query argument.
   */
  neighborDistance?: Maybe<Scalars['Float']['output']>;
  /** The item at the end of the edge. */
  node?: Maybe<Contact>;
  /**
   * Per reach dimension this query touched: what this response revealed, what the
   * company already held, and what stays locked. Beside the node rather than on
   * it: a contact exists whether or not anyone has been handed its reach
   * information. Empty when the query touched no reach field, the same way
   * `filterMatches` is empty for an unfiltered query.
   */
  reveals: Array<RevealDimensionStatus>;
};

/** Autogenerated return type of ContactEnrichmentResult. */
export type ContactEnrichmentResultPayload = {
  __typename?: 'ContactEnrichmentResultPayload';
  /** The merged Contact, or null when none could be resolved. */
  contact?: Maybe<Contact>;
  /** The caller-supplied correlation id this result answers. */
  externalId: Scalars['ID']['output'];
  /** Why no Contact could be resolved. Populated only when `contact` is null. */
  unresolvedReason?: Maybe<ContactEnrichmentUnresolvedReason>;
};

/** Why an enrichContact call resolved no Contact. */
export type ContactEnrichmentUnresolvedReason =
  /**
   * Enrichment was accepted and deferred to a background job, and that job did not
   * complete — an upstream provider outage, or a payload the interaction refused.
   * Unlike the other reasons this is not a verdict about the contact: nothing was
   * decided, so the caller may retry the same payload.
   */
  | 'ENRICHMENT_FAILED'
  /** No email address, LinkedIn URL, or first-and-last-name pair was supplied, so no contact could be matched or created. */
  | 'NO_IDENTIFIER'
  /**
   * No organization domain was supplied and none could be resolved from the
   * organization LinkedIn URL or name. A Contact is always attached to a
   * domain-keyed Organization, so none could be created.
   */
  | 'UNRESOLVED_ORGANIZATION_DOMAIN';

/** Filter criteria for contacts. */
export type ContactFilterInput = {
  /** Filter by confidence score (0.0–1.0). */
  confidenceScore?: InputMaybe<FloatFilterInput>;
  /**
   * Filter by ISO 3166-1 alpha-2 country code.
   * @deprecated Use divisionIds for geographic filtering. divisionIds supports cities, regions, and multi-country groups (DACH, BENELUX) via Mercator.
   */
  countryCode?: InputMaybe<StringFilterInput>;
  /**
   * Filter contacts that belong to any of the given Mercator location division
   * IDs. `eq`/`in` match contacts with at least one overlapping division;
   * `not_eq`/`not_in` exclude them. This is an array-overlap filter against
   * Mercator-encoded division IDs, not a scalar Atlas ID filter.
   */
  divisionIds?: InputMaybe<IdFilterInput>;
  /**
   * Filter on the contact's email address. Values are downcased and trimmed
   * before matching — the same transform the column is written through — so
   * `eq: " Jane@Acme.com "` matches a stored "jane@acme.com". Matching is exact
   * after that, not a substring or domain search. An email is unique per
   * organization, and in practice globally, so a positive `eq` matches at most
   * one contact. Prefer this for a read-only "do we already have this person?"
   * lookup, batching a list through `in`; `searchContact` is the enriching
   * counterpart and will call paid providers on a miss. Pair with `valid: false`
   * to check existence irrespective of the quality floor — the default `valid`
   * gate requires a verified email and would hide a contact whose address is on
   * file but unverified. Use `emailStatus` to filter on verification state.
   */
  emailAddress?: InputMaybe<StringFilterInput>;
  /** Filter by email verification status (VALID, INVALID, CATCH_ALL, UNKNOWN). */
  emailStatus?: InputMaybe<EmailStatusFilterInput>;
  /** Filter by contact global id. */
  id?: InputMaybe<IdFilterInput>;
  /**
   * Job title embedding filters. Each entry matches contacts whose combined
   * job context (function + level + title) is semantically close to the query.
   * List related roles in `queries` (e.g. ["CMO", "Marketing Director",
   * "VP Marketing"]) to match any of them. Multilingual queries work: include
   * translated titles (e.g. "Directeur Marketing", "Marketingleiter") to
   * improve cross-language recall. Entries AND with each other.
   * Set `match` rather than a raw `distance`: this axis is measured in its
   * fitted 512-dimension projection, so its calibrated operating point is
   * 0.89 (text-embedding-3-small) and not the native-space 0.58 — a number a
   * caller cannot derive, and one that moves with every refit.
   * INCLUDED_STRICT resolves to 0.89, INCLUDED_LOOSE to 0.8949; both sit
   * inside the defensible 0.8802-0.8998 interval.
   * Thresholds validated by the embedding_calibration test suite.
   * Maximum 25 entries.
   */
  jobTitle?: InputMaybe<Array<EmbeddingFilterInput>>;
  /**
   * Filter on the contact's LinkedIn profile URL. `presence: true` returns only
   * contacts that have one — independent of `valid`, so combine `valid: false`
   * with it to reach contacts reachable on LinkedIn but without a verified
   * email. `eq`/`in` match a specific profile, and values are normalized the way
   * the column is written, so scheme, host and a trailing slash or query no
   * longer have to match a stored URL byte for byte:
   * `eq: "fr.linkedin.com/in/janedoe/?trk=x"` finds a stored
   * "https://www.linkedin.com/in/janedoe". A vanity slug is case-dependent, so
   * `/in/JaneDoe` and `/in/janedoe` stay two different profiles. Only person
   * profiles resolve — a company page, a bare slug or a non-LinkedIn URL matches
   * nothing rather than being ignored; use the `linkedin` filter on
   * `organizations` for a company page. Prefer this for a read-only "do we
   * already have this person?" lookup, batching a list through `in`;
   * `searchContact` is the enriching counterpart and will call paid providers on
   * a miss. Pair with `valid: false` to check existence irrespective of the
   * quality floor.
   */
  linkedin?: InputMaybe<StringFilterInput>;
  /**
   * Filter on the contact's full name. `presence: true` returns only contacts with
   * both a first and a last name — it re-expresses `valid`'s name floor on its
   * own, so callers passing `valid: false` can keep it without the
   * email/confidence floors. `eq`/`in` match a full name; values are compared
   * case- and accent-insensitively.
   */
  name?: InputMaybe<StringFilterInput>;
  /**
   * Return only contacts an outreach can land on — those with a LinkedIn URL, a
   * verified email, or both. Independent of `valid`, which requires the email leg
   * specifically, so pair `valid: false, reachable: true` to reach a contact whose
   * email is still undiscovered but whose LinkedIn profile is known. `false`
   * applies no constraint.
   */
  reachable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return only complete records (name, email, confidence >= 0.5). */
  valid?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of ContactIdentifyResult. */
export type ContactIdentifyResultPayload = {
  __typename?: 'ContactIdentifyResultPayload';
  contact?: Maybe<Contact>;
  externalId: Scalars['ID']['output'];
};

/** OneOf input for searchContact — supply exactly one lookup mode. */
export type ContactLookupInput = {
  /** Global ID of an existing contact whose email should be discovered. */
  contactId?: InputMaybe<Scalars['ID']['input']>;
  /** Contact's email address — globally unique within an organization. */
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  /** Contact's LinkedIn profile URL — globally unique within an organization. */
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  /** Name-based lookup: first name + last name + organization. */
  name?: InputMaybe<ContactNameInput>;
};

/** Name-based lookup for searchContact — first name, last name, and organization. */
export type ContactNameInput = {
  /** Contact's first name. */
  firstName: Scalars['String']['input'];
  /** Contact's last name. */
  lastName: Scalars['String']['input'];
  /** Global ID of the organization this contact belongs to. */
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of ContactSearchResult. */
export type ContactSearchResultPayload = {
  __typename?: 'ContactSearchResultPayload';
  /**
   * Matched contacts — both pre-existing database matches and newly-discovered,
   * newly-persisted third-party matches. Paginated; fetch further pages via the
   * `contacts` query using the same filter.
   */
  contacts: ContactConnection;
  externalId: Scalars['ID']['output'];
};


/** Autogenerated return type of ContactSearchResult. */
export type ContactSearchResultPayloadContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Fields available for sorting contacts. */
export type ContactSortField =
  /** Sort by merged confidence score, highest first by default. */
  | 'CONFIDENCE_SCORE'
  /** Sort by creation timestamp. */
  | 'CREATED_AT'
  /** Cosine distance from the linked organization's description embedding. Requires a query argument. */
  | 'DESCRIPTION_DISTANCE'
  /** Cosine distance from the linked organization's industry embedding. Requires a query argument. */
  | 'INDUSTRY_DISTANCE'
  /**
   * Hamming distance between the binary quantizations of the job_title embedding
   * and the query, an integer from 0 to 512 where 0 is identical. Requires a query argument.
   */
  | 'JOB_TITLE_DISTANCE';

/** Sort configuration for contacts. */
export type ContactSortInput = {
  direction?: InputMaybe<SortDirection>;
  field: ContactSortField;
  /**
   * Required when field is JOB_TITLE_DISTANCE, DESCRIPTION_DISTANCE, or
   * INDUSTRY_DISTANCE. Text to embed for distance ordering.
   */
  query?: InputMaybe<Scalars['String']['input']>;
};

/** Contact field values to cross-check against Atlas's stored data. */
export type ContactValidationChecksInput = {
  /** Email address to include in contact coherence checks. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Phone number to include in contact coherence checks. */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ContactValidationResult. */
export type ContactValidationResultPayload = {
  __typename?: 'ContactValidationResultPayload';
  /** Per-field coherence flags from the validation pass. */
  clues?: Maybe<Scalars['JSON']['output']>;
  contact?: Maybe<Contact>;
  externalId: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
};

/** A geographic point serialized as a GeoJSON Point object (RFC 7946). */
export type Coordinate = Node & {
  __typename?: 'Coordinate';
  /** Position in GeoJSON order: [longitude, latitude] (WGS 84). */
  coordinates: Array<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** GeoJSON geometry type. Always "Point". */
  type: Scalars['String']['output'];
};

/** A geographic coordinate used as a spatial query input. */
export type CoordinateInput = {
  /** Latitude in decimal degrees (WGS 84). */
  lat: Scalars['Float']['input'];
  /** Longitude in decimal degrees (WGS 84). */
  lng: Scalars['Float']['input'];
};

/** Autogenerated input type of CreateApplicationCredential */
export type CreateApplicationCredentialInput = {
  applicationId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Omit for a credential that lives until revoked. Note this bounds when the
   * credential may still obtain a token, not the tokens themselves: one issued
   * just before this moment stays valid for its full lifetime afterwards, because
   * a subgraph verifies a token by signature and `exp` and never asks whether the
   * credential behind it is still alive.
   */
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  name: Scalars['String']['input'];
  /** Marks a throwaway credential minted for one CLI session. Hidden from listings by default. */
  session?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of CreateApplication */
export type CreateApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Defaults to the caller's personal company. */
  companyId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Autogenerated input type of CreateBillingCheckoutSession */
export type CreateBillingCheckoutSessionInput = {
  /** Billing customer UUID, stored on the owning service's company record. */
  billingCustomerId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Settlement currency to charge, lowercase ISO (one of: eur, usd, gbp — the
   * currencies with defined catalog prices). Pins Checkout to that currency's
   * defined amount so the price the product displayed is exactly what the card is
   * charged. Omitted: Stripe Adaptive Pricing presents the customer's local
   * currency, converted from EUR.
   */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Billing periodicity for the new subscription. MONTHLY or ANNUAL. */
  periodicity: BillingPeriodicity;
  /** Plan tier for the new subscription. Plans whose catalog entry offers a trial start with one; the rest bill immediately. */
  plan: BillingPlanName;
  /** Override for the frontend base URL Stripe redirects to after Checkout. Defaults to BILLING_CHECKOUT_RETURN_BASE_URL. */
  returnBaseUrl?: InputMaybe<Scalars['String']['input']>;
  /**
   * Trial length override in days (0-90), for sales-led flows that hand out custom
   * trials. 0 disables the trial (charge at checkout). Defaults to the plan's catalog trial.
   */
  trialDays?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateBillingCheckoutSession. */
export type CreateBillingCheckoutSessionPayload = Node & {
  __typename?: 'CreateBillingCheckoutSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Stripe-hosted Checkout URL. The frontend should immediately `window.location =` this. */
  url: Scalars['String']['output'];
};

/** Autogenerated input type of CreateBillingCustomer */
export type CreateBillingCustomerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional company UUID to record in Stripe's customer metadata for
   * cross-service debugging. Not used by billing for any lookup.
   */
  companyId?: InputMaybe<Scalars['ID']['input']>;
  /** Customer's email. Sent to Stripe so Checkout pre-fills the email field and receipts go to the right inbox. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Customer's display name (typically `first last`). Stored on the Stripe Customer for Dashboard readability. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Product the customer belongs to — decides which Stripe account the customer is
   * created on and which plan catalog applies. The account must be registered in
   * the environment or the mutation fails.
   */
  product: BillingProduct;
};

/** Autogenerated return type of CreateBillingCustomer. */
export type CreateBillingCustomerPayload = Node & {
  __typename?: 'CreateBillingCustomerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created billing customer. */
  customer: BillingCustomer;
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of CreateBillingEmbeddedCheckoutSession */
export type CreateBillingEmbeddedCheckoutSessionInput = {
  /** Billing customer UUID, stored on the owning service's company record. */
  billingCustomerId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Billing periodicity for the new subscription. MONTHLY or ANNUAL. */
  periodicity: BillingPeriodicity;
  /** Plan tier for the new subscription. Plans whose catalog entry offers a trial start with one; the rest bill immediately. */
  plan: BillingPlanName;
  /**
   * Override for the frontend base URL Stripe redirects the parent frame to after
   * the customer completes payment. Defaults to the
   * BILLING_CHECKOUT_RETURN_BASE_URL env var.
   */
  returnBaseUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateBillingEmbeddedCheckoutSession. */
export type CreateBillingEmbeddedCheckoutSessionPayload = Node & {
  __typename?: 'CreateBillingEmbeddedCheckoutSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /**
   * Stripe Checkout Session client secret. The frontend feeds this to Stripe.js'
   * `<EmbeddedCheckoutProvider>` to mount the payment form inline.
   */
  clientSecret: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of CreateBillingPortalSession */
export type CreateBillingPortalSessionInput = {
  /** Billing customer UUID. */
  billingCustomerId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Override for the frontend base URL Stripe redirects back to after the Portal session closes. */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateBillingPortalSession. */
export type CreateBillingPortalSessionPayload = Node & {
  __typename?: 'CreateBillingPortalSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Stripe-hosted Customer Portal URL. */
  url: Scalars['String']['output'];
};

/** Autogenerated input type of CreateChannelAccount */
export type CreateChannelAccountInput = {
  /** Channel the account will operate on. */
  channel: Channel;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Who the account is for, when the consumer already knows: history can then be
   * imported before any connection. A claim until a connection confirms it; a
   * connection resolving to someone else is refused. Refused as
   * `identity.channel_mismatch` for another channel's variant and
   * `identity.already_claimed` when this owner already has a live account for that person.
   */
  identity?: InputMaybe<ChannelIdentityInput>;
  /**
   * Provider that runs the account on the channel. Defaults to the first
   * configured provider of the channel. Refused as `provider.unknown` when it does
   * not serve the channel and `provider.unavailable` when it is not configured in
   * this environment.
   */
  provider?: InputMaybe<Provider>;
  /** HMAC-SHA256 secret every event about this account is signed with. Write-only: it is never returned by the API. */
  webhookSecret: Scalars['String']['input'];
  /** HTTPS address every event about this account is delivered to. */
  webhookUrl: Scalars['String']['input'];
};

/** Autogenerated return type of CreateChannelAccount. */
export type CreateChannelAccountPayload = Node & {
  __typename?: 'CreateChannelAccountPayload';
  /** The draft account. */
  channelAccount: ChannelAccount;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of CreateCompanyBillingPortalSession */
export type CreateCompanyBillingPortalSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The company whose billing is being managed. */
  companyId: Scalars['ID']['input'];
  /** Where Stripe returns the caller when they leave the portal. */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateCompanyCheckoutSession */
export type CreateCompanyCheckoutSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The company being subscribed. Every member may subscribe it — there are no roles. */
  companyId: Scalars['ID']['input'];
  /** MONTHLY or ANNUAL, as `billingPlanCatalog` reports it. */
  periodicity: Scalars['String']['input'];
  /**
   * Tier name, as `billingPlanCatalog(product:)` reports it. Validated by billing
   * against that product's catalog, so a tier belonging to another product is
   * refused rather than resolved.
   */
  plan: Scalars['String']['input'];
  /** Where Stripe returns the parent frame after payment. Defaults to the deployment's configured portal URL. */
  returnBaseUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateCompany */
export type CreateCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Autogenerated input type of CreateCompanyInvitation */
export type CreateCompanyInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  /**
   * Who the invitation is meant for. A label for your own records: whoever
   * authenticates while accepting joins, not this address.
   */
  email: Scalars['String']['input'];
  /** Defaults to seven days. */
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated input type of CreateSource */
export type CreateSourceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Maps Atlas canonical contact field names to rawData extraction expressions.
   * Keys: first_name, last_name, email_address, job_title, job_level, job_function,
   * linkedin_url, city, country_code.
   * Values: a string key ("firstname"), an array path for nested access
   * (["data", "email"]), or an operation hash
   * ({"op": "split", "key": "full_name", "index": 0}).
   * All referenced keys must exist in contact_schema.
   */
  contactFieldMappings?: InputMaybe<Scalars['JSON']['input']>;
  /** JSON Schema (draft-07) describing the expected shape of contact rawData payloads. */
  contactSchema?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * Maps Atlas canonical identification field names to rawData extraction expressions.
   * Keys: ip_address, organization_domain, confidence_score.
   * Values follow the same expression syntax as contact_field_mappings.
   * All referenced keys must exist in identification_schema.
   */
  identificationFieldMappings?: InputMaybe<Scalars['JSON']['input']>;
  /** JSON Schema (draft-07) describing the expected shape of identification rawData payloads. */
  identificationSchema?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * Maps Atlas canonical organization field names to rawData extraction expressions.
   * Keys: name, website, phone, contact_email, linkedin_url, description,
   * company_size, founded_year, industry, country_code, annual_revenue.
   * Values: a string key ("name"), an array path (["company", "name"]),
   * or an operation hash ({"op": "parse_employee_range", "path": ["size_range"]}).
   * All referenced keys must exist in organization_schema.
   */
  organizationFieldMappings?: InputMaybe<Scalars['JSON']['input']>;
  /** JSON Schema (draft-07) describing the expected shape of organization rawData payloads. */
  organizationSchema?: InputMaybe<Scalars['JSON']['input']>;
  /** Short machine-readable identifier for this source (e.g. snitcher, hunter). */
  slug: Scalars['String']['input'];
  /** Weight applied during multi-source merging, 0.0–1.0. Higher scores win field conflicts. */
  trustScore?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated input type of CreateWatcher */
export type CreateWatcherInput = {
  /**
   * Provision the Watcher's providers asynchronously. False (the default) keeps
   * the synchronous contract: providers are set up before this mutation returns,
   * the Watcher comes back `PROVISIONED` with its `installations` and
   * `providerReferences` populated, and a provider refusing the request (an
   * unresolvable place, an out-of-vocabulary industry, an upstream outage) fails
   * the call. True returns as soon as the Watcher is persisted, `PENDING`, and
   * provisions in background jobs retried across provider outages for about a day:
   * creation no longer fails when a provider is down, and the outcome arrives on
   * `provisioningStatus` (poll) or `watcherProvisioningResult` (subscribe, with
   * `externalId`), with per-provider reasons on `provisioningFailures`.
   */
  async?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Ignored. Accepted only so callers written against the previous schema keep
   * working; a Watcher is keyed on the calling `owner_sub`, never on a company.
   * @deprecated Never read. Removed once the last caller stops sending it.
   */
  companyId?: InputMaybe<Scalars['ID']['input']>;
  /** Slug of the Definition to subscribe to. */
  definitionSlug: Scalars['String']['input'];
  /** Version of the Definition to subscribe to. */
  definitionVersion: Scalars['Int']['input'];
  /**
   * How the upstream source treats a lead it has already delivered for this
   * watcher. Omit to leave the source's own default in place.
   */
  duplicateHandling?: InputMaybe<DuplicateHandlingInput>;
  /**
   * Optional caller-chosen correlation id for the asynchronous provisioning
   * outcome, used with `async: true`. Subscribe to
   * `watcherProvisioningResult(externalId:)` with the same value before calling
   * this mutation; when every provider settles, the watcher is delivered on that
   * subscription. Callers that poll `provisioningStatus` instead can omit it.
   */
  externalId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Optional Ideal Customer Profile, in the same shape Atlas search uses —
   * including geography: `contact.divisionIds` / `organization.divisionIds` are
   * Mercator location division IDs filtered exactly as Atlas search filters them,
   * so `notIn` excludes places as well. Forwarded to each provider's upstream
   * source so leads outside the profile are never emitted — and never billed. Part
   * of the watcher's identity: two callers watching the same topic with different
   * profiles get separate watchers.
   */
  icp?: InputMaybe<WatcherIcpInput>;
  /**
   * Optional freshness-first per-period lead caps for this watcher. Omit or pass
   * an empty list to leave the watcher uncapped. Caps are a property of the
   * watcher (not the individual webhook), so they replace any caps already set on
   * a shared watcher.
   */
  leadCaps?: InputMaybe<Array<LeadCapInput>>;
  /**
   * How many contacts one matched organization may yield, and the window that is
   * measured over. Omit to take the defaults the input type declares. Only sources
   * that can enforce a per-organization limit accept an explicit cap — a
   * definition whose providers cannot refuses one rather than silently ignoring
   * it, while omission is always accepted. Part of the Watcher's identity, so it
   * is fixed at creation.
   */
  maximumLeadsPerOrganization?: InputMaybe<MaximumLeadsPerOrganizationInput>;
  /** User-supplied watcher input validated against the Definition's `watcherInputSchema`. */
  watcherInput: Scalars['JSON']['input'];
  /** Delivery endpoint registered on this watcher. Multiple callers with the same definition and input share one watcher. */
  webhook: WatcherWebhookInput;
};

/** Autogenerated return type of CreateWatcher. */
export type CreateWatcherPayload = Node & {
  __typename?: 'CreateWatcherPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * The newly created or updated Watcher. Already `PROVISIONED` unless `async:
   * true` was requested, in which case its provisioning may still be `PENDING` —
   * see `provisioningStatus`.
   */
  watcher: Watcher;
};

/**
 * The credentials were verified at the channel and stored; nothing is left for the
 * account owner to do. The account is connected only when the
 * `channel_account.connected` event arrives, a few seconds later.
 */
export type CredentialsAccepted = {
  __typename?: 'CredentialsAccepted';
  /** When the credentials were verified. */
  acceptedAt: Scalars['ISO8601DateTime']['output'];
  /** The channel-side id the credentials resolved to — for LinkedIn, the member id (`ACoAA…`). */
  providerAccountId: Scalars['String']['output'];
};

/** Autogenerated input type of DebitCredits */
export type DebitCreditsInput = {
  /** Billing customer UUID the consumer holds for the tenant (from Company.billingCustomerId). */
  billingCustomerId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the record being paid for (e.g. the Lead or Message id). */
  consumableId: Scalars['ID']['input'];
  /** AR class name of the consumed record (e.g. 'Lead', 'Message'). */
  consumableType: Scalars['String']['input'];
  /** Number of credits to draw. Must be greater than 0. */
  cost: Scalars['Float']['input'];
  /** Optional label stored on the debit rows. */
  description?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DebitCredits. */
export type DebitCreditsPayload = Node & {
  __typename?: 'DebitCreditsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Debit rows written by this call. Empty on failure. */
  debits: Array<BillingDebit>;
  /** Currently always `insufficient_credits`. Null on success. */
  errorCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Customer's credit balance after the debit, or on failure. */
  remainingBalance: Scalars['Float']['output'];
  /** True when the full cost was drawn. */
  success: Scalars['Boolean']['output'];
};

/** A signal Definition: a code-defined strategy that produces leads from external sources via one or more internal providers. */
export type Definition = {
  __typename?: 'Definition';
  /**
   * JSON Schema describing the shape of `Event.payload` rows produced by this
   * Definition, regardless of which provider delivered them. `Event.payload` is
   * projected onto this schema, so a property it does not declare is never
   * returned. Property names are camelCase, matching the payload; each carries a
   * localized `title` in the caller's locale.
   */
  canonicalEventSchema: Scalars['JSON']['output'];
  /** Whether this Definition version is deprecated. */
  deprecated: Scalars['Boolean']['output'];
  /** Human-readable explanation of the signal this Definition captures. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Display-only description localized to the caller's Accept-Language locale, for
   * showing in the UI. Falls back to the English `description` when no translation exists.
   */
  descriptionLocalized?: Maybe<Scalars['String']['output']>;
  /** Stable composite identifier in the form 'slug@version'. */
  id: Scalars['ID']['output'];
  /** Human-readable name of the Definition. */
  name: Scalars['String']['output'];
  /**
   * Display-only name localized to the caller's Accept-Language locale, for
   * showing in the UI. Falls back to the English `name` when no translation exists.
   */
  nameLocalized: Scalars['String']['output'];
  /** Cron expression for scheduled ingestion runs, or null if the Definition is purely webhook-driven. */
  scheduleCron?: Maybe<Scalars['String']['output']>;
  /** URL-safe identifier of the Definition (e.g. 'radar'). */
  slug: Scalars['String']['output'];
  /** Ways this Definition can be triggered (scheduled, webhook, manual). */
  triggers: Array<TriggerEnum>;
  /** Definition version. Bumped when the canonical event shape changes. */
  version: Scalars['Int']['output'];
  /**
   * JSON Schema for the user-supplied watcher input. The same input is fanned out
   * to every internal provider; providers never require additional user input.
   * Each property carries a localized `title` and, for enum-constrained
   * properties, an `x-enumLabels` map of localized option labels in the caller's locale.
   */
  watcherInputSchema: Scalars['JSON']['output'];
};

/** The connection type for Definition. */
export type DefinitionConnection = {
  __typename?: 'DefinitionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DefinitionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Definition>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DefinitionEdge = {
  __typename?: 'DefinitionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Definition>;
};

/** Filter arguments for the definitions connection. */
export type DefinitionFilterInput = {
  /** Include deprecated definitions. Defaults to false. */
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of DeleteApplication */
export type DeleteApplicationInput = {
  applicationId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of DeleteBillingCustomer */
export type DeleteBillingCustomerInput = {
  /** Billing customer UUID to delete, stored on the owning service's company record. */
  billingCustomerId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteBillingCustomer. */
export type DeleteBillingCustomerPayload = Node & {
  __typename?: 'DeleteBillingCustomerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** True when the customer was deleted. */
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of DeleteCompany */
export type DeleteCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  /** Required while the company still owns applications. Revokes all their credentials. */
  force?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of DeleteWatcher */
export type DeleteWatcherInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** Webhook URL to remove from this watcher. Cancels the watcher automatically when the last URL is removed. */
  webhookUrl: Scalars['String']['input'];
};

/** Autogenerated return type of DeleteWatcher. */
export type DeleteWatcherPayload = Node & {
  __typename?: 'DeleteWatcherPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The updated or canceled Watcher. */
  watcher: Watcher;
};

/** Autogenerated input type of DeviceAuthorize */
export type DeviceAuthorizeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceCodeResponse = Node & {
  __typename?: 'DeviceCodeResponse';
  deviceCode: Scalars['String']['output'];
  expiresIn: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  interval: Scalars['Int']['output'];
  userCode: Scalars['String']['output'];
  verificationUri: Scalars['String']['output'];
  verificationUriComplete?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeviceToken */
export type DeviceTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deviceCode: Scalars['String']['input'];
};

/** Autogenerated input type of DisconnectChannelAccount */
export type DisconnectChannelAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Global id of the channel account to remove. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DisconnectChannelAccount. */
export type DisconnectChannelAccountPayload = Node & {
  __typename?: 'DisconnectChannelAccountPayload';
  /** The account, now `REMOVED`; it no longer resolves by id. */
  channelAccount: ChannelAccount;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** Autogenerated return type of DomainValidationResult. */
export type DomainValidationResultPayload = {
  __typename?: 'DomainValidationResultPayload';
  /** Per-field coherence flags from the validation pass. */
  clues?: Maybe<Scalars['JSON']['output']>;
  externalId: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
};

/**
 * Policy for a lead the upstream source has already delivered for this Watcher.
 * Omit the whole input to leave the source's own default in place.
 */
export type DuplicateHandlingInput = {
  /** Which policy applies. */
  mode: DuplicateHandlingModeEnum;
  /**
   * How long a repeat delivery stays refused, as an ISO-8601 duration (e.g. P7D).
   * Required when `mode` is REFUSE_DURING and rejected otherwise. Sources count
   * this in whole days, so a duration that isn't a whole number of days is rejected.
   */
  period?: InputMaybe<Scalars['ISO8601Duration']['input']>;
};

/** How the upstream source treats a lead it has already delivered for a Watcher. */
export type DuplicateHandlingModeEnum =
  /** Always deliver, even for a lead already seen. */
  | 'ALWAYS'
  /** Never deliver the same lead twice. */
  | 'REFUSE'
  /** Refuse a repeat delivery for `period`, then allow it again. */
  | 'REFUSE_DURING';

/** Email verification status. */
export type EmailStatus =
  /** Domain accepts all emails (catch-all). */
  | 'CATCH_ALL'
  /** Email is invalid or undeliverable. */
  | 'INVALID'
  /** Verification status is unknown. */
  | 'UNKNOWN'
  /** Email is valid and deliverable. */
  | 'VALID';

/** Filter on email status with schema-validated enum values. */
export type EmailStatusFilterInput = {
  /**
   * When true, a row also matches when the attribute is blank — NULL, an empty
   * string, an empty list, or no related record, depending on the column. The
   * connection edge reports which branch admitted each row via `filterMatches`.
   * Contrast `blank`, which narrows to blank-only rows where this one widens to include them.
   */
  allowBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exact match. */
  eq?: InputMaybe<EmailStatus>;
  /** Match any of these values. */
  in?: InputMaybe<Array<EmailStatus>>;
  /** Exclude exact match. */
  notEq?: InputMaybe<EmailStatus>;
  /** Exclude any of these values. */
  notIn?: InputMaybe<Array<EmailStatus>>;
};

/** A semantic-similarity filter, as submitted. */
export type EmbeddingFilter = {
  __typename?: 'EmbeddingFilter';
  /** Cosine distance constraints (0 = identical, 2 = opposite). Null when the filter was submitted with `match` instead. */
  distance?: Maybe<FloatFilter>;
  /** How the entry constrains a record. Null when the filter was submitted with the deprecated `distance` instead. */
  match?: Maybe<EmbeddingMatch>;
  /**
   * Texts that were embedded and compared against, combined under this entry's
   * constraint. Populated instead of `query` when the filter was submitted with a list.
   */
  queries?: Maybe<Array<Scalars['String']['output']>>;
  /** Text that was embedded and compared against. Null when the filter was submitted with `queries` instead. */
  query?: Maybe<Scalars['String']['output']>;
};

/** Filter by semantic similarity using vector embeddings. */
export type EmbeddingFilterInput = {
  /**
   * When true, a row also matches when the attribute is blank — NULL, an empty
   * string, an empty list, or no related record, depending on the column. The
   * connection edge reports which branch admitted each row via `filterMatches`.
   * Contrast `blank`, which narrows to blank-only rows where this one widens to include them.
   */
  allowBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Cosine distance constraints (0 = identical, 2 = opposite). `allowBlank`
   * belongs on the entry, not here — the distance operators are evaluated against
   * the embedding column.
   * @deprecated Supply `match` instead. A raw distance is only meaningful against the axis's calibrated threshold and the basis it is measured in, neither of which a caller can see.
   */
  distance?: InputMaybe<FloatFilterInput>;
  /**
   * How this entry constrains a record. `INCLUDED_*` keeps records within the
   * axis's calibrated cosine-distance threshold, `EXCLUDED_*` keeps those beyond
   * it — exact complements at the same threshold. `*_LOOSE` widens that threshold
   * so near matches are admitted (or, on the excluded side, dropped too).
   * The number itself is resolved per axis and in the vector basis that axis is
   * measured in, which is why it is no longer the caller's to supply.
   */
  match?: InputMaybe<EmbeddingMatch>;
  /**
   * Texts to embed and compare against, combined under this entry's single
   * `match`. Use this for "any of these" — the OR that `in` gives the scalar
   * filters. Each string is embedded separately, so several concepts keep their
   * own centroid and their own recall; packing them into one `query` instead
   * averages them into a single vector that can sit between the concepts and
   * match none of them well.
   * Direction decides how they combine: an `INCLUDED_*` match keeps records close
   * to **any** of the queries, while an `EXCLUDED_*` one keeps only records far
   * from **every** one of them.
   * Mutually exclusive with `query`; supply exactly one of the two. Maximum 50 queries.
   */
  queries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Text to embed and compare against. Mutually exclusive with `queries`; supply exactly one of the two. */
  query?: InputMaybe<Scalars['String']['input']>;
};

/**
 * How an embedding filter entry constrains a record: which side of the axis's
 * calibrated threshold to keep, and how wide that threshold is. The numeric bound
 * is resolved server-side per axis, in the vector basis that axis is measured in.
 */
export type EmbeddingMatch =
  /**
   * Drops records close to the query at the widened threshold, so near matches are
   * dropped too. The exact complement of INCLUDED_LOOSE.
   */
  | 'EXCLUDED_LOOSE'
  /**
   * Drops records semantically close to the query, at the axis's calibrated
   * threshold. The exact complement of INCLUDED_STRICT.
   */
  | 'EXCLUDED_STRICT'
  /** Keeps records close to the query at a widened threshold, admitting near matches at the cost of precision. */
  | 'INCLUDED_LOOSE'
  /** Keeps records semantically close to the query, at the axis's calibrated threshold. */
  | 'INCLUDED_STRICT';

/** Autogenerated input type of EnrichContact */
export type EnrichContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The contact's primary email address. */
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  /**
   * Caller-supplied correlation id; when present, the merged contact is broadcast
   * over the contactEnrichmentResult subscription.
   */
  externalId?: InputMaybe<Scalars['ID']['input']>;
  /** The contact's first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** When the raw data was originally ingested. */
  ingestedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Visitor IP address associated with this event. */
  ip?: InputMaybe<Scalars['String']['input']>;
  /** The contact's last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The contact's LinkedIn profile URL. */
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  /**
   * The organization's primary web domain. When omitted, it is resolved from the
   * linkedin and organization hints below — a CoreSignal lookup and, failing that,
   * an LLM web search, which is the expensive part of this mutation.
   */
  organizationDomain?: InputMaybe<Scalars['String']['input']>;
  /**
   * The organization's LinkedIn URL. Used to resolve the organization domain via
   * CoreSignal when organization_domain is omitted.
   */
  organizationLinkedinUrl?: InputMaybe<Scalars['String']['input']>;
  /** The organization's name. Used to resolve the organization domain via web search when organization_domain is omitted. */
  organizationName?: InputMaybe<Scalars['String']['input']>;
  /** The full raw enrichment payload. */
  rawData: Scalars['JSON']['input'];
  /** The ID of the enrichment source. */
  sourceId: Scalars['ID']['input'];
};

/** Autogenerated return type of EnrichContact. */
export type EnrichContactPayload = {
  __typename?: 'EnrichContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** One of: received. */
  status: Scalars['String']['output'];
};

/** Autogenerated input type of EnrichIdentification */
export type EnrichIdentificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** When the raw data was originally ingested. */
  ingestedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** The IPv4 or IPv6 address being identified. */
  ip: Scalars['String']['input'];
  /** The company domain identified for this IP. */
  organizationDomain?: InputMaybe<Scalars['String']['input']>;
  /** The raw enrichment payload, stored as-is. */
  rawData?: InputMaybe<Scalars['JSON']['input']>;
  /** The ID of the enrichment source. */
  sourceId: Scalars['ID']['input'];
};

/** Autogenerated return type of EnrichIdentification. */
export type EnrichIdentificationPayload = {
  __typename?: 'EnrichIdentificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** One of: received. */
  status: Scalars['String']['output'];
};

/** Autogenerated input type of EnrichOrganization */
export type EnrichOrganizationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The company's primary web domain. */
  domain: Scalars['String']['input'];
  /**
   * Correlation id echoed on the `organizationEnrichmentResult` subscription once
   * the merge (including embeddings) has settled. When omitted, no result is broadcast.
   */
  externalId?: InputMaybe<Scalars['ID']['input']>;
  /** When the raw data was originally ingested. */
  ingestedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Visitor IP associated with this event. */
  ip?: InputMaybe<Scalars['String']['input']>;
  /** The full raw enrichment payload. */
  rawData: Scalars['JSON']['input'];
  /** The ID of the enrichment source. */
  sourceId: Scalars['ID']['input'];
};

/** Autogenerated return type of EnrichOrganization. */
export type EnrichOrganizationPayload = {
  __typename?: 'EnrichOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** One of: received. */
  status: Scalars['String']['output'];
};

/** Federation reference to a Event owned by another subgraph. */
export type Event = Node & {
  __typename?: 'Event';
  /** Timestamp when the Event row was persisted. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Key used by the Definition's deduplication strategy. Null when the Definition does not deduplicate. */
  deduplicationKey?: Maybe<Scalars['String']['output']>;
  /**
   * Every attempt made to deliver this Event to its Watcher's webhooks, oldest
   * first. Retries each write their own row, so several attempts against one URL
   * is normal and the last one decides whether the lead arrived. Requires
   * `signals/watcher:read`.
   */
  deliveries: EventDeliveryConnection;
  /**
   * Why this Event never became a lead — a duplicate, or an ICP the payload did
   * not clear. Null for one that was kept. It is the difference between "nothing
   * arrived" and "something arrived and was refused", which the timestamps alone
   * cannot express.
   */
  discardReason?: Maybe<Scalars['String']['output']>;
  /** When this Event was refused. Null for one that was kept. */
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * How the lead cleared each attribute the Watcher's ICP constrains, one entry
   * per attribute, ordered by attribute name. Null when the Event predates the
   * check, never reached it, or its Watcher has no ICP.
   */
  icpAxisVerdicts?: Maybe<Array<EventIcpAxisVerdict>>;
  /** GlobalID-encoded Event id. */
  id: Scalars['ID']['output'];
  /**
   * Why materialization failed, as the pipeline recorded it. Distinct from
   * discardReason: this one is our failure, not a refusal. Requires
   * `signals/watcher:read`.
   */
  materializationFailureReason?: Maybe<Scalars['String']['output']>;
  /**
   * Which route materialization took to turn this Event into a lead — the
   * difference between "no contact was found" and "a contact was found the other
   * way". Requires `signals/watcher:read`.
   */
  materializationPath?: Maybe<Scalars['String']['output']>;
  /** Timestamp at which the originating ingestion run observed this Event. */
  observedAt: Scalars['ISO8601DateTime']['output'];
  /** Timestamp at which the underlying activity actually happened upstream, when known. */
  occurredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Canonical Event payload, projected onto the shape declared by the
   * `canonicalEventSchema` of the Definition version that captured it. A key the
   * schema does not declare is never returned, at any depth, and declared keys are
   * camelCase. An object the schema marks `additionalProperties: true` is returned
   * whole, under the key names its provider sends.
   */
  payload: Scalars['JSON']['output'];
  /** Timestamp of the most recent failed materialization attempt. */
  processingFailedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Timestamp at which materialization succeeded. */
  processingSucceededAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Atlas contact this Event resolved to, as the GlobalID atlas addresses it by —
   * the same form `Events::DeliverWebhookJob` puts on the wire, so a lead can be
   * followed from here into atlas without re-encoding anything. Null when
   * materialization resolved no contact. Requires `signals/watcher:read`.
   */
  resolvedContactId?: Maybe<Scalars['String']['output']>;
  /**
   * The Watcher that captured this Event. Selected from the root `events`
   * connection, where a page spans many Watchers and a row is unreadable without
   * the one it belongs to.
   */
  watcher: Watcher;
};


/** Federation reference to a Event owned by another subgraph. */
export type EventDeliveriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Event. */
export type EventConnection = {
  __typename?: 'EventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EventEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Event>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/**
 * One attempt to deliver an Event to one of its Watcher's webhooks.
 * DeliverWebhookJob retries, so a single Event can carry several attempts against
 * the same URL — the last one decides whether the lead arrived.
 */
export type EventDelivery = {
  __typename?: 'EventDelivery';
  /** When the attempt was made. */
  attemptedAt: Scalars['ISO8601DateTime']['output'];
  /** What the endpoint or the transport answered with, when the attempt failed. Null for one that succeeded. */
  error?: Maybe<Scalars['String']['output']>;
  /**
   * Status the endpoint answered with. Null when the request never got an answer —
   * a timeout or a DNS failure, which is not the same as a 5xx.
   */
  httpStatus?: Maybe<Scalars['Int']['output']>;
  /** Whether the lead reached the endpoint on this attempt. */
  state: EventDeliveryStateEnum;
  /**
   * The webhook URL this attempt targeted. Secrets are never exposed. Null when
   * the endpoint has since been deleted — deliveries outlive it, being an audit trail.
   */
  url?: Maybe<Scalars['String']['output']>;
  /** Identifier of the webhook this attempt targeted. */
  webhookId: Scalars['ID']['output'];
};

/** The connection type for EventDelivery. */
export type EventDeliveryConnection = {
  __typename?: 'EventDeliveryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EventDeliveryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EventDelivery>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EventDeliveryEdge = {
  __typename?: 'EventDeliveryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EventDelivery>;
};

/** How one delivery attempt ended. */
export type EventDeliveryStateEnum =
  /** The endpoint answered with a 2xx. */
  | 'DELIVERED'
  /** The endpoint answered with anything else, or never answered at all. */
  | 'FAILED';

/** An edge in a connection. */
export type EventEdge = {
  __typename?: 'EventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Event>;
};

/** Filter arguments for the events connection. */
export type EventFilterInput = {
  /**
   * Keep only the events refused for this reason, e.g. 'icp_mismatch'. A reason is
   * only ever carried by a refused event, so asking for one asks for the DISCARDED
   * slice and takes the same scope.
   */
  discardReason?: InputMaybe<StringFilterInput>;
  /** Which slices to list. Omitted, KEPT alone — the only slice a caller without a service-wide read scope may reach. */
  state?: InputMaybe<WatcherEventStateFilterInput>;
  /**
   * Keep only the events captured by this Watcher, as its GlobalID. The root
   * connection spans every watcher, so this is what narrows it to the one a ticket names.
   */
  watcherId?: InputMaybe<IdFilterInput>;
};

/** One attribute the Watcher's ICP constrains, and how the lead cleared it. */
export type EventIcpAxisVerdict = {
  __typename?: 'EventIcpAxisVerdict';
  /** Attribute the ICP constrains. One of: job_title, contact_divisions, industry, company_size, organization_divisions. */
  axis: Scalars['String']['output'];
  /** How the lead cleared this attribute. */
  verdict: IcpAxisVerdictEnum;
};

/** How one constrained filter admitted this row. */
export type FilterMatch = {
  __typename?: 'FilterMatch';
  /** Whether this filter was submitted with `allowBlank: true`. */
  allowBlank: Scalars['Boolean']['output'];
  /** Whether the row matched on the attribute's value or on its absence. */
  matchedOn: FilterMatchSource;
  /** Dotted path of the filter argument, e.g. "contact.jobTitle" or "organization.industry". */
  path: Scalars['String']['output'];
};

/** Which branch of a filter admitted a row. */
export type FilterMatchSource =
  /**
   * The attribute is absent on this row — NULL, an empty string, an empty list, or
   * no related record. Usually paired with `allowBlank: true`, but `blank: true`
   * targets absence on purpose and reports BLANK too.
   */
  | 'BLANK'
  /** The row carries a value on this attribute, so the filter's own predicate is what admitted it. */
  | 'VALUE';

/** A numeric comparison filter, as submitted. */
export type FloatFilter = {
  __typename?: 'FloatFilter';
  /** Exact match. */
  eq?: Maybe<Scalars['Float']['output']>;
  /** Greater than. */
  gt?: Maybe<Scalars['Float']['output']>;
  /** Greater than or equal. */
  gteq?: Maybe<Scalars['Float']['output']>;
  /** Less than. */
  lt?: Maybe<Scalars['Float']['output']>;
  /** Less than or equal. */
  lteq?: Maybe<Scalars['Float']['output']>;
};

/** Filter on a numeric column with comparison operators. */
export type FloatFilterInput = {
  /**
   * When true, a row also matches when the attribute is blank — NULL, an empty
   * string, an empty list, or no related record, depending on the column. The
   * connection edge reports which branch admitted each row via `filterMatches`.
   * Contrast `blank`, which narrows to blank-only rows where this one widens to include them.
   */
  allowBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exact match. */
  eq?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than. */
  gt?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than or equal. */
  gteq?: InputMaybe<Scalars['Float']['input']>;
  /** Less than. */
  lt?: InputMaybe<Scalars['Float']['input']>;
  /** Less than or equal. */
  lteq?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * A short-lived page hosted by the provider where the account owner signs in. Send
 * the user's browser there; the account is connected only when the
 * `channel_account.connected` event arrives, never from the return redirect.
 */
export type HostedAuthenticationLink = {
  __typename?: 'HostedAuthenticationLink';
  /** Address of the hosted sign-in page. Valid for about ten minutes. */
  url: Scalars['String']['output'];
};

/**
 * Whether the delivery-time ICP re-check judged an attribute on the lead's own
 * data, on its absence, or refused the lead on it.
 */
export type IcpAxisVerdictEnum =
  /**
   * This attribute is why the lead was discarded as an ICP mismatch. Only a
   * discarded lead carries it, and it may carry it on more than one attribute.
   */
  | 'REFUSED'
  /** The lead was admitted on this attribute only because no value is held for it, so the attribute says nothing about its fit. */
  | 'UNVERIFIED'
  /** The ICP's own criterion is what admitted the lead on this attribute. */
  | 'VERIFIED';

/** Filter on an encoded global ID field with positive and negative matching. */
export type IdFilterInput = {
  /**
   * When true, a row also matches when the attribute is blank — NULL, an empty
   * string, an empty list, or no related record, depending on the column. The
   * connection edge reports which branch admitted each row via `filterMatches`.
   * Contrast `blank`, which narrows to blank-only rows where this one widens to include them.
   */
  allowBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exact match. */
  eq?: InputMaybe<Scalars['ID']['input']>;
  /** Match any of these values. Maximum 10000 entries. */
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Exclude exact match. */
  notEq?: InputMaybe<Scalars['ID']['input']>;
  /** Exclude any of these values. Maximum 10000 entries. */
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** An IP-to-company identification record. */
export type Identification = Node & {
  __typename?: 'Identification';
  /** Confidence score between 0.0 and 1.0. */
  confidenceScore?: Maybe<Scalars['Float']['output']>;
  /** When the identification was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** The identified IP address. */
  ipAddress: Scalars['String']['output'];
  /** Best matching industry name from provided candidates. */
  matchedIndustry?: Maybe<Scalars['String']['output']>;
  /** The identified organization. */
  organization?: Maybe<Organization>;
  /** When the identification was last updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for Identification. */
export type IdentificationConnection = {
  __typename?: 'IdentificationConnection';
  /**
   * Estimated total number of items across all pages. It comes from the query
   * planner rather than a count, so it costs planning time instead of a scan and
   * cannot exceed the statement timeout. It is approximate at every magnitude,
   * including small ones, and it moves when the table's statistics are refreshed.
   * Accuracy depends on the filter: within a few percent on plain column and
   * array-overlap filters, and as much as 30% out on a range filter such as
   * `companySize`. It is not meaningful for the embedding filters `jobTitle` and
   * `industry` — no statistics exist for a vector-distance predicate, so the
   * estimate ignores the distance threshold entirely and approximates only what
   * the other filters admit; it has been measured reporting 241371 for a filter
   * whose true result was empty. Never render it as an exact figure, and use
   * `totalCount` when the figure has to be exact.
   */
  approximateTotalCount: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IdentificationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Identification>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages, exact unless `upTo` is given. */
  totalCount: Scalars['Int']['output'];
};


/** The connection type for Identification. */
export type IdentificationConnectionTotalCountArgs = {
  upTo?: InputMaybe<Scalars['Int']['input']>;
};

/** An edge in a connection. */
export type IdentificationEdge = Node & {
  __typename?: 'IdentificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Identification>;
};

/** Filter criteria for identifications. */
export type IdentificationFilterInput = {
  /** Filter by confidence score (0.0–1.0). */
  confidenceScore?: InputMaybe<FloatFilterInput>;
  /** Return only matched identifications. */
  valid?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of ImportLinkedinHistory */
export type ImportLinkedinHistoryInput = {
  /** Global id of the account. Must be `RUNNING`. */
  channelAccountId: Scalars['ID']['input'];
  /** Conversations to import. */
  chats?: InputMaybe<Array<LinkedinChatReferenceInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Connection requests to import. */
  invitations?: InputMaybe<Array<LinkedinInvitationReferenceInput>>;
};

/** Autogenerated return type of ImportLinkedinHistory. */
export type ImportLinkedinHistoryPayload = Node & {
  __typename?: 'ImportLinkedinHistoryPayload';
  /** The account the import runs on. */
  channelAccount: ChannelAccount;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** Returned once, at creation. The secret is never retrievable again. */
export type IssuedCredential = {
  __typename?: 'IssuedCredential';
  /** Public half of the credential. Paired with clientSecret below. */
  clientId: Scalars['String']['output'];
  /** Store it now; only its digest is kept, so it cannot be shown again. */
  clientSecret: Scalars['String']['output'];
  credential: ApplicationCredential;
};

/** Returned once, at creation. The code is never retrievable again. */
export type IssuedInvitation = {
  __typename?: 'IssuedInvitation';
  /**
   * Give this to the invitee; they run `acceptCompanyInvitation`. Only its digest
   * is kept, so it cannot be shown again — and whoever holds it can join.
   */
  code: Scalars['String']['output'];
  expiresAt: Scalars['ISO8601DateTime']['output'];
  invitation: CompanyInvitation;
};

/**
 * A single freshness-first lead cap for a Watcher: at most `maximumLeads` events
 * are surfaced per `period`, counted from `startsAt` and reset at every period
 * boundary. Excess events are dropped, never buffered. Combine several caps to
 * constrain multiple periods at once — the most restrictive one wins.
 */
export type LeadCapInput = {
  /** Maximum number of events surfaced per period. Must be greater than zero. */
  maximumLeads: Scalars['Int']['input'];
  /** Length of the accumulation window as an ISO-8601 duration, e.g. P1D (one day) or P1W (one week). */
  period: Scalars['ISO8601Duration']['input'];
  /** Anchor at which the first period begins. Defaults to the moment the cap is created. */
  startsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** A file to attach to a LinkedIn message. The combined size of a message's attachments may not exceed 20 MB, LinkedIn's limit. */
export type LinkedinAttachmentInput = {
  /** The file's bytes, base64-encoded. */
  content: Scalars['String']['input'];
  /** MIME type, e.g. `application/pdf`. */
  contentType: Scalars['String']['input'];
  /** File name shown to the recipient. */
  filename: Scalars['String']['input'];
};

/** Withdraws a connection request the account sent. */
export type LinkedinCancelInvitationInput = {
  /** LinkedIn's id of the request, as `channel_action.completed` returned it for the `LINKEDIN_INVITE` action. */
  invitationId: Scalars['String']['input'];
};

/** A one-to-one LinkedIn conversation Outreach started, or that followed an invitation it sent. */
export type LinkedinChat = Node & {
  __typename?: 'LinkedinChat';
  /** LinkedIn's id of the chat. */
  chatId: Scalars['String']['output'];
  /** When recorded. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The connection request this conversation followed, when there was one. */
  invitation?: Maybe<LinkedinInvitation>;
  /** When the most recent message was sent. */
  lastMessageAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The other participant, as far as the provider told us. */
  member?: Maybe<LinkedinMember>;
  /** The other participant's member id. */
  memberId: Scalars['String']['output'];
};

/** The connection type for LinkedinChat. */
export type LinkedinChatConnection = {
  __typename?: 'LinkedinChatConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LinkedinChatEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LinkedinChat>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LinkedinChatEdge = {
  __typename?: 'LinkedinChatEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LinkedinChat>;
};

/** A conversation the consumer already holds, to import. */
export type LinkedinChatReferenceInput = {
  /** LinkedIn's id of the chat. */
  chatId: Scalars['String']['input'];
  /** The other participant's member id (`ACoAA…`). */
  memberId: Scalars['String']['input'];
  /** The messages the consumer holds for it. */
  messages: Array<LinkedinMessageReferenceInput>;
};

/**
 * The LinkedIn session the account owner is signed in with, as their browser holds
 * it. Either the raw `cookie` header or the `liAt` and `jsessionid` pair.
 */
export type LinkedinCookieCredentialsInput = {
  /**
   * The browser's `Cookie` header value for linkedin.com, carrying at least
   * `li_at` and `JSESSIONID`. Write-only, stored encrypted.
   */
  cookie?: InputMaybe<Scalars['String']['input']>;
  /**
   * ISO 3166-1 alpha-2 country the owner uses LinkedIn from, so the gateway exits
   * from that country. Left out, the exit is not pinned to one.
   */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** The `JSESSIONID` cookie, LinkedIn's CSRF token. Used with `liAt` when `cookie` is not given. */
  jsessionid?: InputMaybe<Scalars['String']['input']>;
  /** The `li_at` cookie, LinkedIn's session token. Used with `jsessionid` when `cookie` is not given. */
  liAt?: InputMaybe<Scalars['String']['input']>;
  /**
   * The browser's User-Agent, so the gateway looks like the device the session was
   * opened on. Left out, a common desktop browser is used.
   */
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The LinkedIn member a channel account is connected as. Read from the provider
 * when the account connects; the member id is the identifier LinkedIn keeps stable.
 */
export type LinkedinIdentity = {
  __typename?: 'LinkedinIdentity';
  /** Name as displayed on LinkedIn. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** First name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** LinkedIn member id (`ACoAA…`), the stable identifier of the person across providers. */
  memberId: Scalars['String']['output'];
  /**
   * Whether the member holds a LinkedIn Premium subscription, as read from the
   * provider when the account connected. Premium accounts are not subject to the
   * monthly cap on invitation notes and get higher invitation quotas. Null when
   * the provider did not say.
   */
  premium?: Maybe<Scalars['Boolean']['output']>;
  /** Public profile URL. */
  profileUrl?: Maybe<Scalars['String']['output']>;
  /** Public identifier, the last segment of the profile URL. */
  publicIdentifier?: Maybe<Scalars['String']['output']>;
};

/** The LinkedIn member an account is for, named by the consumer before any connection confirms it. */
export type LinkedinIdentityInput = {
  /** LinkedIn member id (`ACoAA…`), the identifier LinkedIn keeps stable for a person across providers. */
  memberId: Scalars['String']['input'];
};

/** A connection request sent through Outreach, followed until it settles. */
export type LinkedinInvitation = Node & {
  __typename?: 'LinkedinInvitation';
  /** When the member accepted, as far as Outreach saw it. */
  acceptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The action that sent it. */
  channelAction?: Maybe<ChannelAction>;
  /** The conversation LinkedIn opened once the member accepted. */
  chat?: Maybe<LinkedinChat>;
  /** When recorded. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** LinkedIn's id of the request. */
  invitationId: Scalars['String']['output'];
  /** The invited member (`ACoAA…`). */
  memberId: Scalars['String']['output'];
  /** The note sent with it. */
  note?: Maybe<Scalars['String']['output']>;
  /** When it was sent. */
  sentAt: Scalars['ISO8601DateTime']['output'];
  /** Where it stands. */
  state: LinkedinInvitationState;
  /** When Outreach withdrew it. */
  withdrawnAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for LinkedinInvitation. */
export type LinkedinInvitationConnection = {
  __typename?: 'LinkedinInvitationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LinkedinInvitationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LinkedinInvitation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LinkedinInvitationEdge = {
  __typename?: 'LinkedinInvitationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LinkedinInvitation>;
};

/** Narrows `linkedinInvitations`. */
export type LinkedinInvitationFilterInput = {
  /** Keep only the invitations in these states. */
  state?: InputMaybe<LinkedinInvitationStateFilterInput>;
};

/** A connection request the consumer already holds, to import. */
export type LinkedinInvitationReferenceInput = {
  /** LinkedIn's id of the request. */
  invitationId: Scalars['String']['input'];
  /** The invited member's id (`ACoAA…`). */
  memberId: Scalars['String']['input'];
  /** The note it carried, if known. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** When it was sent, if known. */
  sentAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Where it stands, as far as the consumer knows. */
  state: LinkedinInvitationState;
};

/** Where a connection request stands. One of: pending, accepted, withdrawn, gone. */
export type LinkedinInvitationState =
  /** The member accepted; a chat followed. */
  | 'ACCEPTED'
  /** No longer pending at LinkedIn, for a reason it does not tell (declined, expired). */
  | 'GONE'
  /** Sent, not answered yet. */
  | 'PENDING'
  /** Withdrawn through `linkedinCancelInvitation`. */
  | 'WITHDRAWN';

/** Filter on invitation state (eq/in/notEq/notIn). */
export type LinkedinInvitationStateFilterInput = {
  /** Exact match. */
  eq?: InputMaybe<LinkedinInvitationState>;
  /** Match any of these values. */
  in?: InputMaybe<Array<LinkedinInvitationState>>;
  /** Exclude exact match. */
  notEq?: InputMaybe<LinkedinInvitationState>;
  /** Exclude any of these values. */
  notIn?: InputMaybe<Array<LinkedinInvitationState>>;
};

/**
 * A LinkedIn connection request to one member. Fails at the provider when the
 * member is already a connection or a request is already pending.
 */
export type LinkedinInviteInput = {
  /** LinkedIn member id of the recipient (`ACoAA…`). */
  memberId: Scalars['String']['input'];
  /**
   * Note sent with the request. LinkedIn caps notes at 300 characters and, on free
   * accounts, at a handful of noted requests a month.
   */
  message?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Reads a member's profile as the account: identity, headline, location, network
 * distance, pending connection request, InMail reachability. Reading does not
 * notify the member; `linkedinVisit` does.
 */
export type LinkedinLookupProfileInput = {
  /** Member id (`ACoAA…`) or public identifier (the profile URL's last segment). */
  identifier: Scalars['String']['input'];
  /** Bypass the hour-long cache and read LinkedIn now, against the account's rate limits. */
  noCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A LinkedIn member as seen in a conversation. */
export type LinkedinMember = {
  __typename?: 'LinkedinMember';
  /** Name as displayed on LinkedIn. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** First name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** LinkedIn member id (`ACoAA…`). */
  memberId?: Maybe<Scalars['String']['output']>;
  /** Public profile URL. */
  profileUrl?: Maybe<Scalars['String']['output']>;
  /** Public identifier. */
  publicIdentifier?: Maybe<Scalars['String']['output']>;
};

/** A message in a conversation Outreach follows, the shape `message.received` delivers. */
export type LinkedinMessage = Node & {
  __typename?: 'LinkedinMessage';
  /** `[{ type, mimetype, filename, file_size, url, url_expires_at }]`. */
  attachments: Scalars['JSON']['output'];
  /** The action that sent it, when Outreach did. */
  channelAction?: Maybe<ChannelAction>;
  /** The conversation. */
  chat: LinkedinChat;
  id: Scalars['ID']['output'];
  /** LinkedIn's id of the message. */
  messageId: Scalars['String']['output'];
  /** True when the account sent it. */
  own: Scalars['Boolean']['output'];
  /** Who sent it. */
  sender?: Maybe<LinkedinMember>;
  /** When it was sent. */
  sentAt: Scalars['ISO8601DateTime']['output'];
  /** The message. */
  text?: Maybe<Scalars['String']['output']>;
};

/** The connection type for LinkedinMessage. */
export type LinkedinMessageConnection = {
  __typename?: 'LinkedinMessageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LinkedinMessageEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LinkedinMessage>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LinkedinMessageEdge = {
  __typename?: 'LinkedinMessageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LinkedinMessage>;
};

/** A message of a conversation the consumer already holds, to import. */
export type LinkedinMessageReferenceInput = {
  /** LinkedIn's id of the message. */
  messageId: Scalars['String']['input'];
  /** Whether the account's owner wrote it. */
  own: Scalars['Boolean']['input'];
  /** When it was sent. */
  sentAt: Scalars['ISO8601DateTime']['input'];
  /** Its text, if any. */
  text?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A LinkedIn message to one member. Sent in the existing conversation with that
 * member when there is one, otherwise a new one is started.
 */
export type LinkedinSendMessageInput = {
  /** Files to attach, 20 MB in all at most. */
  attachments?: InputMaybe<Array<LinkedinAttachmentInput>>;
  /** LinkedIn member id of the recipient (`ACoAA…`). */
  memberId: Scalars['String']['input'];
  /** The message. */
  text: Scalars['String']['input'];
};

/**
 * A LinkedIn profile visit: the profile is read as the account, and the member is
 * notified of the visit when their settings allow it.
 */
export type LinkedinVisitInput = {
  /** LinkedIn member id of the profile (`ACoAA…`). */
  memberId: Scalars['String']['input'];
};

/** Federation reference to a Location owned by another subgraph. */
export type Location = Node & {
  __typename?: 'Location';
  /** Numeric hierarchy depth. 0 = country, higher = more granular. */
  adminLevel: Scalars['Int']['output'];
  /**
   * National administrative codes for this division, own codes first, then codes
   * inherited from enclosing divisions — so a locality reports its département's
   * and region's INSEE codes without the caller walking the hierarchy. Each entry
   * names the division it came from via locationId. Empty for divisions in
   * countries without a mapped scheme.
   */
  administrativeCodes: Array<AdministrativeCode>;
  /**
   * Every enclosing division, ordered root-first (highest ancestor first,
   * immediate parent last) so the connection reads as a breadcrumb path. Excludes
   * this location, so a root division returns an empty connection — and so does a
   * freshly imported division whose ancestry is not yet resolved. The two are
   * deliberately indistinguishable here: both mean "no ancestors to walk".
   */
  ancestors: LocationConnection;
  /** Center point of the division boundary as a GeoJSON Point. */
  centroid?: Maybe<Coordinate>;
  /** Child divisions in the hierarchy. */
  children: LocationConnection;
  /** ISO 3166-1 alpha-2 country code of the division. */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** GlobalID-encoded Location id. */
  id: Scalars['ID']['output'];
  /**
   * ISO 3166-2 code of the principal subdivision this division belongs to, e.g.
   * "FR-IDF", "BE-WAL" — the division's own code only on REGION rows; every deeper
   * division carries its enclosing region's. As shipped by Overture; null when the
   * source has none.
   */
  iso31662?: Maybe<Scalars['String']['output']>;
  /**
   * Name in the requested language, e.g. "Luxembourg" for EN where name is
   * "Lëtzebuerg". Falls back to the English name, and then to name, for the
   * divisions the source publishes neither for — so it is always a usable name
   * rather than sometimes null.
   */
  localizedName: Scalars['String']['output'];
  /**
   * Primary name of the division as Overture publishes it, which is the local
   * endonym for a multilingual country — "Lëtzebuerg",
   * "Schweiz/Suisse/Svizzera/Svizra". Read localizedName when the name has to be
   * understood, matched or displayed in one language.
   */
  name: Scalars['String']['output'];
  /** Parent administrative division in the hierarchy. */
  parent?: Maybe<Location>;
  /**
   * Name with its administrative wrapper removed — "Edinburgh" where name is "City
   * of Edinburgh", "Copenhagen" where name is "Københavns Kommune". Read this
   * instead of name when the value is stored or shown as a city: Overture files
   * many cities under their council's name, and persisting that records a city
   * nobody calls it. Identical to name for divisions whose name carries no
   * wrapper, so a caller already storing name keeps the same value for them.
   */
  shortName: Scalars['String']['output'];
  /** Administrative subdivision level. */
  subtype: LocationSubtype;
};


/** Federation reference to a Location owned by another subgraph. */
export type LocationAncestorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Federation reference to a Location owned by another subgraph. */
export type LocationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  deep?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LocationSortInput>>;
  subtype?: InputMaybe<LocationSubtypeFilterInput>;
};


/** Federation reference to a Location owned by another subgraph. */
export type LocationLocalizedNameArgs = {
  language: LocationLanguage;
};


/** Federation reference to a Location owned by another subgraph. */
export type LocationShortNameArgs = {
  language?: InputMaybe<LocationLanguage>;
};

/** The identifier scheme a code passed to `resolveByCode` is expressed in. */
export type LocationCode =
  /** ISO 3166-1 alpha-2 country code (e.g. "BE", "US"). */
  | 'COUNTRY_ISO';

/** The connection type for Location. */
export type LocationConnection = {
  __typename?: 'LocationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LocationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Location>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LocationEdge = {
  __typename?: 'LocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Location>;
};

/**
 * Language a division's name can be rendered in — the locales Sortlist serves, and
 * the only ones every tier is guaranteed to carry a name for.
 */
export type LocationLanguage =
  /** German name of the division. */
  | 'DE'
  /** English name of the division. */
  | 'EN'
  /** Spanish name of the division. */
  | 'ES'
  /** French name of the division. */
  | 'FR'
  /** Italian name of the division. */
  | 'IT'
  /** Dutch name of the division. */
  | 'NL';

/** Fields available for sorting locations. */
export type LocationSortField =
  /**
   * Resident population as shipped by Overture. Null on small or minor divisions,
   * which sort after every populated one regardless of direction.
   */
  | 'POPULATION';

/** Sort configuration for locations. */
export type LocationSortInput = {
  /** Direction to sort in. Defaults to descending. */
  direction?: InputMaybe<SortDirection>;
  /** Field to sort by. */
  field: LocationSortField;
};

/** Administrative subdivision level of a geographic location. */
export type LocationSubtype =
  /** Borough or city district between the locality and neighborhood levels. */
  | 'BOROUGH'
  /** Sovereign nation (admin_level 0). */
  | 'COUNTRY'
  /** County, department, or second-level subdivision (admin_level 3-4). */
  | 'COUNTY'
  /** Dependent or overseas territory of a country. */
  | 'DEPENDENCY'
  /** Local administrative unit such as a commune or municipality, between the county and locality levels. */
  | 'LOCALADMIN'
  /** City, town, or municipality (admin_level 5-8). */
  | 'LOCALITY'
  /**
   * Continent or business macro-region grouping whole countries, above the country
   * level. Its member countries are exposed through `children`, not through
   * `parent` on the country: a country belongs to several macro-countries at once.
   */
  | 'MACROCOUNTRY'
  /** Grouping of counties between the region and county levels. */
  | 'MACROCOUNTY'
  /** Large area grouping multiple neighborhoods within a locality. */
  | 'MACROHOOD'
  /** Grouping of regions between the country and region levels. */
  | 'MACROREGION'
  /** Neighborhood, district, or sub-municipal area (admin_level 9+). */
  | 'NEIGHBORHOOD'
  /** State, province, or first-level subdivision (admin_level 1-2). */
  | 'REGION';

/** Filter on location subtype with schema-validated enum values. */
export type LocationSubtypeFilterInput = {
  /** Exact match. */
  eq?: InputMaybe<LocationSubtype>;
  /** Match any of these subdivision levels. */
  in?: InputMaybe<Array<LocationSubtype>>;
  /** Exclude exact match. */
  notEq?: InputMaybe<LocationSubtype>;
  /** Exclude any of these values. */
  notIn?: InputMaybe<Array<LocationSubtype>>;
};

/**
 * How many contacts one matched organization may yield, and the window that is
 * measured over. Left uncapped a source mints a contact per 10% of the
 * organization's headcount — every one billed, every one pitching the same account.
 */
export type MaximumLeadsPerOrganizationInput = {
  /** Maximum number of contacts one matched organization may yield. Must be greater than zero. Defaults to 2. */
  maximum?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Window the maximum is measured over, as an ISO-8601 duration, e.g. P1D (one
   * day). Bounds how many contacts one organization may yield before the source is
   * reported as having ignored the cap — the source itself is only told the
   * maximum, since it accepts no window. Defaults to P1D.
   */
  period?: InputMaybe<Scalars['ISO8601Duration']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Joins the authenticated caller. The only management mutation a non-member may call. */
  acceptCompanyInvitation?: Maybe<Company>;
  /**
   * Starts one authentication attempt on a channel account, in the shape its
   * provider requires: a hosted sign-in page the owner is sent to (`returnUrl`),
   * or credentials the consumer collected and passes along (`credentials`). Works
   * on a draft account and on a connected or disconnected one alike:
   * re-authenticating is the same call. The account stays in its current status
   * until the identity is read; the outcome arrives as a
   * `channel_account.connected` event.
   */
  authenticateChannelAccount?: Maybe<AuthenticateChannelAccountPayload>;
  /**
   * Cancels all of a billing customer's active subscriptions immediately. Used
   * when the owning company is destroyed. Idempotent.
   */
  cancelBillingCustomerSubscriptions?: Maybe<CancelBillingCustomerSubscriptionsPayload>;
  /**
   * Cancels the subscription's pending scheduled plan change (see
   * BillingSubscription.pendingChange) before it applies at the next bill date.
   * Free of charge — the subscription keeps its current plan. Errors when no
   * change is pending.
   */
  cancelBillingSubscriptionChange?: Maybe<CancelBillingSubscriptionChangePayload>;
  /**
   * Ends the subscription immediately, forfeiting the rest of the paid period.
   * Billing offers no cancel-at-period-end, so this exists for a subscription on a
   * withdrawn plan, which cannot be changed instead.
   */
  cancelCompanySubscription?: Maybe<Company>;
  /**
   * Changes a subscription's plan or periodicity. Unset arguments preserve the
   * current value. Upgrades are invoiced immediately with proration and grant the
   * prorated credit share; downgrades and lateral moves are SCHEDULED at the next
   * bill date (surfaced as BillingSubscription.pendingChange, cancelable for free
   * via cancelBillingSubscriptionChange) — the current plan's credits and limits
   * stay in force until then. Re-targeting the current plan cancels a pending change.
   */
  changeBillingSubscription?: Maybe<ChangeBillingSubscriptionPayload>;
  /**
   * Moves an existing subscription to another plan or periodicity. Upgrades
   * invoice immediately with prorated credits; downgrades are scheduled at the
   * next bill date and readable as `pendingChange` until they apply.
   */
  changeCompanySubscription?: Maybe<Company>;
  createApplication?: Maybe<Application>;
  /** Returns the secret exactly once. */
  createApplicationCredential?: Maybe<IssuedCredential>;
  /** Creates a hosted Stripe Checkout session for a new subscription and returns the URL the frontend redirects to. */
  createBillingCheckoutSession?: Maybe<CreateBillingCheckoutSessionPayload>;
  /** Creates a billing customer + matching Stripe customer. Caller stores the returned id. */
  createBillingCustomer?: Maybe<CreateBillingCustomerPayload>;
  /**
   * Creates an embedded Stripe Checkout session for a new subscription and returns
   * the clientSecret the frontend passes to Stripe.js.
   */
  createBillingEmbeddedCheckoutSession?: Maybe<CreateBillingEmbeddedCheckoutSessionPayload>;
  /** Creates a Stripe Customer Portal session and returns the hosted URL the frontend redirects to. */
  createBillingPortalSession?: Maybe<CreateBillingPortalSessionPayload>;
  /**
   * Registers a channel account as a draft on a provider of the channel: the one
   * named in `provider`, or the channel's default when none is. Nothing reaches
   * the provider yet: the account is connected by a later authentication step,
   * whose shape depends on the provider. The consumer stores the returned id
   * before any event can arrive.
   */
  createChannelAccount?: Maybe<CreateChannelAccountPayload>;
  createCompany?: Maybe<Company>;
  /** Opens Stripe's hosted portal for card replacement and invoice history. */
  createCompanyBillingPortalSession?: Maybe<BillingPortalSession>;
  /**
   * Subscribes a company to a plan. Billing is never reached directly by a caller:
   * it checks no tenancy of its own, so every write that spends a company's money
   * goes through a membership check here first.
   */
  createCompanyCheckoutSession?: Maybe<BillingCheckoutSession>;
  /**
   * A security grant: whoever redeems the code gains full control of every
   * application and credential the company owns. Refused for a personal company —
   * create a shared one.
   */
  createCompanyInvitation?: Maybe<IssuedInvitation>;
  /** Create a new enrichment source. */
  createSource?: Maybe<Source>;
  /**
   * Create a Watcher for a given Definition. All providers registered on the
   * Definition are auto-provisioned; the user does not choose providers.
   *
   * By default every provider is set up before this mutation returns, so the
   * Watcher comes back `PROVISIONED` and a provider refusing the request fails the
   * call. Pass `async: true` to instead have the Watcher persisted immediately as
   * `PENDING` and provisioned in the background — a provider outage then delays
   * provisioning rather than failing creation. See `async`.
   *
   * There is no mutation to change a Watcher's `watcherInput` or `icp` afterwards,
   * by design. Both determine *which leads the Watcher returns*, and a Watcher is
   * shared: callers with the same definition and input attach their own webhook to
   * one row, so editing it in place would silently repoint every other webhook
   * attached to it. Those fields are also what the Watcher is keyed on, so
   * changing them means becoming a different Watcher.
   *
   * To change what a Watcher returns, call `createWatcher` again with the new
   * input — an existing match is reused, otherwise a new Watcher is provisioned —
   * then `deleteWatcher` the old one if nothing else needs it.
   * `updateWatcherLeadCaps` and `setWebhookActive` remain available: they bound
   * volume and delivery, not which leads qualify.
   */
  createWatcher?: Maybe<CreateWatcherPayload>;
  /**
   * Draws credits for in-app usage. Idempotent per consumable: a replay for an
   * already-paid consumableType/consumableId returns the original debits as a
   * success instead of drawing again. Returns success=false with
   * errorCode=insufficient_credits when the balance can't cover the cost; raises a
   * GraphQL error if the billingCustomerId is unknown.
   */
  debitCredits?: Maybe<DebitCreditsPayload>;
  deleteApplication?: Maybe<Application>;
  /**
   * Hard-deletes a billing customer and its Stripe customer. Used to compensate a
   * failed sales-offer creation. Refuses a customer that has subscriptions,
   * invoices, credits, or debits.
   */
  deleteBillingCustomer?: Maybe<DeleteBillingCustomerPayload>;
  deleteCompany?: Maybe<Company>;
  /**
   * Cancel a Watcher and tear down its external provider resources. The
   * cancellation is immediate; the external teardown runs asynchronously and is
   * retried across provider outages. Events are preserved.
   */
  deleteWatcher?: Maybe<DeleteWatcherPayload>;
  deviceAuthorize?: Maybe<DeviceCodeResponse>;
  deviceToken?: Maybe<TokenResponse>;
  /**
   * Removes a channel account for good: it becomes `REMOVED` and disappears from
   * `channelAccount` at once; the provider's connection is deleted in the
   * background and, once the provider has confirmed, the consumer receives
   * `channel_account.removed`. Idempotent: removing a removed account changes
   * nothing. To use the same identity again, register a new account.
   */
  disconnectChannelAccount?: Maybe<DisconnectChannelAccountPayload>;
  /**
   * Asynchronously merge a raw source payload into the contact record, applying the source's
   * trust score to resolve field conflicts, then recompute the confidence score.
   * Returns `{status: "received"}` immediately; the merged Contact arrives via the
   * `contactEnrichmentResult(externalId:)` subscription, so pass an `externalId` and
   * subscribe before calling.
   * Use when pushing enrichment data from a registered source.
   * To discover a contact from a known identifier (email, LinkedIn, name) without raw
   * source data, use `searchContact` instead.
   */
  enrichContact?: Maybe<EnrichContactPayload>;
  /**
   * Asynchronously store or update an IP-to-company identification record from a source
   * payload. Returns `{status: "received"}` immediately.
   * Unlike `enrichContact` and `enrichOrganization` there is no result subscription for this
   * one, so a caller learns only that the push was accepted; failures are logged and
   * reported to Sentry rather than broadcast.
   * Use when a source (e.g. Snitcher) has already resolved an IP to a company domain
   * and you want to persist that result. To trigger async resolution from an IP address,
   * use `searchOrganization` with `ip:` instead.
   */
  enrichIdentification?: Maybe<EnrichIdentificationPayload>;
  /**
   * Asynchronously merge a raw source payload into the organization record, applying the
   * source's trust score to resolve field conflicts, then recompute the confidence score.
   * Returns `{status: "received"}` immediately; the merged Organization arrives via the
   * `organizationEnrichmentResult(externalId:)` subscription, so pass an `externalId` and
   * subscribe before calling.
   * Use when pushing enrichment data from a registered source.
   * To look up an existing organization without writing data, use `organization(domain:)` instead.
   */
  enrichOrganization?: Maybe<EnrichOrganizationPayload>;
  /**
   * Brings a consumer's existing LinkedIn history under Outreach's watch: the
   * conversations, messages and connection requests it passes are stored as the
   * consumer holds them, then followed like the ones Outreach started. Nothing is
   * read from the provider. Accepted and run in the background;
   * `linkedin_import.completed` reports the counts. Meant for a consumer's first
   * connection of an account, under a scope of its own.
   */
  importLinkedinHistory?: Maybe<ImportLinkedinHistoryPayload>;
  /**
   * Asks the gateway to perform one action on a connected account. The action is
   * accepted and executed in the background; its outcome reaches the consumer as
   * `channel_action.completed` or `channel_action.failed`. Repeating the call with
   * the same `externalId` — or, when none is given, with the same account and
   * input — returns the accepted action instead of performing it again.
   */
  performChannelAction?: Maybe<PerformChannelActionPayload>;
  refreshToken?: Maybe<TokenResponse>;
  /** Also revokes every credential that member created for this company's applications, in one transaction. */
  removeCompanyMember?: Maybe<Company>;
  /** Effective immediately for new token requests; tokens already issued remain valid until they expire. */
  revokeApplicationCredential?: Maybe<ApplicationCredential>;
  revokeCompanyInvitation?: Maybe<CompanyInvitation>;
  /** Runs a background job inline. Admin-only, intended for E2E test orchestration. */
  runSignalsSynchronousWorker?: Maybe<RunSignalsSynchronousWorkerPayload>;
  /** Run a background job inline. Admin-only, intended for E2E test orchestration. */
  runSynchronousWorker?: Maybe<RunSynchronousWorkerPayload>;
  /**
   * Asynchronously discover an Atlas Contact record.
   * Returns `{status: "received"}` immediately. The result arrives via
   * the `contactIdentifyResult(externalId:)` subscription.
   * Provide exactly one lookup mode via `lookup`:
   * `contactId`, `linkedinUrl`, `emailAddress`, or `name`.
   */
  searchContact?: Maybe<SearchContactPayload>;
  /**
   * Synchronously discover a contact's phone number through Airscale and merge it into
   * the contact record. Unlike `searchContact` this one blocks and answers on the same
   * round trip, so no subscription is involved.
   * Supply `contactId` when you hold one, otherwise `linkedinUrl`. A LinkedIn URL Atlas
   * has not seen before is identified first, through the same strategy `searchContact`
   * leads with, so the lookup does not require the person to be known already; it
   * answers `contact_not_found` only when identification fails too. Airscale is keyed
   * on the LinkedIn profile, so a contact carrying none answers `missing_linkedin_url`.
   * A number already known is re-validated at most once per the source's revalidation
   * period; inside it the cached number is returned without calling Airscale.
   * A `linkedinUrl` that is not a LinkedIn profile URL is refused with
   * `INVALID_INTERACTION` rather than answered as `contact_not_found`, so bad input stays
   * distinguishable from a genuine miss.
   */
  searchContactPhone?: Maybe<SearchContactPhonePayload>;
  /**
   * Asynchronously searches for contacts matching `filter`/`organizationFilter`, the
   * same criteria accepted by the `contacts` query — but in addition to the local
   * database, this also searches Atlas's third-party sources (currently Coresignal)
   * and persists any new matches as Contact records.
   * Returns `{status: "received"}` immediately. The result arrives via the
   * `contactSearchResult(externalId:)` subscription, as a paginated connection —
   * further pages beyond the first are fetched via the `contacts` query using the
   * same filter.
   */
  searchContacts?: Maybe<SearchContactsPayload>;
  /**
   * Asynchronously search for an organization by domain or visitor IP.
   * Returns {status: "received"} immediately. The matched Organization arrives via
   * the `organizationSearchResult(externalId:)` subscription.
   * Provide exactly one lookup mode via `lookup`: either `domain` or `byIp`.
   * A `lookup.domain` that is not a resolvable hostname is rejected up front with
   * `INVALID_INTERACTION` and no work is queued.
   */
  searchOrganization?: Maybe<SearchOrganizationPayload>;
  /**
   * Activate or pause delivery for a single webhook on a Watcher. The upstream
   * source's emitting state is reconciled asynchronously, so the call succeeds
   * even while the provider is unreachable. Does not deprovision — the
   * subscription, webhook, and config are preserved.
   */
  setWebhookActive?: Maybe<SetWebhookActivePayload>;
  /** Manually fire an ingestion run for a Watcher. Rejects pure-webhook strategies. */
  triggerWatcher?: Maybe<TriggerWatcherPayload>;
  /** Update an existing enrichment source. */
  updateSource?: Maybe<Source>;
  /**
   * Replace the freshness-first per-period lead caps on a Watcher. The new caps
   * take effect in-house immediately and are propagated to Rodz-backed signals as
   * their per-day limit.
   */
  updateWatcherLeadCaps?: Maybe<UpdateWatcherLeadCapsPayload>;
  /**
   * Asynchronously validate that the supplied name, email, and phone are internally consistent
   * for a contact at the given organization.
   * Returns `{status: "received"}` immediately. Per-field coherence flags arrive via
   * the `contactValidationResult(externalId:)` subscription.
   */
  validateContact?: Maybe<ValidateContactPayload>;
  /**
   * Asynchronously validate that the supplied company field values are coherent with
   * Atlas's stored data for the given domain.
   * Returns `{status: "received"}` immediately. Per-field coherence flags arrive via
   * the `domainValidationResult(externalId:)` subscription.
   * A `domain` that is not a resolvable hostname is rejected up front with
   * `INVALID_INTERACTION` and no work is queued.
   */
  validateDomain?: Maybe<ValidateDomainPayload>;
};


export type MutationAcceptCompanyInvitationArgs = {
  input: AcceptCompanyInvitationInput;
};


export type MutationAuthenticateChannelAccountArgs = {
  input: AuthenticateChannelAccountInput;
};


export type MutationCancelBillingCustomerSubscriptionsArgs = {
  input: CancelBillingCustomerSubscriptionsInput;
};


export type MutationCancelBillingSubscriptionChangeArgs = {
  input: CancelBillingSubscriptionChangeInput;
};


export type MutationCancelCompanySubscriptionArgs = {
  input: CancelCompanySubscriptionInput;
};


export type MutationChangeBillingSubscriptionArgs = {
  input: ChangeBillingSubscriptionInput;
};


export type MutationChangeCompanySubscriptionArgs = {
  input: ChangeCompanySubscriptionInput;
};


export type MutationCreateApplicationArgs = {
  input: CreateApplicationInput;
};


export type MutationCreateApplicationCredentialArgs = {
  input: CreateApplicationCredentialInput;
};


export type MutationCreateBillingCheckoutSessionArgs = {
  input: CreateBillingCheckoutSessionInput;
};


export type MutationCreateBillingCustomerArgs = {
  input: CreateBillingCustomerInput;
};


export type MutationCreateBillingEmbeddedCheckoutSessionArgs = {
  input: CreateBillingEmbeddedCheckoutSessionInput;
};


export type MutationCreateBillingPortalSessionArgs = {
  input: CreateBillingPortalSessionInput;
};


export type MutationCreateChannelAccountArgs = {
  input: CreateChannelAccountInput;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateCompanyBillingPortalSessionArgs = {
  input: CreateCompanyBillingPortalSessionInput;
};


export type MutationCreateCompanyCheckoutSessionArgs = {
  input: CreateCompanyCheckoutSessionInput;
};


export type MutationCreateCompanyInvitationArgs = {
  input: CreateCompanyInvitationInput;
};


export type MutationCreateSourceArgs = {
  input: CreateSourceInput;
};


export type MutationCreateWatcherArgs = {
  input: CreateWatcherInput;
};


export type MutationDebitCreditsArgs = {
  input: DebitCreditsInput;
};


export type MutationDeleteApplicationArgs = {
  input: DeleteApplicationInput;
};


export type MutationDeleteBillingCustomerArgs = {
  input: DeleteBillingCustomerInput;
};


export type MutationDeleteCompanyArgs = {
  input: DeleteCompanyInput;
};


export type MutationDeleteWatcherArgs = {
  input: DeleteWatcherInput;
};


export type MutationDeviceAuthorizeArgs = {
  input: DeviceAuthorizeInput;
};


export type MutationDeviceTokenArgs = {
  input: DeviceTokenInput;
};


export type MutationDisconnectChannelAccountArgs = {
  input: DisconnectChannelAccountInput;
};


export type MutationEnrichContactArgs = {
  input: EnrichContactInput;
};


export type MutationEnrichIdentificationArgs = {
  input: EnrichIdentificationInput;
};


export type MutationEnrichOrganizationArgs = {
  input: EnrichOrganizationInput;
};


export type MutationImportLinkedinHistoryArgs = {
  input: ImportLinkedinHistoryInput;
};


export type MutationPerformChannelActionArgs = {
  input: PerformChannelActionInput;
};


export type MutationRefreshTokenArgs = {
  input: RefreshTokenInput;
};


export type MutationRemoveCompanyMemberArgs = {
  input: RemoveCompanyMemberInput;
};


export type MutationRevokeApplicationCredentialArgs = {
  input: RevokeApplicationCredentialInput;
};


export type MutationRevokeCompanyInvitationArgs = {
  input: RevokeCompanyInvitationInput;
};


export type MutationRunSignalsSynchronousWorkerArgs = {
  input: RunSignalsSynchronousWorkerInput;
};


export type MutationRunSynchronousWorkerArgs = {
  input: RunSynchronousWorkerInput;
};


export type MutationSearchContactArgs = {
  input: SearchContactInput;
};


export type MutationSearchContactPhoneArgs = {
  input: SearchContactPhoneInput;
};


export type MutationSearchContactsArgs = {
  input: SearchContactsInput;
};


export type MutationSearchOrganizationArgs = {
  input: SearchOrganizationInput;
};


export type MutationSetWebhookActiveArgs = {
  input: SetWebhookActiveInput;
};


export type MutationTriggerWatcherArgs = {
  input: TriggerWatcherInput;
};


export type MutationUpdateSourceArgs = {
  input: UpdateSourceInput;
};


export type MutationUpdateWatcherLeadCapsArgs = {
  input: UpdateWatcherLeadCapsInput;
};


export type MutationValidateContactArgs = {
  input: ValidateContactInput;
};


export type MutationValidateDomainArgs = {
  input: ValidateDomainInput;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

/** A company or organization identified and enriched from multiple data sources. */
export type Organization = Node & {
  __typename?: 'Organization';
  /** Annual revenue range in USD (e.g. [1000000, 5000000]). */
  annualRevenue?: Maybe<Scalars['Range']['output']>;
  /** Employee count range (e.g. [10, 50]). */
  companySize?: Maybe<Scalars['Range']['output']>;
  /** Confidence score (0.0–1.0) from source quality, freshness, and diversity. */
  confidenceScore?: Maybe<Scalars['Float']['output']>;
  /** General contact email address. */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** Known contacts at this organization. */
  contacts: ContactConnection;
  /** ISO 3166-1 alpha-2 country code of the primary location. */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** When the organization record was first created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Short company description or tagline. */
  description?: Maybe<Scalars['String']['output']>;
  /** Primary web domain (unique identifier for deduplication). */
  domain: Scalars['String']['output'];
  /** When the domain was last verified as reachable. */
  domainReachableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Year the company was founded. */
  foundedYear?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Primary industry classification. */
  industry?: Maybe<Scalars['String']['output']>;
  /** Whether the LinkedIn page is claimed by the organization. */
  linkedinClaimed?: Maybe<Scalars['Boolean']['output']>;
  /** LinkedIn company page URL. */
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  /** URL to the organization's logo image. */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Legal or trade name. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Physical office locations.
   * @deprecated Use organization_addresses instead.
   */
  offices: Array<OrganizationAddress>;
  /** Physical addresses. */
  organizationAddresses: OrganizationAddressConnection;
  /** Main phone number. */
  phone?: Maybe<Scalars['String']['output']>;
  /** When the organization record was last modified. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Unique identifier (UUID) for this organization. */
  uuid: Scalars['String']['output'];
  /** Company website URL. */
  website?: Maybe<Scalars['String']['output']>;
};


/** A company or organization identified and enriched from multiple data sources. */
export type OrganizationContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ContactFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ContactSortInput>>;
};


/** A company or organization identified and enriched from multiple data sources. */
export type OrganizationOrganizationAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isHeadquarters?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<OrganizationAddressKind>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A physical address of an organization. */
export type OrganizationAddress = Node & {
  __typename?: 'OrganizationAddress';
  /** City where the office is located. */
  city?: Maybe<Scalars['String']['output']>;
  /** Geographic coordinates of the address as a GeoJSON Point. */
  coordinates?: Maybe<Coordinate>;
  /** ISO 3166-1 alpha-2 country code. */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Human-readable country name derived from country_code. */
  countryName?: Maybe<Scalars['String']['output']>;
  /** When the address was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /**
   * Whether this is the organization's headquarters.
   * @deprecated Use `kind == HEADQUARTERS` instead.
   */
  isHeadquarters: Scalars['Boolean']['output'];
  /** Classification of this address: headquarters, office, or unattended. */
  kind: OrganizationAddressKind;
  /** Mercator location divisions for this office address. Empty until the background enrichment job runs. */
  locations: LocationConnection;
  /** Postal or ZIP code. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** State or province. */
  state?: Maybe<Scalars['String']['output']>;
  /** Street address. */
  street?: Maybe<Scalars['String']['output']>;
  /** When the address was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** A physical address of an organization. */
export type OrganizationAddressLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for OrganizationAddress. */
export type OrganizationAddressConnection = {
  __typename?: 'OrganizationAddressConnection';
  /**
   * Estimated total number of items across all pages. It comes from the query
   * planner rather than a count, so it costs planning time instead of a scan and
   * cannot exceed the statement timeout. It is approximate at every magnitude,
   * including small ones, and it moves when the table's statistics are refreshed.
   * Accuracy depends on the filter: within a few percent on plain column and
   * array-overlap filters, and as much as 30% out on a range filter such as
   * `companySize`. It is not meaningful for the embedding filters `jobTitle` and
   * `industry` — no statistics exist for a vector-distance predicate, so the
   * estimate ignores the distance threshold entirely and approximates only what
   * the other filters admit; it has been measured reporting 241371 for a filter
   * whose true result was empty. Never render it as an exact figure, and use
   * `totalCount` when the figure has to be exact.
   */
  approximateTotalCount: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganizationAddressEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OrganizationAddress>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages, exact unless `upTo` is given. */
  totalCount: Scalars['Int']['output'];
};


/** The connection type for OrganizationAddress. */
export type OrganizationAddressConnectionTotalCountArgs = {
  upTo?: InputMaybe<Scalars['Int']['input']>;
};

/** An edge in a connection. */
export type OrganizationAddressEdge = Node & {
  __typename?: 'OrganizationAddressEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganizationAddress>;
};

/** Classification of an organization address. */
export type OrganizationAddressKind =
  /** The organization's elected headquarters. */
  | 'HEADQUARTERS'
  /** A staffed office or branch location. */
  | 'OFFICE'
  /** A location with no on-site staff (e.g. an ATM or EV charging station). */
  | 'UNATTENDED';

/** Parameters for an organization search by visitor IP address. */
export type OrganizationByIpInput = {
  /** Visitor's ISO 3166-1 alpha-2 country code — boosts matching accuracy. */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** The visitor's IPv4 or IPv6 address to identify. */
  ip: Scalars['String']['input'];
};

/** The connection type for Organization. */
export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  /**
   * Estimated total number of items across all pages. It comes from the query
   * planner rather than a count, so it costs planning time instead of a scan and
   * cannot exceed the statement timeout. It is approximate at every magnitude,
   * including small ones, and it moves when the table's statistics are refreshed.
   * Accuracy depends on the filter: within a few percent on plain column and
   * array-overlap filters, and as much as 30% out on a range filter such as
   * `companySize`. It is not meaningful for the embedding filters `jobTitle` and
   * `industry` — no statistics exist for a vector-distance predicate, so the
   * estimate ignores the distance threshold entirely and approximates only what
   * the other filters admit; it has been measured reporting 241371 for a filter
   * whose true result was empty. Never render it as an exact figure, and use
   * `totalCount` when the figure has to be exact.
   */
  approximateTotalCount: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganizationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Organization>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages, exact unless `upTo` is given. */
  totalCount: Scalars['Int']['output'];
};


/** The connection type for Organization. */
export type OrganizationConnectionTotalCountArgs = {
  upTo?: InputMaybe<Scalars['Int']['input']>;
};

/** An edge in a connection. */
export type OrganizationEdge = Node & {
  __typename?: 'OrganizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /**
   * One entry per filter constrained on this query, reporting whether this
   * organization matched on the attribute's value or on its absence. Empty when
   * the connection was resolved without a filter.
   */
  filterMatches: Array<FilterMatch>;
  id: Scalars['ID']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Organization>;
};

/** Autogenerated return type of OrganizationEnrichmentResult. */
export type OrganizationEnrichmentResultPayload = {
  __typename?: 'OrganizationEnrichmentResultPayload';
  externalId: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
};

/** Filter criteria for organizations. */
export type OrganizationFilterInput = {
  /**
   * Filter on the organization's employee-count range. Use `overlaps` with a
   * [min, max] range (a one-element [min] array means open-ended) — e.g.
   * { overlaps: [0, 100] } for "fewer than 100 employees", { overlaps: [1000] }
   * for "1000+". Callers targeting several buckets pass a single merged range.
   */
  companySize?: InputMaybe<RangeFilterInput>;
  /** Filter by confidence score (0.0–1.0). */
  confidenceScore?: InputMaybe<FloatFilterInput>;
  /**
   * Description embedding filters. Each entry matches organizations whose
   * description is semantically close to the query. Use a rich phrase rather
   * than a single keyword — e.g. "B2B SaaS platform for sales teams" — for a
   * strong centroid. For several distinct concepts, list them in `queries`
   * rather than joining them into one string: each keeps its own centroid,
   * where one merged string averages them into a vector that may match none
   * of them well. Entries AND with each other.
   * Set `match` rather than a raw `distance`: INCLUDED_STRICT resolves to
   * 0.55 (text-embedding-3-small) and INCLUDED_LOOSE to 0.60, measured in the
   * native 1536-dimension space — this axis carries no projection.
   * Thresholds validated by the embedding_calibration test suite.
   * Maximum 25 entries.
   */
  description?: InputMaybe<Array<EmbeddingFilterInput>>;
  /**
   * Filter organizations that have at least one address belonging to any of the
   * given Mercator location division IDs. `eq`/`in` match organizations with at
   * least one overlapping division; `not_eq`/`not_in` exclude them. This is an
   * array-overlap filter against Mercator-encoded division IDs, not a scalar Atlas ID filter.
   */
  divisionIds?: InputMaybe<IdFilterInput>;
  /**
   * Filter on the organization's domain. Values are matched against a normalized
   * form — host downcased, a single leading "www." dropped — so `eq:
   * "https://www.Acme.com/about"` matches a stored "acme.com". Matching is exact
   * after that normalization, not a substring or suffix search, and no further
   * subdomain stripping happens, so "barla.synlab.fr" and "synlab.fr" stay
   * distinct organizations. `domain` is unique, so a positive `eq` matches at
   * most one record. A value that cannot yield a host (a bare company name, an IP
   * literal, punctuation) matches no organization rather than silently dropping
   * the constraint — so passing a mixed name/domain list here returns only its
   * domain-shaped entries instead of the whole table. Prefer this for a read-only
   * "which of these organizations do we already have?" lookup over a list — it
   * normalizes and batches through `in`. `organization(domain:)` is the
   * single-record equivalent but matches the column raw, so it misses any URL
   * form; `searchOrganization(input: { domain: ... })` is the enriching
   * counterpart and will call paid providers on a miss.
   */
  domain?: InputMaybe<StringFilterInput>;
  /** Filter by organization global id. */
  id?: InputMaybe<IdFilterInput>;
  /**
   * Industry embedding filters. Each entry matches organizations whose
   * industry is semantically close to the query. List related sectors in
   * `queries` (e.g. ["Marketing Agency", "Digital Agency", "PR Agency"]) to
   * match any of them. Multilingual queries work: adding translations
   * (e.g. "Agence Marketing", "Marketingagentur") widens recall. Entries AND
   * with each other.
   * Set `match` rather than a raw `distance`: this axis is measured in its
   * fitted 512-dimension projection, so its calibrated operating point is
   * 0.777 (text-embedding-3-small) and not the native-space 0.60 — a number a
   * caller cannot derive, and one that moves with every refit.
   * INCLUDED_STRICT resolves to 0.777, INCLUDED_LOOSE to 0.7811; both sit
   * inside the defensible 0.7687-0.7852 interval.
   * Thresholds validated by the embedding_calibration test suite.
   * Maximum 25 entries.
   */
  industry?: InputMaybe<Array<EmbeddingFilterInput>>;
  /**
   * Filter on the organization's LinkedIn company page. Values are matched on
   * the company vanity slug, extracted from both sides of the comparison, so
   * `eq: "http://fr.linkedin.com/company/acme/?trk=x"` matches a stored
   * "https://www.linkedin.com/company/acme". Slug matching is what makes this
   * usable: unlike `domain` and `name`, the stored URL is never normalized on
   * write, so any URL form may be on file. A slug is globally unique on
   * LinkedIn, so a positive `eq` matches at most one organization. Only the
   * first path segment identifies the company, so a sub-page link resolves the
   * company itself — `eq: ".../company/acme/about/"` matches a stored
   * ".../company/acme", and a stored sub-page URL is matched by the plain
   * company URL. Percent-encoded and literal non-ASCII slugs are the same page
   * ("/company/ko%C3%A7-holding" matches a stored "/company/koç-holding" and
   * the reverse). The slug is **case-sensitive** — scheme, host, sub-pages,
   * percent-encoding and trailing punctuation are normalized away, but
   * "/company/Acme" and "/company/acme" are two different pages, so pass the
   * slug exactly as LinkedIn spells it. A value yielding no company
   * slug (a `/in/` person profile, a bare slug, a school or showcase page, a
   * non-LinkedIn URL) matches no organization rather than silently dropping the
   * constraint. `presence: true` is a check on the raw column — it returns
   * organizations that have any LinkedIn URL on file, even one this filter's
   * `eq` could not parse — and applies independently of `valid`, so combine
   * `valid: false` with it to reach organizations reachable on LinkedIn but
   * below the quality floor. Note that `notEq`/`notIn` also exclude
   * organizations with no LinkedIn URL at all, matching how every other
   * negative string operator in this schema treats NULL.
   */
  linkedin?: InputMaybe<StringFilterInput>;
  /**
   * Filter on the organization's name. Values are matched against a
   * normalized form — transliterated, downcased, punctuation-stripped and
   * with trailing legal-form tokens dropped — so `eq: "Acme"` matches a
   * stored "ACME, Inc." and `eq: "Sortlist NV/SA"` matches a stored
   * "Sortlist". Matching stays exact *after* that normalization: it is not
   * a substring or fuzzy search, so "Acme" does not match "Acme Widgets".
   * A name is not unique in Atlas (country subsidiaries, "<brand> SA" /
   * "<brand> NV" pairs), so every match is returned, ordered by the
   * connection's default confidence_score DESC — use
   * `searchOrganization(input: { domain: ... })` instead when the caller has
   * a domain and needs exactly one record. A value that normalizes to
   * nothing (punctuation only) matches no organization rather than silently
   * dropping the constraint. `presence: true` returns only organizations
   * that have a name, re-expressing `valid`'s name floor on its own, so
   * callers passing `valid: false` can keep it without the confidence and
   * domain-reachability floors.
   */
  name?: InputMaybe<StringFilterInput>;
  /** Return only complete records. */
  valid?: InputMaybe<Scalars['Boolean']['input']>;
};

/** OneOf input for searchOrganization — supply exactly one lookup mode. */
export type OrganizationLookupInput = {
  /** Look up by visitor IP address. */
  byIp?: InputMaybe<OrganizationByIpInput>;
  /** Look up by company's primary web domain (no scheme, no trailing slash). */
  domain?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of OrganizationSearchResult. */
export type OrganizationSearchResultPayload = {
  __typename?: 'OrganizationSearchResultPayload';
  externalId: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
};

/** Fields available for sorting organizations. */
export type OrganizationSortField =
  /** Sort by merged confidence score, highest first by default. */
  | 'CONFIDENCE_SCORE'
  /** Sort by creation timestamp. */
  | 'CREATED_AT'
  /** Cosine distance from the description embedding. Requires query. */
  | 'DESCRIPTION_DISTANCE'
  /** Cosine distance from the industry embedding. Requires query. */
  | 'INDUSTRY_DISTANCE'
  /** Sort alphabetically by legal or trade name. */
  | 'NAME';

/** Sort configuration for organizations. */
export type OrganizationSortInput = {
  direction?: InputMaybe<SortDirection>;
  field: OrganizationSortField;
  /** Required when field is DESCRIPTION_DISTANCE or INDUSTRY_DISTANCE. Text to embed for distance ordering. */
  query?: InputMaybe<Scalars['String']['input']>;
};

/** One event the gateway sent, or is sending, to the consumer's webhook. */
export type OutboundEvent = Node & {
  __typename?: 'OutboundEvent';
  /** How many deliveries were tried. */
  attempts: Scalars['Int']['output'];
  /** The account the event is about. */
  channelAccount: ChannelAccount;
  /** When the gateway recorded the event. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** When the gateway gave up delivering it. */
  deadAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the consumer's webhook accepted it. */
  deliveredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The type the consumer receives, one of the events documented in the API reference (`channel_action.completed`, …). */
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** HTTP status of the last delivery attempt. */
  lastResponseStatus?: Maybe<Scalars['Int']['output']>;
  /** When the thing the event reports happened. */
  occurredAt: Scalars['ISO8601DateTime']['output'];
  /** The event's payload, as delivered. */
  payload: Scalars['JSON']['output'];
  /** Where the delivery stands. */
  state: OutboundEventState;
};

/** The connection type for OutboundEvent. */
export type OutboundEventConnection = {
  __typename?: 'OutboundEventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OutboundEventEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OutboundEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OutboundEventEdge = {
  __typename?: 'OutboundEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OutboundEvent>;
};

/** Narrows `outboundEvents`. */
export type OutboundEventFilterInput = {
  /** Keep only these event types, as the consumer receives them (`channel_action.failed`, `message.received`, …). */
  eventType?: InputMaybe<StringFilterInput>;
  /** Keep only the events in these delivery states. */
  state?: InputMaybe<OutboundEventStateFilterInput>;
};

/** Where an event stands on its way to the consumer's webhook. One of: pending, delivered, dead. */
export type OutboundEventState =
  /** Given up: the webhook refused it (4xx) or failed eight times. */
  | 'DEAD'
  /** The consumer's webhook answered 2xx. */
  | 'DELIVERED'
  /** Not delivered yet; the gateway is still trying. */
  | 'PENDING';

/** Filter on an event's delivery state (eq/in/notEq/notIn). Derived from `deliveredAt` and `deadAt`, not a column. */
export type OutboundEventStateFilterInput = {
  /** Exact match. */
  eq?: InputMaybe<OutboundEventState>;
  /** Match any of these values. */
  in?: InputMaybe<Array<OutboundEventState>>;
  /** Exclude exact match. */
  notEq?: InputMaybe<OutboundEventState>;
  /** Exclude any of these values. */
  notIn?: InputMaybe<Array<OutboundEventState>>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of PerformChannelAction */
export type PerformChannelActionInput = {
  /** What to do, exactly one variant. */
  action: ChannelActionInput;
  /** Global id of the account to act with. Must be `RUNNING`. */
  channelAccountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Caller's key for this action. Omitted, the gateway derives one from the
   * account and the input, so an identical retry is a no-op; pass your own to
   * repeat an identical action on purpose.
   */
  externalId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PerformChannelAction. */
export type PerformChannelActionPayload = Node & {
  __typename?: 'PerformChannelActionPayload';
  /** The accepted action, `PENDING` unless it was already known. */
  channelAction: ChannelAction;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** Autogenerated return type of Ping. */
export type PingPayload = {
  __typename?: 'PingPayload';
  externalId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

/** Provider running a channel account behind the gateway. One of: unipile, linkedin_direct. */
export type Provider =
  /** The linkedin_direct provider. */
  | 'LINKEDIN_DIRECT'
  /** The unipile provider. */
  | 'UNIPILE';

/**
 * One way an account has been reached: a provider, the id that provider knows the
 * account by, and the life of that link. An account works through one running
 * connection at a time; the others are its history.
 */
export type ProviderConnection = Node & {
  __typename?: 'ProviderConnection';
  /** The account this connection reaches. */
  channelAccount: ChannelAccount;
  /** When it first ran; null while a draft. */
  connectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When opened. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The provider. */
  provider: Provider;
  /**
   * The id the provider knows the account by — Unipile's account id, or the
   * LinkedIn member id for the direct provider. Null until bound.
   */
  providerAccountId?: Maybe<Scalars['String']['output']>;
  /** When it was replaced or removed, and released at the provider. */
  retiredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Where the connection stands. */
  status: ProviderConnectionStatus;
};

/** The connection type for ProviderConnection. */
export type ProviderConnectionConnection = {
  __typename?: 'ProviderConnectionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProviderConnectionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProviderConnection>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProviderConnectionEdge = {
  __typename?: 'ProviderConnectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProviderConnection>;
};

/** State of one connection between an account and a provider. One of: draft, running, disconnected, retired. */
export type ProviderConnectionStatus =
  /** Its provider session expired or was revoked; re-authenticate or switch. */
  | 'DISCONNECTED'
  /** Opened by an authentication attempt, not confirmed yet. */
  | 'DRAFT'
  /** Replaced by another connection or removed with the account; released at the provider. */
  | 'RETIRED'
  /** The connection the account works through. */
  | 'RUNNING';

/** One delivery the provider made to the gateway's webhook about an account. */
export type ProviderEvent = Node & {
  __typename?: 'ProviderEvent';
  /** When the gateway stored it. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Why processing failed, when it did. */
  error?: Maybe<Scalars['String']['output']>;
  /** The type in the provider's own vocabulary. */
  eventType: Scalars['String']['output'];
  /** The provider's id of the delivery. */
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The gateway's own event type it was translated to; null when the gateway stores this type without effect. */
  kind?: Maybe<Scalars['String']['output']>;
  /** The delivery's body, as received. */
  payload: Scalars['JSON']['output'];
  /** When the gateway processed it; null while it waits. */
  processedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The provider that sent it. */
  provider: Provider;
  /** When the gateway received it. */
  receivedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for ProviderEvent. */
export type ProviderEventConnection = {
  __typename?: 'ProviderEventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProviderEventEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProviderEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProviderEventEdge = {
  __typename?: 'ProviderEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProviderEvent>;
};

/** Narrows `providerEvents`. */
export type ProviderEventFilterInput = {
  /** Keep only these types, in the provider's own vocabulary (`message.new`, `account.status.disconnected`, …). */
  eventType?: InputMaybe<StringFilterInput>;
  /**
   * Keep only the deliveries the gateway translated to these event types
   * (`message.received`, `channel_account.disconnected`, …). `blank: true` keeps
   * the ones it stores without effect.
   */
  kind?: InputMaybe<StringFilterInput>;
};

/** Filter on provider (eq/in/notEq/notIn). */
export type ProviderFilterInput = {
  /** Exact match. */
  eq?: InputMaybe<Provider>;
  /** Match any of these values. */
  in?: InputMaybe<Array<Provider>>;
  /** Exclude exact match. */
  notEq?: InputMaybe<Provider>;
  /** Exclude any of these values. */
  notIn?: InputMaybe<Array<Provider>>;
};

/**
 * What this service would send upstream for one (Definition, provider) pair,
 * rendered without provisioning anything. Internal plumbing rather than
 * customer-facing data, exposed so the checks that assert against a provider's
 * live API can run from outside this codebase — the e2e backend suite diffs
 * `sentConfigKeys` against the provider's published schemas and offers
 * `draftRequestBody` to the live API as a draft.
 */
export type ProvisioningPreview = {
  __typename?: 'ProvisioningPreview';
  /** Slug of the Definition this preview belongs to. */
  definitionSlug: Scalars['String']['output'];
  /** Version of the Definition this preview belongs to. */
  definitionVersion: Scalars['Int']['output'];
  /**
   * The complete request body this provider's provisioning builds, from a sample
   * input derived from the Definition's own `watcherInputSchema`. Carries `status:
   * "draft"` where the provider has one: leads are sourced only once a signal is
   * activated, which is what makes offering this body to a live API free. Null for
   * a provider whose provisioning is a sequence of API calls rather than one
   * declarative body, leaving nothing to render ahead of time. Carries the
   * translation of the query's `icp` argument when one is given, so a caller can
   * see what a given ICP constrains upstream without provisioning a billable signal.
   */
  draftRequestBody?: Maybe<Scalars['JSON']['output']>;
  /**
   * Upstream route this provider provisions against, e.g. 'fundraising' or
   * 'gmb-listing'. Null for a provider with no named per-signal route.
   */
  endpoint?: Maybe<Scalars['String']['output']>;
  /**
   * Whether this is the latest version of the Definition. Deprecated versions
   * share their provisioning with the successor, so a consumer diffing config keys
   * can skip them without losing coverage.
   */
  latest: Scalars['Boolean']['output'];
  /** Slug of the definition provider this preview is for, e.g. 'rodz'. */
  providerSlug: Scalars['String']['output'];
  /**
   * ICP paths this Definition cannot be created without — `createWatcher` refuses
   * a watcher missing any of them, because some endpoints cannot run unfiltered.
   * Values are the caller's to supply: `organization.division_ids` wants real
   * Mercator ids, which only the caller's environment can resolve. Empty when the
   * Definition can be created with no ICP at all.
   */
  requiredIcpPaths: Array<Scalars['String']['output']>;
  /**
   * The watcher input `draftRequestBody` was rendered from, derived from the
   * Definition's own `watcherInputSchema`. Exposed so a consumer driving the real
   * `createWatcher` path needs no second implementation of "an input this
   * Definition accepts".
   */
  sampleWatcherInput: Scalars['JSON']['output'];
  /**
   * Every upstream filter-config key this provider's provisioning can emit — the
   * declared set, not the subset this particular sample input rendered. A key the
   * provider no longer accepts is a filter that silently stopped applying, since
   * Rodz (for one) ignores unknown config keys rather than rejecting them. Empty
   * for a provider that sends no filter config upstream and filters locally instead.
   */
  sentConfigKeys: Array<Scalars['String']['output']>;
};

/**
 * Selection arguments for the provisioning previews query. Each field picks one
 * value rather than filtering a set: an ICP-scoped preview is refused unless
 * exactly one Definition is named.
 */
export type ProvisioningPreviewSelectorInput = {
  /**
   * Only preview this Definition, e.g. 'fundraising'. Both versions of a
   * superseded slug are returned — filter on `latest` to keep the current one.
   * Omit for every Definition.
   */
  definitionSlug?: InputMaybe<Scalars['String']['input']>;
  /** Only preview this definition provider, e.g. 'rodz' or 'snitcher'. Omit for every provider. */
  providerSlug?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  /**
   * Whether a token subject may act for a company right now: a person who is a
   * member of it, or an application it owns. Atlas asks this before recording a
   * reveal, with its service token. Reachable by a **machine token** from the
   * Cognito issuer and by a caller holding `hermes/company:read`; UNKNOWN_SUBJECT
   * for everyone else, so a subject cannot be probed for its memberships.
   */
  actingCheck: ActingCheck;
  /**
   * One application the caller may manage, by global id. Returns null when no
   * company the caller belongs to owns it. A caller holding
   * `hermes/application:read` reaches any application, and for them null means it
   * does not exist.
   */
  application?: Maybe<Application>;
  /**
   * Applications the caller may manage: those owned by every company they belong
   * to. A caller holding `hermes/application:read` reads every application instead
   * — the scope Sortlist staff hold, so support can inspect a customer's.
   */
  applications: ApplicationConnection;
  /**
   * Looks up a billing customer by id, e.g. for a consumer's credit pre-check.
   * Billing trusts authenticated callers; tenancy is enforced upstream by the
   * calling service.
   * @deprecated use node instead
   */
  billingCustomer?: Maybe<BillingCustomer>;
  /** Liveness probe for the billing subgraph. */
  billingPing: Scalars['String']['output'];
  /** Static plan catalog of one product (tiers × monthly / annual). Drives the plan-picker UI without round-tripping Stripe. */
  billingPlanCatalog: Array<BillingPlanCatalogEntry>;
  /**
   * Looks up a channel account by id. Null when the id is unknown or the account
   * was removed; refused when it belongs to another caller.
   */
  channelAccount?: Maybe<ChannelAccount>;
  /**
   * The caller's channel accounts, newest first, without the removed ones. A token
   * carrying `outreach/*:read` or `outreach/*:*` sees every consumer's accounts.
   */
  channelAccounts: ChannelAccountConnection;
  /**
   * Looks up an action by id, for consumers that prefer polling to the
   * `channel_action.*` events. Null when the id is unknown; refused when the
   * action belongs to another caller.
   */
  channelAction?: Maybe<ChannelAction>;
  /** The actions a consumer asked for on one of the caller's accounts, newest first, with where each one stands. */
  channelActions?: Maybe<ChannelActionConnection>;
  /**
   * Companies the caller belongs to, including their personal one. A caller
   * holding `hermes/company:read` reads every company instead — the scope Sortlist
   * staff hold, so support can look up a customer they are not a member of.
   */
  companies: CompanyConnection;
  /**
   * One company the caller belongs to, by slug. Returns null when they do not
   * belong to it, so a company that exists and one that does not are
   * indistinguishable. A caller holding `hermes/company:read` reaches any company,
   * and for them null means it does not exist.
   */
  company?: Maybe<Company>;
  /**
   * What an invitation code is for, without redeeming it — accepting hands over
   * full control of a company's applications and credentials, so nobody should
   * have to do it blind. Null for a code that is unknown, spent, revoked or
   * expired; those are indistinguishable on purpose.
   */
  companyInvitationPreview?: Maybe<CompanyInvitationPreview>;
  /**
   * List contacts with optional filtering and sorting.
   * Supports cross-organization filtering via `organizationFilter` — for example, contacts
   * whose organization is in a given industry or country.
   * When you already hold an Organization, prefer `organization { contacts { ... } }` to
   * avoid cross-joins. Maximum page size: 100.
   */
  contacts: ContactConnection;
  /** Returns all administrative divisions at every hierarchy level that contain the given coordinate. */
  containingDivisions: LocationConnection;
  /** Find a Definition by slug and version. */
  definition?: Maybe<Definition>;
  /** List of code-defined Definitions exposed by this subgraph. */
  definitions: DefinitionConnection;
  /**
   * Events across every Watcher the caller reads, newest first. Kept ones by
   * default; the refused slice carries the provider's own envelope and takes a
   * service-wide read scope, exactly as `Watcher.events` does.
   */
  events: EventConnection;
  /**
   * List IP-to-company identification records with optional filtering.
   * Use `filter.valid: true` to restrict to records that successfully matched a company.
   */
  identifications: IdentificationConnection;
  /** The messages of one conversation Outreach follows, newest first. */
  linkedinChatMessages?: Maybe<LinkedinMessageConnection>;
  /**
   * The conversations Outreach follows on one of the caller's accounts, most
   * recent activity first. Only what Outreach started is here.
   */
  linkedinChats?: Maybe<LinkedinChatConnection>;
  /** The connection requests sent through Outreach on one of the caller's accounts, newest first, with where each one stands. */
  linkedinInvitations?: Maybe<LinkedinInvitationConnection>;
  /**
   * Every division level, ordered coarsest to finest. The MACRO* levels group
   * whole levels rather than sitting on one, so they fall *between* the
   * administrative levels — which is why this ordering, and not `adminLevel`, is
   * what a consumer walks to find the nearest level it can express.
   */
  locationSubtypes: Array<LocationSubtype>;
  /** Auth0 logout URL used by the CLI to clear the browser session. */
  logoutUrl: Scalars['String']['output'];
  /**
   * The person calling. Null when the request carries no access token, one this
   * service does not trust, or an application credential's token — an application
   * is not a person, and this service refuses its own tokens by design. A caller
   * holding such a token reads its own `application_id` and `company_id` claims
   * instead; it minted the token, so it needs nothing from here to know that.
   */
  me?: Maybe<User>;
  /**
   * Fetches an object given its ID. Supports all entity types across subgraphs —
   * the gateway hydrates fields from the owning subgraph via federation entity resolution.
   */
  node?: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. Supports all entity types across subgraphs. */
  nodes: Array<Maybe<Node>>;
  /**
   * Look up an organization by its exact primary domain.
   * Returns null when no record exists for that domain.
   * Use when you have the exact domain. For attribute-based or fuzzy search,
   * use `organizations(filter:, sort:)` instead.
   */
  organization?: Maybe<Organization>;
  /**
   * List organizations with optional filtering and sorting.
   * Supports semantic search via embedding filters on `description` and `industry`.
   * The `name` and `domain` filters both accept `in`, so a whole list of company
   * identifiers can be resolved to records in one read — no enrichment, no external calls.
   * Use `organization(domain:)` for a direct single-domain lookup.
   * Maximum page size: 100.
   */
  organizations: OrganizationConnection;
  /**
   * The events the gateway sent to the consumer's webhook about one of the
   * caller's accounts, newest first, with whether each one got through.
   */
  outboundEvents?: Maybe<OutboundEventConnection>;
  /**
   * Liveness probe for the outreach subgraph. Answers "pong" to any caller whose
   * token carries `outreach/channel_account:read`.
   */
  ping: Scalars['String']['output'];
  /**
   * The deliveries the provider made to the gateway about an account, newest
   * first, with what the gateway made of each one. For operators: the token has to
   * carry `outreach/*:read` or `outreach/*:*`.
   */
  providerEvents?: Maybe<ProviderEventConnection>;
  /**
   * What this service would send upstream for every (Definition, provider) pair,
   * rendered without provisioning anything. Exposed so the checks that assert
   * against a provider's live API can run from outside this codebase (see the e2e
   * backend suite) and therefore check the deployed service rather than a copy of its source.
   */
  provisioningPreviews: Array<ProvisioningPreview>;
  /** Looks up a single location by an external code, in the identifier scheme given by `code_type`. */
  resolveByCode?: Maybe<Location>;
  /** Fuzzy text search over location names and aliases. Returns ranked matches. */
  resolveLocations: LocationConnection;
  /**
   * The reveal ledger, newest first: which reach dimensions each company was handed,
   * and in which window. Staff surface for reading usage before it is priced. Maximum page size: 100.
   */
  reveals: RevealRecordConnection;
  /** Liveness probe for the signals subgraph */
  signalsPing: Scalars['String']['output'];
  /**
   * Looks up a user by Auth0 subject. Reachable by a **machine token** from the
   * Cognito issuer — it exists for one of them, the sync_company_ids Auth0 Action,
   * which holds a subject and no way to obtain a global id — and by a caller
   * holding `hermes/user:read`, the scope Sortlist staff hold, since correlating a
   * subject from a log line to a person is the support question it answers. Null
   * for everyone else: a subject is not a secret, so an open lookup is a directory.
   */
  user?: Maybe<User>;
  /**
   * Every person Hermes has provisioned, newest first. Requires `hermes/user:read`
   * — the scope Sortlist staff hold — because a list of people with their emails
   * and companies is exactly the directory `user(sub:)` is closed to avoid handing
   * out. Empty for anyone else.
   */
  users: UserConnection;
  /**
   * Find a Watcher by id.
   * @deprecated use node instead
   */
  watcher?: Maybe<Watcher>;
  /**
   * Watchers the caller owns. A caller holding a resource-wide read scope reads
   * every watcher instead — the scopes Sortlist staff hold, so support can see
   * what a customer subscribed to.
   */
  watchers: WatcherConnection;
  /**
   * Delivery endpoints across every Watcher the caller reads, newest first. The
   * delivery side of the pipeline read as a whole: an outage is usually shared by
   * host rather than by watcher, which no single Watcher's page can show.
   */
  webhooks: WebhookConnection;
};


export type QueryActingCheckArgs = {
  companyId: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
};


export type QueryApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBillingCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBillingPlanCatalogArgs = {
  product: BillingProduct;
};


export type QueryChannelAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChannelAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ChannelAccountFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChannelActionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChannelActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channelAccountId: Scalars['ID']['input'];
  filter?: InputMaybe<ChannelActionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyArgs = {
  slug: Scalars['String']['input'];
};


export type QueryCompanyInvitationPreviewArgs = {
  code: Scalars['String']['input'];
};


export type QueryContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ContactFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationFilter?: InputMaybe<OrganizationFilterInput>;
  reveal?: InputMaybe<Array<RevealDimension>>;
  sort?: InputMaybe<Array<ContactSortInput>>;
};


export type QueryContainingDivisionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  coordinate: CoordinateInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDefinitionArgs = {
  slug: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};


export type QueryDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DefinitionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<EventFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIdentificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<IdentificationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLinkedinChatMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chatId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLinkedinChatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channelAccountId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLinkedinInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channelAccountId: Scalars['ID']['input'];
  filter?: InputMaybe<LinkedinInvitationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryOrganizationArgs = {
  domain: Scalars['String']['input'];
};


export type QueryOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrganizationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationSortInput>>;
};


export type QueryOutboundEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channelAccountId: Scalars['ID']['input'];
  filter?: InputMaybe<OutboundEventFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProviderEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channelAccountId: Scalars['ID']['input'];
  filter?: InputMaybe<ProviderEventFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProvisioningPreviewsArgs = {
  filter?: InputMaybe<ProvisioningPreviewSelectorInput>;
  icp?: InputMaybe<WatcherIcpInput>;
};


export type QueryResolveByCodeArgs = {
  code: Scalars['String']['input'];
  codeType: LocationCode;
};


export type QueryResolveLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  exactOnly?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  subtypes?: InputMaybe<LocationSubtypeFilterInput>;
  within?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRevealsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RevealFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserArgs = {
  sub: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UserFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWatcherArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWatchersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<WatcherFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWebhooksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<WebhookFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Filter on an int8range column with range operators. */
export type RangeFilterInput = {
  /**
   * When true, a row also matches when the attribute is blank — NULL, an empty
   * string, an empty list, or no related record, depending on the column. The
   * connection edge reports which branch admitted each row via `filterMatches`.
   * Contrast `blank`, which narrows to blank-only rows where this one widens to include them.
   */
  allowBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches rows whose range is fully within the given [min, max] range. */
  containedBy?: InputMaybe<Scalars['Range']['input']>;
  /** Matches rows whose range contains the given value. */
  contains?: InputMaybe<Scalars['Int']['input']>;
  /** Matches rows whose range overlaps the given [min, max] range. */
  overlaps?: InputMaybe<Scalars['Range']['input']>;
};

/** Autogenerated input type of RefreshToken */
export type RefreshTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  refreshToken: Scalars['String']['input'];
};

/** Autogenerated input type of RemoveCompanyMember */
export type RemoveCompanyMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  /** The member to remove. `company { members { user { id } } }` lists them. */
  userId: Scalars['ID']['input'];
};

/**
 * What this response cost in reveal credits: the most it could have, and what it
 * actually did. Nothing is charged yet; the figures are what would be.
 */
export type RevealCredits = {
  __typename?: 'RevealCredits';
  /** The units used, per dimension this response revealed. Empty when it revealed nothing. */
  byDimension: Array<RevealDimensionCredits>;
  /** The ceiling reserved before the page was read: every requested dimension on every row. */
  held: Scalars['Int']['output'];
  /**
   * Units this response actually consumed: one per dimension revealed on one row.
   * An owned or unavailable dimension costs nothing.
   */
  used: Scalars['Int']['output'];
};

/**
 * A separately purchasable piece of reach information about a lead. One flat list
 * rather than a subject plus a dimension, so a contact edge can report
 * organization lines under the same vocabulary.
 */
export type RevealDimension =
  /** Their email address, its verification status and its pattern. */
  | 'CONTACT_EMAIL_ADDRESS'
  /** The person's name, picture and career history. */
  | 'CONTACT_IDENTITY'
  /** Their LinkedIn profile. */
  | 'CONTACT_LINKEDIN_URL'
  /** Their phone number. */
  | 'CONTACT_PHONE_NUMBER';

/** Units one dimension cost on this response. */
export type RevealDimensionCredits = {
  __typename?: 'RevealDimensionCredits';
  dimension: RevealDimension;
  /** Rows this dimension was revealed on. */
  used: Scalars['Int']['output'];
};

/** Filter on the reach dimension a reveal handed over (eq/in/notEq/notIn). */
export type RevealDimensionFilterInput = {
  /** Exact match. */
  eq?: InputMaybe<RevealDimension>;
  /** Match any of these values. */
  in?: InputMaybe<Array<RevealDimension>>;
  /** Exclude exact match. */
  notEq?: InputMaybe<RevealDimension>;
  /** Exclude any of these values. */
  notIn?: InputMaybe<Array<RevealDimension>>;
};

/** One dimension of one lead, and what this response did about it. */
export type RevealDimensionStatus = {
  __typename?: 'RevealDimensionStatus';
  /** The piece of reach information this entry is about. */
  dimension: RevealDimension;
  /** When this dimension stops being owned and would be charged again. Set on REVEALED and OWNED, null otherwise. */
  ownedUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether it was revealed now, already owned, locked, or not there. */
  status: RevealStatus;
};

/** Filter criteria for the reveal ledger. */
export type RevealFilterInput = {
  /**
   * Only reveals handed to these companies, as Company ids. An id that is not a
   * company's matches nothing rather than everything.
   */
  companyId?: InputMaybe<IdFilterInput>;
  /** Only reveals of these contacts, as Contact ids: who was handed which of their dimensions. */
  contactId?: InputMaybe<IdFilterInput>;
  /** `true` keeps only rows not yet superseded by a later window. */
  current?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only reveals of these dimensions. */
  dimension?: InputMaybe<RevealDimensionFilterInput>;
  /** Only reveals triggered by these token subjects — an Auth0 subject for a person, `application:<uuid>` for a machine. */
  oauthId?: InputMaybe<StringFilterInput>;
};

/**
 * One row of the reveal ledger: a reach dimension handed to a company, recorded
 * once per window. What the list `reveals` returns, as opposed to the per-edge
 * `Reveal` a query reports back beside each lead.
 */
export type RevealRecord = Node & {
  __typename?: 'RevealRecord';
  /** The day this window opened. */
  anchorOn: Scalars['ISO8601Date']['output'];
  /** The application whose token triggered the reveal, resolved by Hermes. Null when a person did. */
  application?: Maybe<Application>;
  /** The company the information was handed to, resolved by Hermes. Null when Hermes no longer knows it. */
  company?: Maybe<Company>;
  /** The identifier a charge would carry: subject, window anchor, dimension. */
  consumableId: Scalars['String']['output'];
  /** The contact the information belongs to. Null when the subject is not a contact or has since been merged away. */
  contact?: Maybe<Contact>;
  /** The piece of reach information recorded. */
  dimension: RevealDimension;
  /** When this window closes and the dimension would be recorded again. */
  expiresAt: Scalars['ISO8601DateTime']['output'];
  /**
   * How many responses served this dimension inside this window, the reveal itself
   * included. Reads inside the window count here and nowhere else: the row is what
   * would be charged, once.
   */
  hits: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Whether this row is the current, unexpired record for its dimension. */
  live: Scalars['Boolean']['output'];
  /** The token subject that triggered the reveal: a person or an application. */
  oauthId: Scalars['String']['output'];
  /** When the information was first handed over in this window. */
  revealedAt: Scalars['ISO8601DateTime']['output'];
  /** When a later window replaced this row. Null on the current row. */
  supersededAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Why the row was superseded: `rollover` when its window lapsed. */
  supersededReason?: Maybe<Scalars['String']['output']>;
};

/** The connection type for RevealRecord. */
export type RevealRecordConnection = {
  __typename?: 'RevealRecordConnection';
  /**
   * Estimated total number of items across all pages. It comes from the query
   * planner rather than a count, so it costs planning time instead of a scan and
   * cannot exceed the statement timeout. It is approximate at every magnitude,
   * including small ones, and it moves when the table's statistics are refreshed.
   * Accuracy depends on the filter: within a few percent on plain column and
   * array-overlap filters, and as much as 30% out on a range filter such as
   * `companySize`. It is not meaningful for the embedding filters `jobTitle` and
   * `industry` — no statistics exist for a vector-distance predicate, so the
   * estimate ignores the distance threshold entirely and approximates only what
   * the other filters admit; it has been measured reporting 241371 for a filter
   * whose true result was empty. Never render it as an exact figure, and use
   * `totalCount` when the figure has to be exact.
   */
  approximateTotalCount: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RevealRecordEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RevealRecord>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages, exact unless `upTo` is given. */
  totalCount: Scalars['Int']['output'];
};


/** The connection type for RevealRecord. */
export type RevealRecordConnectionTotalCountArgs = {
  upTo?: InputMaybe<Scalars['Int']['input']>;
};

/** An edge in a connection. */
export type RevealRecordEdge = Node & {
  __typename?: 'RevealRecordEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RevealRecord>;
};

/** What happened to one dimension of one lead on this response. */
export type RevealStatus =
  /**
   * Atlas has it, but this company has not asked for it: the fields come back null
   * until a response passes the dimension in `reveal:`.
   */
  | 'LOCKED'
  /** Already recorded inside its window, so it is served and counts once, not again. */
  | 'OWNED'
  /** Asked for through `reveal:`, found, and recorded by this response. */
  | 'REVEALED'
  /** Atlas found nothing. Never recorded — an unsuccessful lookup would not be chargeable. */
  | 'UNAVAILABLE';

/** Autogenerated input type of RevokeApplicationCredential */
export type RevokeApplicationCredentialInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  credentialId: Scalars['ID']['input'];
};

/** Autogenerated input type of RevokeCompanyInvitation */
export type RevokeCompanyInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invitationId: Scalars['ID']['input'];
};

/** Autogenerated input type of RunSignalsSynchronousWorker */
export type RunSignalsSynchronousWorkerInput = {
  /** Positional arguments forwarded to the job's perform. */
  args?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Fully-qualified ActiveJob class name to execute inline. */
  jobName: Scalars['String']['input'];
  /** Keyword arguments forwarded to the job's perform. */
  kwargs?: InputMaybe<Scalars['JSON']['input']>;
};

/** Autogenerated return type of RunSignalsSynchronousWorker. */
export type RunSignalsSynchronousWorkerPayload = Node & {
  __typename?: 'RunSignalsSynchronousWorkerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the job ran to completion without raising. */
  done: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of RunSynchronousWorker */
export type RunSynchronousWorkerInput = {
  /** Positional arguments forwarded to the job's #perform. */
  args?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Fully-qualified ActiveJob class name to execute inline. */
  jobName: Scalars['String']['input'];
  /** Keyword arguments forwarded to the job's #perform. */
  kwargs?: InputMaybe<Scalars['JSON']['input']>;
};

/** Autogenerated return type of RunSynchronousWorker. */
export type RunSynchronousWorkerPayload = {
  __typename?: 'RunSynchronousWorkerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  done: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SearchContact */
export type SearchContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Caller-supplied identifier used to key the `contactIdentifyResult` subscription. */
  externalId: Scalars['ID']['input'];
  /** Exactly one lookup mode must be provided. */
  lookup: ContactLookupInput;
};

/** Autogenerated return type of SearchContact. */
export type SearchContactPayload = {
  __typename?: 'SearchContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** One of: received. */
  status: Scalars['String']['output'];
};

/** Autogenerated input type of SearchContactPhone */
export type SearchContactPhoneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Global id of the contact whose phone number should be discovered. */
  contactId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * LinkedIn profile URL of the person, used when no `contactId` is held. Ignored
   * when `contactId` is supplied. A value that does not normalize to a LinkedIn
   * profile URL is rejected with `INVALID_INTERACTION`.
   */
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SearchContactPhone. */
export type SearchContactPhonePayload = {
  __typename?: 'SearchContactPhonePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The contact the lookup resolved to, with `phone` populated when one was found. Null when no contact matched. */
  contact?: Maybe<Contact>;
  /** The discovered phone number, or null when none was found. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Outcome of the lookup. One of: found, not_found, contact_not_found, missing_linkedin_url. */
  status: Scalars['String']['output'];
};

/** Autogenerated input type of SearchContacts */
export type SearchContactsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Caller-supplied identifier used to key the `contactSearchResult` subscription. */
  externalId: Scalars['ID']['input'];
  /** Filter criteria for contacts, applied to both the local database and, where translatable, the Coresignal search. */
  filter?: InputMaybe<ContactFilterInput>;
  /**
   * Filter criteria for the contacts' organizations, applied to both the local
   * database and, where translatable, the Coresignal search.
   */
  organizationFilter?: InputMaybe<OrganizationFilterInput>;
  /** Sort order applied to the database contacts result set. */
  sort?: InputMaybe<Array<ContactSortInput>>;
};

/** Autogenerated return type of SearchContacts. */
export type SearchContactsPayload = {
  __typename?: 'SearchContactsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** One of: received. */
  status: Scalars['String']['output'];
};

/** Autogenerated input type of SearchOrganization */
export type SearchOrganizationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Caller-supplied correlation key; pass the same value to `organizationSearchResult(externalId:)` to receive the result. */
  externalId: Scalars['String']['input'];
  /** Lookup mode — provide exactly one of `domain` or `byIp`. */
  lookup: OrganizationLookupInput;
  /**
   * Optional URL to receive the result via webhook instead of the federated
   * subscription. Only used with `lookup.byIp`. Requires the `atlas/source:write` scope.
   */
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SearchOrganization. */
export type SearchOrganizationPayload = {
  __typename?: 'SearchOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** One of: received. */
  status: Scalars['String']['output'];
};

/** Autogenerated input type of SetWebhookActive */
export type SetWebhookActiveInput = {
  /** True to resume delivery, false to pause it. */
  active: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** Webhook URL whose delivery state is toggled. */
  webhookUrl: Scalars['String']['input'];
};

/** Autogenerated return type of SetWebhookActive. */
export type SetWebhookActivePayload = Node & {
  __typename?: 'SetWebhookActivePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The reconciled Watcher. */
  watcher: Watcher;
};

/** Sort direction. */
export type SortDirection =
  /** Ascending order (lowest to highest, oldest to newest). */
  | 'ASC'
  /** Descending order (highest to lowest, newest to oldest). */
  | 'DESC';

/** An enrichment data source with trust score and field mappings. */
export type Source = Node & {
  __typename?: 'Source';
  /**
   * Maps Atlas canonical contact field names to rawData extraction expressions.
   * Keys: first_name, last_name, email_address, job_title, job_level, job_function,
   * linkedin_url, city, country_code.
   * Values: a string key ("firstname"), an array path for nested access
   * (["data", "email"]), or an operation hash
   * ({"op": "split", "key": "full_name", "index": 0}).
   * All referenced keys must exist in contact_schema.
   */
  contactFieldMappings: Scalars['JSON']['output'];
  /** JSON Schema (draft-07) describing the expected shape of contact rawData payloads. */
  contactSchema: Scalars['JSON']['output'];
  /** When the source was registered. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /**
   * Maps Atlas canonical identification field names to rawData extraction expressions.
   * Keys: ip_address, organization_domain, confidence_score.
   * Values follow the same expression syntax as contact_field_mappings.
   * All referenced keys must exist in identification_schema.
   */
  identificationFieldMappings: Scalars['JSON']['output'];
  /** JSON Schema (draft-07) describing the expected shape of identification rawData payloads. */
  identificationSchema: Scalars['JSON']['output'];
  /** OAuth subject of the user who registered this source. Null for system-registered sources. */
  oauthId?: Maybe<Scalars['String']['output']>;
  /**
   * Maps address slot names to rawData extraction expressions.
   * The top-level key names an address slot (e.g. "headquarters").
   * Each slot maps Atlas address field names (street, city, state, postal_code,
   * country_code, is_headquarters) to extraction expressions or literal values.
   */
  officeFieldMappings: Scalars['JSON']['output'];
  /**
   * Maps Atlas canonical organization field names to rawData extraction expressions.
   * Keys: name, website, phone, contact_email, linkedin_url, description,
   * company_size, founded_year, industry, country_code, annual_revenue.
   * Values: a string key ("name"), an array path (["company", "name"]),
   * or an operation hash ({"op": "parse_employee_range", "path": ["size_range"]}).
   * All referenced keys must exist in organization_schema.
   */
  organizationFieldMappings: Scalars['JSON']['output'];
  /** JSON Schema (draft-07) describing the expected shape of organization rawData payloads. */
  organizationSchema: Scalars['JSON']['output'];
  /** Short machine-readable identifier for this source (e.g. snitcher, hunter). */
  slug: Scalars['String']['output'];
  /** Weight applied during multi-source merging, 0.0–1.0. Higher scores win field conflicts. */
  trustScore: Scalars['Float']['output'];
  /** When the source configuration was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Filter on a string column with positive and negative matching. */
export type StringFilterInput = {
  /**
   * When true, a row also matches when the attribute is blank — NULL, an empty
   * string, an empty list, or no related record, depending on the column. The
   * connection edge reports which branch admitted each row via `filterMatches`.
   * Contrast `blank`, which narrows to blank-only rows where this one widens to include them.
   */
  allowBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, match only rows where the column is NULL or empty. False or omitted applies no constraint. */
  blank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exact match. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Match any of these values. Maximum 10000 entries. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Exclude exact match. */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** Exclude any of these values. Maximum 10000 entries. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** When true, match only rows where the column is neither NULL nor empty. False or omitted applies no constraint. */
  presence?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /**
   * Delivers an action the moment it settles, `COMPLETED` or `FAILED`, to the
   * caller that performed it, keyed by account and `externalId`. Choose the key,
   * subscribe, then call `performChannelAction`: the result cannot slip by before
   * the subscription exists. The fast path only: a subscription lives minutes, so
   * the webhook event and `channelAction(id)` remain the paths of record.
   */
  channelActionResult: ChannelActionResultPayload;
  /**
   * Delivers the result of an `enrichContact` call when `externalId` was supplied,
   * keyed by that `externalId`. The payload contains the merged Contact after enrichment,
   * or a null Contact and an `unresolvedReason` when none could be resolved.
   */
  contactEnrichmentResult: ContactEnrichmentResultPayload;
  /**
   * Delivers the result of a `searchContact` call, keyed by `externalId`.
   * Subscribe before or immediately after calling `searchContact`, passing the
   * same `externalId`. The payload contains the matched Contact (or null if not found),
   * regardless of which probe mode was used.
   */
  contactIdentifyResult: ContactIdentifyResultPayload;
  /**
   * Delivers the result of a `searchContacts` call, keyed by `externalId`.
   * The payload contains the contacts matching the filter — both
   * pre-existing database matches and newly-discovered, newly-persisted
   * third-party (Coresignal) matches, since Coresignal-sourced contacts
   * are persisted before this query runs.
   */
  contactSearchResult: ContactSearchResultPayload;
  /**
   * Delivers the result of a `validateContact` call, keyed by `externalId`.
   * The payload contains the Contact and per-field coherence flags in `clues`.
   */
  contactValidationResult: ContactValidationResultPayload;
  /**
   * Delivers the result of a `validateDomain` call, keyed by `externalId`.
   * The payload contains the Organization and per-field coherence flags in `clues`.
   */
  domainValidationResult: DomainValidationResultPayload;
  /**
   * Delivers the result of an `enrichOrganization` call when `externalId` was
   * supplied, keyed by that `externalId`. Fires once the merge has settled,
   * including the embedding columns, so the organization is immediately
   * queryable through embedding filters (e.g. `industry`).
   */
  organizationEnrichmentResult: OrganizationEnrichmentResultPayload;
  /**
   * Delivers the result of a `searchOrganization` call, keyed by `externalId`.
   * The payload contains the Organization once Atlas has looked up or enriched it
   * (whether by domain or IP), or null if no match was found.
   */
  organizationSearchResult: OrganizationSearchResultPayload;
  /** Spike subscription used to validate the callback transport end-to-end. */
  ping: PingPayload;
  /**
   * Delivers the outcome of a `createWatcher` call once every provider has
   * settled (provisioned or terminally failed), keyed by the `externalId`
   * the caller passed to the mutation. Subscribe before mutating. Covers
   * the fast path only — a subscription lives minutes, while an upstream
   * outage can keep provisioning pending for hours — so poll the watcher's
   * `provisioningStatus` to cover the long tail.
   */
  watcherProvisioningResult: WatcherProvisioningResultPayload;
};


export type SubscriptionChannelActionResultArgs = {
  channelAccountId: Scalars['ID']['input'];
  externalId: Scalars['String']['input'];
};


export type SubscriptionContactEnrichmentResultArgs = {
  externalId: Scalars['ID']['input'];
};


export type SubscriptionContactIdentifyResultArgs = {
  externalId: Scalars['ID']['input'];
};


export type SubscriptionContactSearchResultArgs = {
  externalId: Scalars['ID']['input'];
};


export type SubscriptionContactValidationResultArgs = {
  externalId: Scalars['ID']['input'];
};


export type SubscriptionDomainValidationResultArgs = {
  externalId: Scalars['ID']['input'];
};


export type SubscriptionOrganizationEnrichmentResultArgs = {
  externalId: Scalars['ID']['input'];
};


export type SubscriptionOrganizationSearchResultArgs = {
  externalId: Scalars['ID']['input'];
};


export type SubscriptionPingArgs = {
  externalId: Scalars['ID']['input'];
};


export type SubscriptionWatcherProvisioningResultArgs = {
  externalId: Scalars['ID']['input'];
};

export type TokenResponse = Node & {
  __typename?: 'TokenResponse';
  accessToken?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  idToken?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  tokenType?: Maybe<Scalars['String']['output']>;
};

/** How a Watcher run is initiated. */
export type TriggerEnum =
  | 'MANUAL'
  | 'SCHEDULE'
  | 'WEBHOOK';

/** Autogenerated input type of TriggerWatcher */
export type TriggerWatcherInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of TriggerWatcher. */
export type TriggerWatcherPayload = Node & {
  __typename?: 'TriggerWatcherPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  watcher: Watcher;
};

/** Autogenerated input type of UpdateSource */
export type UpdateSourceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Maps Atlas canonical contact field names to rawData extraction expressions.
   * Keys: first_name, last_name, email_address, job_title, job_level, job_function,
   * linkedin_url, city, country_code.
   * Values: a string key ("firstname"), an array path for nested access
   * (["data", "email"]), or an operation hash
   * ({"op": "split", "key": "full_name", "index": 0}).
   * All referenced keys must exist in contact_schema.
   */
  contactFieldMappings?: InputMaybe<Scalars['JSON']['input']>;
  /** JSON Schema (draft-07) describing the expected shape of contact rawData payloads. */
  contactSchema?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * Maps Atlas canonical identification field names to rawData extraction expressions.
   * Keys: ip_address, organization_domain, confidence_score.
   * Values follow the same expression syntax as contact_field_mappings.
   * All referenced keys must exist in identification_schema.
   */
  identificationFieldMappings?: InputMaybe<Scalars['JSON']['input']>;
  /** JSON Schema (draft-07) describing the expected shape of identification rawData payloads. */
  identificationSchema?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * Maps Atlas canonical organization field names to rawData extraction expressions.
   * Keys: name, website, phone, contact_email, linkedin_url, description,
   * company_size, founded_year, industry, country_code, annual_revenue.
   * Values: a string key ("name"), an array path (["company", "name"]),
   * or an operation hash ({"op": "parse_employee_range", "path": ["size_range"]}).
   * All referenced keys must exist in organization_schema.
   */
  organizationFieldMappings?: InputMaybe<Scalars['JSON']['input']>;
  /** JSON Schema (draft-07) describing the expected shape of organization rawData payloads. */
  organizationSchema?: InputMaybe<Scalars['JSON']['input']>;
  /** Global ID of the source to update. */
  sourceId: Scalars['ID']['input'];
  /** Weight applied during multi-source merging, 0.0–1.0. Higher scores win field conflicts. */
  trustScore?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated input type of UpdateWatcherLeadCaps */
export type UpdateWatcherLeadCapsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Global id of the Watcher whose caps are being replaced. */
  id: Scalars['ID']['input'];
  /** The full set of caps for the Watcher. Pass an empty list to remove all caps (leaving the Watcher uncapped). */
  leadCaps: Array<LeadCapInput>;
};

/** Autogenerated return type of UpdateWatcherLeadCaps. */
export type UpdateWatcherLeadCapsPayload = Node & {
  __typename?: 'UpdateWatcherLeadCapsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The updated Watcher. */
  watcher: Watcher;
};

/** Federation reference to a User owned by another subgraph. */
export type User = Node & {
  __typename?: 'User';
  /** Companies this user belongs to. Reading this never provisions — only the caller's own first access does, through `me`. */
  companies: CompanyConnection;
  /** When this person first reached Hermes — their row is provisioned on that request, not when they registered with Auth0. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Cached from Auth0 on this user's own requests. May lag; never authoritative. */
  email?: Maybe<Scalars['String']['output']>;
  /** Cached from Auth0. Null when the identity provider does not supply one. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** GlobalID-encoded User id. */
  id: Scalars['ID']['output'];
  /** Cached from Auth0. Null when the identity provider does not supply one. */
  lastName?: Maybe<Scalars['String']['output']>;
  /**
   * The Auth0 subject. It is what a log line and a JWT carry, so it is the handle
   * support correlates on — and the reason `user(sub:)` is not open: a subject is
   * copyable, so an unscoped lookup by it is a directory.
   */
  oauthId: Scalars['String']['output'];
};


/** Federation reference to a User owned by another subgraph. */
export type UserCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

/** Filter criteria for people. */
export type UserFilterInput = {
  /** The Auth0 subjects, as a log line or a ledger row names them. */
  oauthId?: InputMaybe<StringFilterInput>;
};

/** Autogenerated input type of ValidateContact */
export type ValidateContactInput = {
  /** Optional values to cross-check against Atlas data (email, phone). */
  checks?: InputMaybe<ContactValidationChecksInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Caller-supplied correlation key; pass the same value to `contactValidationResult(externalId:)` to receive the result. */
  externalId: Scalars['String']['input'];
  /** Contact's first name to validate. */
  firstName: Scalars['String']['input'];
  /** Contact's last name to validate. */
  lastName: Scalars['String']['input'];
  /** Global ID of the organization this contact belongs to. */
  organizationId: Scalars['ID']['input'];
  /**
   * Optional URL to receive the result via webhook. Callers consuming results via
   * the federated `contactValidationResult` subscription can omit it. Requires the
   * `atlas/source:write` scope.
   */
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ValidateContact. */
export type ValidateContactPayload = {
  __typename?: 'ValidateContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** One of: received. */
  status: Scalars['String']['output'];
};

/** Autogenerated input type of ValidateDomain */
export type ValidateDomainInput = {
  /** Company field values to cross-check against Atlas data. */
  checks?: InputMaybe<ValidationChecksInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The company's primary web domain to validate. */
  domain: Scalars['String']['input'];
  /** Caller-supplied correlation key; pass the same value to `domainValidationResult(externalId:)` to receive the result. */
  externalId: Scalars['String']['input'];
  /**
   * Optional URL to receive the result via webhook. Callers consuming results via
   * the federated `domainValidationResult` subscription can omit it. Requires the
   * `atlas/source:write` scope.
   */
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ValidateDomain. */
export type ValidateDomainPayload = {
  __typename?: 'ValidateDomainPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** One of: received. */
  status: Scalars['String']['output'];
};

/** Company field values to cross-check against Atlas's stored organization data. */
export type ValidationChecksInput = {
  /** Expected annual revenue string to validate against the stored range. */
  annualRevenue?: InputMaybe<Scalars['String']['input']>;
  /** Expected employee count string to validate against the stored range. */
  companySize?: InputMaybe<Scalars['String']['input']>;
  /** General contact email address to validate. */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 alpha-2 country code to validate. */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Four-digit founding year to validate against the stored value. */
  foundedYear?: InputMaybe<Scalars['Int']['input']>;
  /** Industry string to validate against the stored classification. */
  industry?: InputMaybe<Scalars['String']['input']>;
  /** IP address to include in identification coherence checks. */
  ip?: InputMaybe<Scalars['String']['input']>;
  /** LinkedIn company page URL to validate. */
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  /** Legal or trade name to validate against the stored value. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Main phone number to validate. */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Federation reference to a Watcher owned by another subgraph. */
export type Watcher = Node & {
  __typename?: 'Watcher';
  /** Timestamp at which the Watcher was permanently canceled, or null if active or paused. */
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The Hermes company this Watcher belongs to, as the GlobalID hermes addresses
   * it by. Null on a watcher created before companies were recorded, or by a
   * subject that belongs to none. `ownerSub` says who created it; this says who is
   * billed for it, and the two answer different halves of "whose watcher is this".
   */
  companyId?: Maybe<Scalars['ID']['output']>;
  /** Timestamp when the Watcher was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The signal Definition this Watcher tracks. */
  definition: Definition;
  /**
   * Events this Watcher captured, newest first. Kept ones by default: a delivery
   * that was refused — a duplicate, a lead past the cap, an upstream payload
   * carrying no contact — never became a lead. Its reason is operator data, so
   * listing it through `state` takes a service-wide read scope — the one staff
   * hold, not the per-resource scope a customer is granted.
   */
  events: WatcherEventConnection;
  /**
   * Ideal Customer Profile this Watcher filters its leads by, in the same shape
   * Atlas search uses — including geography, as `contact.divisionIds` /
   * `organization.divisionIds`. Null for a Watcher created without a profile. Part
   * of the Watcher's identity, so it is fixed at creation.
   */
  icp?: Maybe<WatcherIcp>;
  /** GlobalID-encoded Watcher id. */
  id: Scalars['ID']['output'];
  /**
   * User-supplied input that defines what to track (e.g. keywords, domain, post
   * URL). Provider-managed configuration is not included here.
   */
  input: Scalars['JSON']['output'];
  /**
   * Client-side installation artifacts for this Watcher, one entry per provider
   * that publishes one. Each entry is a provider-specific JSON blob. By convention
   * every entry includes an `instructions` markdown field that tells the consumer
   * (agent or UI) how to walk the user through the install, plus the concrete
   * artifacts those instructions reference (e.g. Snitcher exposes `snippet`,
   * `snippet_version`, `wordpress_plugin_url`, `help_article_path`). Empty when no
   * provider requires client-side setup.
   */
  installations: Array<Scalars['JSON']['output']>;
  /** Freshness-first per-period lead caps applied to this Watcher. Empty when the Watcher is uncapped. */
  leadCaps: WatcherLeadCapConnection;
  /**
   * Whether this Watcher is currently producing signals. Reads PAUSED when every
   * registered webhook is paused, which provisioningStatus cannot express.
   */
  lifecycleState: WatcherLifecycleStateEnum;
  /** Human-readable display name of the Watcher, derived from the signal Definition it tracks. */
  name: Scalars['String']['output'];
  /**
   * The subject that created this Watcher — an Auth0 subject for a person,
   * `application:<uuid>` for a machine. It is what ownership is enforced on, so it
   * is also what correlates a Watcher to a log line.
   */
  ownerSub: Scalars['String']['output'];
  /**
   * Identifiers the upstream services assigned to this Watcher, one per provider
   * that holds one. Gated behind `signals/watcher:*` because these are internal
   * vendor ids — unlike `installations`, they are not customer-facing and disclose
   * which third party backs the signal. Empty for providers that keep no external reference.
   */
  providerReferences: Array<WatcherProviderReference>;
  /**
   * Where each provider stands: provisioned or not, torn down or not, and when it
   * next runs. Requires `signals/watcher:read` rather than the wider scope
   * providerReferences needs, because it carries no upstream identifier — only
   * whether the plumbing works.
   */
  providerStates: WatcherProviderStateConnection;
  /**
   * Terminal per-provider provisioning failures, one entry per provider that could
   * not be set up. Entries accumulate as each provider settles, so a still-PENDING
   * watcher can already carry failures for the providers that gave up first; empty
   * when everything provisioned. Gated behind `signals/watcher:*` for the same
   * reason `providerReferences` is: the provider slug discloses which third party
   * backs the signal.
   */
  provisioningFailures: Array<WatcherProvisioningFailure>;
  /**
   * Aggregate provisioning state of this Watcher's providers. `PROVISIONED` on a
   * Watcher created the default synchronous way; a Watcher created with
   * `createWatcher(async: true)` starts `PENDING` and settles once every provider
   * has an answer — poll this field, or subscribe to `watcherProvisioningResult`,
   * to learn the outcome.
   */
  provisioningStatus: WatcherProvisioningStatusEnum;
  /** Timestamp of the most recent change to this Watcher. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Delivery URLs registered on this watcher. Secrets are never exposed. */
  webhookUrls: Array<Scalars['String']['output']>;
  /**
   * Where each delivery endpoint stands and how it has been answering — paused or
   * not, how many leads reached it, how many failed. Requires
   * `signals/watcher:read`, and each summary is a set of aggregate queries: select
   * it on one Watcher, not across a list. `webhookUrls` stays the customer-facing
   * view of the same endpoints.
   */
  webhooks: WebhookConnection;
};


/** Federation reference to a Watcher owned by another subgraph. */
export type WatcherEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<WatcherEventStateFilterInput>;
};


/** Federation reference to a Watcher owned by another subgraph. */
export type WatcherLeadCapsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Federation reference to a Watcher owned by another subgraph. */
export type WatcherProviderStatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Federation reference to a Watcher owned by another subgraph. */
export type WatcherWebhooksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Watcher. */
export type WatcherConnection = {
  __typename?: 'WatcherConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WatcherEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Watcher>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/**
 * Person-level ICP criteria, as submitted. Mirrors `WatcherContactIcpInput`, which
 * in turn mirrors the subset of Atlas's `ContactFilterInput` an upstream lead
 * source can enforce.
 */
export type WatcherContactIcp = {
  __typename?: 'WatcherContactIcp';
  /** Mercator locations the person had to belong to. */
  divisionIds?: Maybe<WatcherDivisionFilter>;
  /**
   * Job title embedding filters. Only the *direction* of `match` was honoured
   * upstream (`INCLUDED_*` include, `EXCLUDED_*` exclude); the entry is echoed
   * back as the caller sent it, including a deprecated `distance`.
   */
  jobTitle?: Maybe<Array<EmbeddingFilter>>;
};

/** Person-level ICP criteria, mirroring the subset of Atlas's `ContactFilterInput` that an upstream lead source can enforce. */
export type WatcherContactIcpInput = {
  /**
   * Mercator location division IDs the person must belong to. Resolved to place
   * names before being handed upstream, since no source speaks Mercator.
   */
  divisionIds?: InputMaybe<IdFilterInput>;
  /**
   * Job title embedding filters. Each `query` is embedded as a single vector, so
   * keep one string to one semantic neighborhood — packing unrelated roles into it
   * dilutes the vector and forces a looser match, costing precision. To target
   * several distinct roles, list them in `queries`: each keeps its own vector, and
   * the entry matches a person close to any of them. Entries combine with AND (an
   * include plus an exclude). Upstream sources honour only the *direction* of
   * `match` (`INCLUDED_*` include, `EXCLUDED_*` exclude); the threshold behind it
   * is enforced at delivery time. Note that upstream sources OR every included
   * title together, so on their side a `queries` list and separate entries are
   * indistinguishable — the AND is enforced at delivery time.
   */
  jobTitle?: InputMaybe<Array<EmbeddingFilterInput>>;
};

/** A Mercator location filter, as submitted, resolved to Locations. */
export type WatcherDivisionFilter = {
  __typename?: 'WatcherDivisionFilter';
  /** Location that had to match exactly. */
  eq?: Maybe<Location>;
  /** Locations any of which had to match. */
  in?: Maybe<Array<Location>>;
  /** Location that was excluded. */
  notEq?: Maybe<Location>;
  /** Locations that were excluded. */
  notIn?: Maybe<Array<Location>>;
};

/** An edge in a connection. */
export type WatcherEdge = {
  __typename?: 'WatcherEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Watcher>;
};

/** The connection type for Event. */
export type WatcherEventConnection = {
  __typename?: 'WatcherEventConnection';
  /**
   * Events refused before materialization — a duplicate, or a lead the ICP
   * excluded. Never delivered, and excluded from `pending` so a backlog that
   * cannot drain is not reported.
   */
  discarded: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EventEdge>>>;
  /** Events whose processing raised and has not since succeeded. */
  failed: Scalars['Int']['output'];
  /**
   * Delivered leads carrying at least one attribute the ICP could only match on
   * absence — a fit enrichment could not confirm, counted inside `total`.
   */
  icpUnverified: Scalars['Int']['output'];
  /** When the most recent event was observed upstream. Null when none ever arrived. */
  lastObservedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When an event last finished processing successfully. */
  lastSucceededAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Event>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Kept events not yet processed and not currently failed — the live backlog. */
  pending: Scalars['Int']['output'];
  /** Events that finished processing successfully. */
  succeeded: Scalars['Int']['output'];
  /**
   * Every event ever ingested for this Watcher, discarded ones included — unlike
   * `totalCount`, which counts the slice `state` selected.
   */
  total: Scalars['Int']['output'];
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/**
 * Which slice of a Watcher's event history to list. Anything other than KEPT is
 * operator data and takes a service-wide read scope: a refused event carries the
 * provider's own envelope rather than a lead.
 */
export type WatcherEventStateEnum =
  /** Both, newest first — what a support session reads to tell "nothing arrived" from "everything was refused". */
  | 'ALL'
  /** Events refused before materialization, carrying the reason they never became a lead. */
  | 'DISCARDED'
  /** Events that became leads. The default, and the only slice a customer-facing caller sees. */
  | 'KEPT';

/**
 * Which slices of an event history to list (eq/in/notEq/notIn). Omitted, only KEPT
 * is listed. Any combination reaching DISCARDED is operator data and takes a
 * service-wide read scope.
 */
export type WatcherEventStateFilterInput = {
  /** Exact match. */
  eq?: InputMaybe<WatcherEventStateEnum>;
  /** Match any of these values. */
  in?: InputMaybe<Array<WatcherEventStateEnum>>;
  /** Exclude exact match. */
  notEq?: InputMaybe<WatcherEventStateEnum>;
  /** Exclude any of these values. */
  notIn?: InputMaybe<Array<WatcherEventStateEnum>>;
};

/**
 * Filter criteria for watchers. Each axis is index-backed: a support session
 * narrows by the thing it was given — a subject from a log line, a company from a
 * ticket, a slug from a definition — not by a phrase it half-remembers.
 */
export type WatcherFilterInput = {
  /**
   * Company the watcher belongs to, as the GlobalID hermes addresses one by — the
   * same form `Watcher.companyId` returns, so what is read back is what filters.
   */
  companyId?: InputMaybe<IdFilterInput>;
  /** Slug of the tracked Definition, e.g. 'radar-website'. */
  definitionSlug?: InputMaybe<StringFilterInput>;
  /** Version of the tracked Definition. Pair with definitionSlug to reach one published version. */
  definitionVersion?: InputMaybe<FloatFilterInput>;
  /** Whether the watcher is producing signals. */
  lifecycleState?: InputMaybe<WatcherLifecycleStateFilterInput>;
  /**
   * The subject that created the watcher — an Auth0 subject for a person,
   * `application:<uuid>` for a machine. It is what ownership is enforced on, so it
   * is also what correlates a watcher to a log line.
   */
  ownerSub?: InputMaybe<StringFilterInput>;
};

/**
 * The Ideal Customer Profile a Watcher filters its leads by, returned in the same
 * vocabulary Atlas search uses. This is what the caller submitted, not what each
 * source could enforce: criteria an individual source cannot express are dropped
 * for that source only, and that translation is not reflected here.
 */
export type WatcherIcp = {
  __typename?: 'WatcherIcp';
  /** Person-level criteria. */
  contact?: Maybe<WatcherContactIcp>;
  /** Company-level criteria. */
  organization?: Maybe<WatcherOrganizationIcp>;
};

/**
 * The subscriber's Ideal Customer Profile, expressed in the same vocabulary Atlas
 * search uses so a caller can pass the filters it already built for
 * `searchContacts`. Enforced twice: each Watcher provider translates what it can
 * into whatever its upstream source accepts, so out-of-ICP leads are never
 * streamed — and never billed — and every resolved contact is then re-checked
 * against the full ICP before delivery. Criteria an individual source cannot
 * express are therefore still applied, just later, so the ICP means the same thing
 * whichever provider backs the watcher.
 */
export type WatcherIcpInput = {
  /** Person-level criteria. */
  contact?: InputMaybe<WatcherContactIcpInput>;
  /** Company-level criteria. */
  organization?: InputMaybe<WatcherOrganizationIcpInput>;
};

/**
 * A freshness-first lead cap on a Watcher: at most `maximumLeads` events are
 * surfaced per `period`, counted from `startsAt` and reset at every period boundary.
 */
export type WatcherLeadCap = Node & {
  __typename?: 'WatcherLeadCap';
  /** Timestamp when the cap was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Start of the window currently accumulating; events are counted from here and the usage resets at the next boundary. */
  currentPeriodStartsAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Number of leads already delivered — or qualified and on their way — in the
   * current window. Leads refused before delivery (duplicates, ICP mismatches,
   * undeliverable endpoints) are not counted. The cap drops further leads once
   * this reaches `maximumLeads`.
   */
  currentUsage: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Maximum number of events surfaced per period. */
  maximumLeads: Scalars['Int']['output'];
  /** Length of the accumulation window as an ISO-8601 duration, e.g. P1D or P1W. */
  period: Scalars['ISO8601Duration']['output'];
  /** Anchor at which the first period begins; each window is measured forward from here. */
  startsAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for WatcherLeadCap. */
export type WatcherLeadCapConnection = {
  __typename?: 'WatcherLeadCapConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WatcherLeadCapEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<WatcherLeadCap>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WatcherLeadCapEdge = {
  __typename?: 'WatcherLeadCapEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WatcherLeadCap>;
};

/**
 * Whether a Watcher is currently producing signals. Distinct from
 * provisioningStatus, which describes its upstream resources rather than whether
 * it runs: a fully provisioned Watcher whose webhooks were all paused delivers
 * nothing and still reports PROVISIONED.
 */
export type WatcherLifecycleStateEnum =
  /** Not canceled, and at least one webhook is active — or it has no webhook yet, which is the state right after creation. */
  | 'ACTIVE'
  /** Terminal: canceledAt is set, providers are deprovisioned upstream and no further event is ingested. */
  | 'CANCELED'
  /** Not canceled, but every registered webhook is paused, so nothing is delivered. Reversible with setWebhookActive. */
  | 'PAUSED';

/**
 * Filter on a Watcher's lifecycle state (eq/in/notEq/notIn). PAUSED is the state
 * provisioningStatus cannot express — every webhook paused on an otherwise
 * provisioned watcher — and is the usual answer to "it stopped working".
 */
export type WatcherLifecycleStateFilterInput = {
  /** Exact match. */
  eq?: InputMaybe<WatcherLifecycleStateEnum>;
  /** Match any of these values. */
  in?: InputMaybe<Array<WatcherLifecycleStateEnum>>;
  /** Exclude exact match. */
  notEq?: InputMaybe<WatcherLifecycleStateEnum>;
  /** Exclude any of these values. */
  notIn?: InputMaybe<Array<WatcherLifecycleStateEnum>>;
};

/**
 * Company-level ICP criteria, as submitted. Mirrors `WatcherOrganizationIcpInput`,
 * which in turn mirrors the subset of Atlas's `OrganizationFilterInput` an
 * upstream lead source can enforce.
 */
export type WatcherOrganizationIcp = {
  __typename?: 'WatcherOrganizationIcp';
  /**
   * Employee-count range the organization had to fall in, as `[min, max]`.
   * Flattened from the submitted filter's `overlaps`, the only operator creation
   * accepts — `contains` and `contained_by` describe querying a stored range and
   * are rejected, so there is nothing else to report.
   */
  companySize?: Maybe<Scalars['Range']['output']>;
  /** Mercator locations the organization had to belong to. */
  divisionIds?: Maybe<WatcherDivisionFilter>;
  /** Industry embedding filters, same `match` handling as `WatcherContactIcp.jobTitle`. */
  industry?: Maybe<Array<EmbeddingFilter>>;
};

/**
 * Company-level ICP criteria, mirroring the subset of Atlas's
 * `OrganizationFilterInput` that an upstream lead source can enforce.
 */
export type WatcherOrganizationIcpInput = {
  /**
   * Employee-count range, e.g. `{ overlaps: [0, 100] }` for "fewer than 100
   * employees" or `{ overlaps: [1000] }` for "1000+". Mapped onto the headcount
   * buckets the upstream source accepts. `contains` / `contained_by` describe
   * querying a stored range and have no meaning at an external source, so they are rejected.
   */
  companySize?: InputMaybe<RangeFilterInput>;
  /** Mercator location division IDs the organization must belong to. Resolved to place names before being handed upstream. */
  divisionIds?: InputMaybe<IdFilterInput>;
  /**
   * Filter by organization global id — the lead's employer. Its chief use is
   * excluding the companies whose employees are not leads: the page a watcher
   * tracks, and the subscriber's own. `notEq`/`notIn` are resolved to the company
   * URLs or domains the upstream source excludes on, so those leads are never
   * streamed nor billed, and re-checked at delivery for the sources that carry no
   * exclusion key. `eq`/`in` have no upstream counterpart at all — no source
   * filters on an employer allowlist — so they narrow at delivery time only. Two
   * caveats: a lead whose employer we cannot resolve is refused rather than
   * admitted, as with every other company-level criterion; and only the positive
   * operators follow organization merges, so exclude by the ids Atlas holds today
   * rather than ones merged away.
   */
  id?: InputMaybe<IdFilterInput>;
  /**
   * Industry embedding filters. Each `query` is embedded as a single vector, so
   * keep one string to one semantic neighborhood — listing many sectors in it
   * dilutes the vector and forces a looser match, costing precision. To target
   * several sectors, list them in `queries`: each keeps its own vector, and the
   * entry matches a company in any of them. Entries combine with AND. Upstream
   * sources honour only the *direction* of `match` (`INCLUDED_*` include,
   * `EXCLUDED_*` exclude); the threshold behind it is enforced at delivery time.
   * Note that upstream sources OR every included industry together, so on their
   * side a `queries` list and separate entries are indistinguishable — the AND is
   * enforced at delivery time.
   */
  industry?: InputMaybe<Array<EmbeddingFilterInput>>;
};

/**
 * The identifier a provider's upstream service assigned to this Watcher. Internal
 * plumbing rather than customer-facing data: it is only actionable with that
 * provider's own API credentials, and it discloses which third party backs the
 * signal. Exposed for operational reconciliation and end-to-end testing.
 */
export type WatcherProviderReference = {
  __typename?: 'WatcherProviderReference';
  /** Identifier the upstream service uses for this Watcher — for Rodz, the provisioned Signal's id. */
  externalId: Scalars['String']['output'];
  /** Slug of the definition provider holding the reference, e.g. 'rodz'. */
  providerSlug: Scalars['String']['output'];
};

/**
 * Where one of a Watcher's providers stands: whether it was provisioned upstream,
 * when it last was, and when it next runs. Deliberately carries no external
 * identifier — that one is actionable with the provider's own credentials and
 * stays on providerReferences behind a wider scope.
 */
export type WatcherProviderState = {
  __typename?: 'WatcherProviderState';
  /** False once the row is deprovisioned. A deprovisioned provider ingests nothing, whatever its provisioning state says. */
  active: Scalars['Boolean']['output'];
  /** When the upstream resource was torn down. Null while it lives. */
  deprovisionedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * When this provider is next scheduled to pull. Null for a provider driven by
   * webhooks rather than a schedule, and for one already deprovisioned — so a null
   * here separates "nothing scheduled" from "overdue".
   */
  nextRunAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Slug of the definition provider, e.g. 'rodz'. */
  providerSlug: Scalars['String']['output'];
  /**
   * When the upstream resource was created. Null when provisioning has not
   * succeeded, which is the usual reason a Watcher delivers nothing at all.
   */
  provisionedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** What the last provisioning attempt failed with, as the provider reported it. Null when nothing failed. */
  provisioningError?: Maybe<Scalars['JSON']['output']>;
  /** Whether the upstream resource exists yet. */
  provisioningState: WatcherProvisioningStateEnum;
};

/** The connection type for WatcherProviderState. */
export type WatcherProviderStateConnection = {
  __typename?: 'WatcherProviderStateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WatcherProviderStateEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<WatcherProviderState>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WatcherProviderStateEdge = {
  __typename?: 'WatcherProviderStateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WatcherProviderState>;
};

/**
 * A provider's terminal provisioning failure on a Watcher. Gated behind
 * `signals/watcher:*` alongside providerReferences: the provider slug discloses
 * which third party backs the signal.
 */
export type WatcherProvisioningFailure = {
  __typename?: 'WatcherProvisioningFailure';
  /**
   * Structured, machine-readable failure data — an Inexpressible refusal's
   * attributes, or the provider / status / upstreamCode of an upstream rejection.
   * Never vendor prose.
   */
  details: Scalars['JSON']['output'];
  /** Slug of the definition provider that failed to provision, e.g. 'rodz'. */
  providerSlug: Scalars['String']['output'];
  /**
   * Symbolic failure code. `upstream_unavailable` (retries exhausted against an
   * outage), `upstream_rejected` (the provider refused the request), or an
   * Inexpressible refusal's own reason (e.g. `unresolvable_locations`).
   */
  reason: Scalars['String']['output'];
};

/** Autogenerated return type of WatcherProvisioningResult. */
export type WatcherProvisioningResultPayload = {
  __typename?: 'WatcherProvisioningResultPayload';
  /** Echo of the externalId this event is keyed by. */
  externalId: Scalars['ID']['output'];
  /** The watcher whose provisioning settled. Read `provisioningStatus` and `provisioningFailures` off it for the outcome. */
  watcher: Watcher;
};

/** Where one provider's provisioning stands. */
export type WatcherProvisioningStateEnum =
  /** The last attempt failed; provisioningError says why. */
  | 'FAILED'
  /** The upstream resource has not been created yet. */
  | 'PENDING'
  /** The upstream resource exists. */
  | 'PROVISIONED';

/**
 * Aggregate provisioning state of a Watcher's providers. Only a Watcher created
 * with `createWatcher(async: true)` is ever PENDING — the default synchronous
 * creation provisions before it returns, so it is already settled.
 */
export type WatcherProvisioningStatusEnum =
  /** Terminal: no provider could be provisioned. The Watcher will deliver nothing. */
  | 'FAILED'
  /** Terminal: some providers provisioned, others failed. The Watcher runs on the ones that succeeded. */
  | 'PARTIALLY_FAILED'
  /**
   * At least one provider is still being provisioned upstream (retried across an
   * outage for about a day). Providers that already failed terminally are visible
   * on provisioningFailures meanwhile.
   */
  | 'PENDING'
  /**
   * Every provider's upstream resource is live. Also reported when there is
   * nothing to provision — a definition with no available provider, or a canceled
   * watcher whose rows are all deprovisioned.
   */
  | 'PROVISIONED';

/** Delivery endpoint registered on a Watcher. Secrets are write-only — they are never returned by the API. */
export type WatcherWebhookInput = {
  /**
   * Whether this webhook should receive deliveries. Defaults to true; pass false
   * to register it without delivering events yet (e.g. for a paused or
   * credit-blocked routine), then activate it later via setWebhookActive.
   */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** HMAC-SHA256 secret used to sign deliveries. Store this — it is not returned after creation. */
  secret: Scalars['String']['input'];
  /** URL that receives a POST payload when a signal fires. */
  url: Scalars['String']['input'];
};

/**
 * A delivery endpoint registered on a Watcher, with how it has been answering.
 * This is the delivery side of the pipeline: a Watcher that ingests normally and
 * delivers nothing is diagnosed here, not on providerStates.
 */
export type Webhook = Node & {
  __typename?: 'Webhook';
  /** When the endpoint was registered. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Every attempt against this endpoint, oldest first, with how it has been answering carried on the connection itself. */
  deliveries: WebhookDeliveryConnection;
  /** Host of the URL, which is what a delivery-side outage is usually shared by. Null when the URL does not parse. */
  host?: Maybe<Scalars['String']['output']>;
  /**
   * Identifier of the endpoint, in the raw form `/debug/webhooks/:id` takes. Not a
   * GlobalID: an endpoint is a fragment of its Watcher rather than an
   * independently fetchable record.
   */
  id: Scalars['ID']['output'];
  /** When delivery stopped. Null while the endpoint is active. */
  pausedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Why delivery stopped — set by PauseBrokenWebhook when an endpoint failed too
   * many times in a row, or by the caller through setWebhookActive.
   */
  pausedReason?: Maybe<Scalars['String']['output']>;
  /** Whether delivery is running. */
  state: WebhookStateEnum;
  /** The delivery URL. Secrets are never exposed. */
  url: Scalars['String']['output'];
  /**
   * The Watcher this endpoint delivers for. Selected from the root `webhooks`
   * connection, where a page spans many Watchers and an endpoint is unreadable
   * without the one it belongs to.
   */
  watcher: Watcher;
};


/**
 * A delivery endpoint registered on a Watcher, with how it has been answering.
 * This is the delivery side of the pipeline: a Watcher that ingests normally and
 * delivers nothing is diagnosed here, not on providerStates.
 */
export type WebhookDeliveriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Webhook. */
export type WebhookConnection = {
  __typename?: 'WebhookConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WebhookEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Webhook>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/** The connection type for EventDelivery. */
export type WebhookDeliveryConnection = {
  __typename?: 'WebhookDeliveryConnection';
  /**
   * Whether the consecutive-failure streak has reached the threshold at which
   * PauseBrokenWebhook stops delivering — the difference between "failing" and
   * "about to go quiet".
   */
  autoPauseThresholdMet: Scalars['Boolean']['output'];
  /** Failed attempts since the last success, or every failed attempt when none ever succeeded. */
  consecutiveFailures: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EventDeliveryEdge>>>;
  /** When this webhook was first delivered to. Null when it never was. */
  firstAttemptAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When it was last delivered to, successfully or not. */
  lastAttemptAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * When a lead last arrived. A recent lastAttemptAt with an old lastSucceededAt
   * is an endpoint that is answering, but not with a 2xx.
   */
  lastSucceededAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Distinct leads that reached the endpoint at least once. */
  leadsDelivered: Scalars['Int']['output'];
  /** Distinct leads whose every attempt failed. A lead that failed once and then succeeded on a retry is not counted here. */
  leadsFailed: Scalars['Int']['output'];
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EventDelivery>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Every HTTP attempt ever made, retries included — the same figure as `totalCount`, named for what it counts. */
  totalAttempts: Scalars['Int']['output'];
  /** Total number of items across all pages. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WebhookEdge = {
  __typename?: 'WebhookEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Webhook>;
};

/** Filter criteria for webhooks. */
export type WebhookFilterInput = {
  /**
   * Host of the delivery URL, anchored: `example.com` does not match
   * `hooks.example.com`. Computed from `url`, so it has no column of its own.
   */
  host?: InputMaybe<WebhookHostFilterInput>;
  /** Whether the endpoint is being delivered to. */
  state?: InputMaybe<WebhookStateFilterInput>;
  /** The delivery URL, exactly or by fragment. */
  url?: InputMaybe<WebhookUrlFilterInput>;
  /** Keep only the endpoints of this Watcher, as its GlobalID. */
  watcherId?: InputMaybe<IdFilterInput>;
};

/**
 * Filter on the host of a delivery URL, matched exactly and without its port. A
 * delivery-side outage is usually shared by host rather than by watcher, so this
 * is the axis that separates "one customer's endpoint is down" from "ours stopped
 * sending". Pass `hooks.example.com`, not a URL.
 */
export type WebhookHostFilterInput = {
  /** When true, match only rows where the column is NULL or empty. False or omitted applies no constraint. */
  blank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exact match. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Match any of these values. Maximum 10000 entries. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Exclude exact match. */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** Exclude any of these values. Maximum 10000 entries. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** When true, match only rows where the column is neither NULL nor empty. False or omitted applies no constraint. */
  presence?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Whether an endpoint is being delivered to. */
export type WebhookStateEnum =
  /** Delivery is running. */
  | 'ACTIVE'
  /**
   * Delivery stopped — either requested by the caller, or by PauseBrokenWebhook
   * after too many consecutive failures. Reversible with setWebhookActive.
   */
  | 'PAUSED';

/**
 * Which delivery states to list (eq/in/notEq/notIn). Omitted, every endpoint is
 * listed. Delivery state is a `pausedAt` timestamp rather than a column of states,
 * so the operators resolve to the set of states they reach and then to the model's own scopes.
 */
export type WebhookStateFilterInput = {
  /** Exact match. */
  eq?: InputMaybe<WebhookStateEnum>;
  /** Match any of these values. */
  in?: InputMaybe<Array<WebhookStateEnum>>;
  /** Exclude exact match. */
  notEq?: InputMaybe<WebhookStateEnum>;
  /** Exclude any of these values. */
  notIn?: InputMaybe<Array<WebhookStateEnum>>;
};

/**
 * Filter on a delivery URL. `contains` is what a support request usually carries:
 * a webhook's uuid appears nowhere a human can reach, so what comes in is a piece
 * of the callback — a path segment, a routine action id, a host fragment — and
 * none of those is a whole URL.
 */
export type WebhookUrlFilterInput = {
  /** When true, match only rows where the column is NULL or empty. False or omitted applies no constraint. */
  blank?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Case-insensitive substring of the URL, wildcard characters taken literally.
   * Not anchored: `sortlist.com` matches `max.sortlist.com`; use `host` for the
   * anchored question.
   */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Exact match. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Match any of these values. Maximum 10000 entries. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Exclude exact match. */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** Exclude any of these values. Maximum 10000 entries. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** When true, match only rows where the column is neither NULL nor empty. False or omitted applies no constraint. */
  presence?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Join__ContextArgument = {
  context: Scalars['String']['input'];
  name: Scalars['String']['input'];
  selection: Scalars['join__FieldValue']['input'];
  type: Scalars['String']['input'];
};

export type Join__Graph =
  | 'ATLAS'
  | 'BILLING'
  | 'HERMES'
  | 'MERCATOR'
  | 'OUTREACH'
  | 'SIGNALS';

export type Link__Purpose =
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  | 'EXECUTION'
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  | 'SECURITY';

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null };

export type LogoutUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type LogoutUrlQuery = { __typename?: 'Query', logoutUrl: string };

export type DeviceAuthorizeMutationVariables = Exact<{
  input: DeviceAuthorizeInput;
}>;


export type DeviceAuthorizeMutation = { __typename?: 'Mutation', deviceAuthorize?: { __typename?: 'DeviceCodeResponse', deviceCode: string, expiresIn: number, interval: number, userCode: string, verificationUri: string, verificationUriComplete?: string | null } | null };

export type DeviceTokenMutationVariables = Exact<{
  input: DeviceTokenInput;
}>;


export type DeviceTokenMutation = { __typename?: 'Mutation', deviceToken?: { __typename?: 'TokenResponse', accessToken?: string | null, error?: string | null, expiresIn?: number | null, idToken?: string | null, refreshToken?: string | null, tokenType?: string | null } | null };

export type RefreshTokenMutationVariables = Exact<{
  input: RefreshTokenInput;
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken?: { __typename?: 'TokenResponse', accessToken?: string | null, error?: string | null, expiresIn?: number | null, idToken?: string | null, refreshToken?: string | null, tokenType?: string | null } | null };


export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const LogoutUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LogoutUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logoutUrl"}}]}}]} as unknown as DocumentNode<LogoutUrlQuery, LogoutUrlQueryVariables>;
export const DeviceAuthorizeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeviceAuthorize"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceAuthorizeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceAuthorize"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceCode"}},{"kind":"Field","name":{"kind":"Name","value":"expiresIn"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"userCode"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUri"}},{"kind":"Field","name":{"kind":"Name","value":"verificationUriComplete"}}]}}]}}]} as unknown as DocumentNode<DeviceAuthorizeMutation, DeviceAuthorizeMutationVariables>;
export const DeviceTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeviceToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceTokenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"expiresIn"}},{"kind":"Field","name":{"kind":"Name","value":"idToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"tokenType"}}]}}]}}]} as unknown as DocumentNode<DeviceTokenMutation, DeviceTokenMutationVariables>;
export const RefreshTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefreshToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RefreshTokenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"expiresIn"}},{"kind":"Field","name":{"kind":"Name","value":"idToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"tokenType"}}]}}]}}]} as unknown as DocumentNode<RefreshTokenMutation, RefreshTokenMutationVariables>;